var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotorcycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1932.2 1188.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-120);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193,.cls-194,.cls-195,.cls-196,.cls-197,.cls-198,.cls-199,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208{stroke-width:0px;}.cls-2{fill:url(#linear-gradient-125);}.cls-3{fill:url(#linear-gradient-124);}.cls-4{fill:url(#linear-gradient-126);}.cls-5{fill:url(#linear-gradient-138);}.cls-6{fill:url(#linear-gradient-139);}.cls-7{fill:url(#linear-gradient-134);}.cls-8{fill:url(#linear-gradient-131);}.cls-9{fill:url(#linear-gradient-136);}.cls-10{fill:url(#linear-gradient-132);}.cls-11{fill:url(#linear-gradient-135);}.cls-12{fill:url(#linear-gradient-130);}.cls-13{fill:url(#linear-gradient-133);}.cls-14{fill:url(#linear-gradient-137);}.cls-15{fill:url(#linear-gradient-100);}.cls-16{fill:url(#linear-gradient-101);}.cls-17{fill:url(#linear-gradient-123);}.cls-18{fill:url(#linear-gradient-129);}.cls-19{fill:url(#linear-gradient-121);}.cls-20{fill:url(#linear-gradient-122);}.cls-21{fill:url(#linear-gradient-109);}.cls-22{fill:url(#linear-gradient-108);}.cls-23{fill:url(#linear-gradient-106);}.cls-24{fill:url(#linear-gradient-107);}.cls-25{fill:url(#linear-gradient-102);}.cls-26{fill:url(#linear-gradient-104);}.cls-27{fill:url(#linear-gradient-103);}.cls-28{fill:url(#linear-gradient-105);}.cls-29{fill:url(#linear-gradient-117);}.cls-30{fill:url(#linear-gradient-118);}.cls-31{fill:url(#linear-gradient-111);}.cls-32{fill:url(#linear-gradient-112);}.cls-33{fill:url(#linear-gradient-127);}.cls-34{fill:url(#linear-gradient-128);}.cls-35{fill:url(#linear-gradient-110);}.cls-36{fill:url(#linear-gradient-113);}.cls-37{fill:url(#linear-gradient-114);}.cls-38{fill:url(#linear-gradient-115);}.cls-39{fill:url(#linear-gradient-116);}.cls-40{fill:url(#linear-gradient-119);}.cls-41{fill:url(#linear-gradient-144);}.cls-42{fill:url(#linear-gradient-145);}.cls-43{fill:url(#linear-gradient-149);}.cls-44{fill:url(#linear-gradient-148);}.cls-45{fill:url(#linear-gradient-146);}.cls-46{fill:url(#linear-gradient-143);}.cls-47{fill:url(#linear-gradient-140);}.cls-48{fill:url(#linear-gradient-141);}.cls-49{fill:url(#linear-gradient-147);}.cls-50{fill:url(#linear-gradient-166);}.cls-51{fill:url(#linear-gradient-142);}.cls-52{fill:url(#linear-gradient-164);}.cls-53{fill:url(#linear-gradient-161);}.cls-54{fill:url(#linear-gradient-163);}.cls-55{fill:url(#linear-gradient-158);}.cls-56{fill:url(#linear-gradient-160);}.cls-57{fill:url(#linear-gradient-159);}.cls-58{fill:url(#linear-gradient-162);}.cls-59{fill:url(#linear-gradient-165);}.cls-60{fill:url(#linear-gradient-154);}.cls-61{fill:url(#linear-gradient-152);}.cls-62{fill:url(#linear-gradient-157);}.cls-63{fill:url(#linear-gradient-155);}.cls-64{fill:url(#linear-gradient-151);}.cls-65{fill:url(#linear-gradient-153);}.cls-66{fill:url(#linear-gradient-150);}.cls-67{fill:url(#linear-gradient-156);}.cls-68{fill:#606060;}.cls-69{fill:url(#linear-gradient);}.cls-70{fill:url(#radial-gradient);}.cls-71{fill:url(#radial-gradient-34);}.cls-72{fill:url(#radial-gradient-35);}.cls-73{fill:url(#radial-gradient-24);}.cls-74{fill:url(#radial-gradient-28);}.cls-75{fill:url(#radial-gradient-23);}.cls-76{fill:url(#radial-gradient-29);}.cls-77{fill:url(#radial-gradient-36);}.cls-78{fill:url(#radial-gradient-26);}.cls-79{fill:url(#radial-gradient-27);}.cls-80{fill:url(#radial-gradient-22);}.cls-81{fill:url(#radial-gradient-37);}.cls-82{fill:url(#radial-gradient-32);}.cls-83{fill:url(#radial-gradient-33);}.cls-84{fill:url(#radial-gradient-31);}.cls-85{fill:url(#radial-gradient-38);}.cls-86{fill:url(#radial-gradient-30);}.cls-87{fill:url(#radial-gradient-25);}.cls-88{fill:url(#radial-gradient-20);}.cls-89{fill:url(#radial-gradient-21);}.cls-90{fill:url(#radial-gradient-14);}.cls-91{fill:url(#radial-gradient-13);}.cls-92{fill:url(#radial-gradient-12);}.cls-93{fill:url(#radial-gradient-15);}.cls-94{fill:url(#radial-gradient-16);}.cls-95{fill:url(#radial-gradient-11);}.cls-96{fill:url(#radial-gradient-19);}.cls-97{fill:url(#radial-gradient-18);}.cls-98{fill:url(#radial-gradient-17);}.cls-99{fill:url(#radial-gradient-10);}.cls-100{fill:url(#linear-gradient-38);}.cls-101{fill:url(#linear-gradient-33);}.cls-102{fill:url(#linear-gradient-29);}.cls-103{fill:url(#linear-gradient-32);}.cls-104{fill:url(#linear-gradient-30);}.cls-105{fill:url(#linear-gradient-31);}.cls-106{fill:url(#linear-gradient-36);}.cls-107{fill:url(#linear-gradient-39);}.cls-108{fill:url(#linear-gradient-34);}.cls-109{fill:url(#linear-gradient-37);}.cls-110{fill:url(#linear-gradient-35);}.cls-111{fill:url(#linear-gradient-28);}.cls-112{fill:url(#linear-gradient-25);}.cls-113{fill:url(#linear-gradient-11);}.cls-114{fill:url(#linear-gradient-12);}.cls-115{fill:url(#linear-gradient-13);}.cls-116{fill:url(#linear-gradient-10);}.cls-117{fill:url(#linear-gradient-17);}.cls-118{fill:url(#linear-gradient-16);}.cls-119{fill:url(#linear-gradient-19);}.cls-120{fill:url(#linear-gradient-15);}.cls-121{fill:url(#linear-gradient-23);}.cls-122{fill:url(#linear-gradient-21);}.cls-123{fill:url(#linear-gradient-18);}.cls-124{fill:url(#linear-gradient-14);}.cls-125{fill:url(#linear-gradient-22);}.cls-126{fill:url(#linear-gradient-20);}.cls-127{fill:url(#linear-gradient-27);}.cls-128{fill:url(#linear-gradient-24);}.cls-129{fill:url(#linear-gradient-26);}.cls-130{fill:url(#linear-gradient-45);}.cls-131{fill:url(#linear-gradient-46);}.cls-132{fill:url(#linear-gradient-44);}.cls-133{fill:url(#linear-gradient-48);}.cls-134{fill:url(#linear-gradient-49);}.cls-135{fill:url(#linear-gradient-47);}.cls-136{fill:url(#linear-gradient-42);}.cls-137{fill:url(#linear-gradient-43);}.cls-138{fill:url(#linear-gradient-40);}.cls-139{fill:url(#linear-gradient-41);}.cls-140{fill:url(#linear-gradient-59);}.cls-141{fill:url(#linear-gradient-57);}.cls-142{fill:url(#linear-gradient-58);}.cls-143{fill:url(#linear-gradient-55);}.cls-144{fill:url(#linear-gradient-56);}.cls-145{fill:url(#linear-gradient-53);}.cls-146{fill:url(#linear-gradient-51);}.cls-147{fill:url(#linear-gradient-52);}.cls-148{fill:url(#linear-gradient-50);}.cls-149{fill:url(#linear-gradient-54);}.cls-150{fill:url(#linear-gradient-60);}.cls-151{fill:url(#linear-gradient-61);}.cls-152{fill:url(#linear-gradient-62);}.cls-153{fill:url(#linear-gradient-65);}.cls-154{fill:url(#linear-gradient-79);}.cls-155{fill:url(#linear-gradient-78);}.cls-156{fill:url(#linear-gradient-77);}.cls-157{fill:url(#linear-gradient-75);}.cls-158{fill:url(#linear-gradient-76);}.cls-159{fill:url(#linear-gradient-74);}.cls-160{fill:url(#linear-gradient-67);}.cls-161{fill:url(#linear-gradient-68);}.cls-162{fill:url(#linear-gradient-66);}.cls-163{fill:url(#linear-gradient-63);}.cls-164{fill:url(#linear-gradient-69);}.cls-165{fill:url(#linear-gradient-64);}.cls-166{fill:url(#linear-gradient-71);}.cls-167{fill:url(#linear-gradient-72);}.cls-168{fill:url(#linear-gradient-70);}.cls-169{fill:url(#linear-gradient-73);}.cls-170{fill:url(#linear-gradient-84);}.cls-171{fill:url(#linear-gradient-85);}.cls-172{fill:url(#linear-gradient-82);}.cls-173{fill:url(#linear-gradient-83);}.cls-174{fill:url(#linear-gradient-89);}.cls-175{fill:url(#linear-gradient-88);}.cls-176{fill:url(#linear-gradient-86);}.cls-177{fill:url(#linear-gradient-87);}.cls-178{fill:url(#linear-gradient-80);}.cls-179{fill:url(#linear-gradient-81);}.cls-180{fill:url(#linear-gradient-98);}.cls-181{fill:url(#linear-gradient-91);}.cls-182{fill:url(#linear-gradient-92);}.cls-183{fill:url(#linear-gradient-93);}.cls-184{fill:url(#linear-gradient-90);}.cls-185{fill:url(#linear-gradient-96);}.cls-186{fill:url(#linear-gradient-97);}.cls-187{fill:url(#linear-gradient-94);}.cls-188{fill:url(#linear-gradient-95);}.cls-189{fill:url(#linear-gradient-99);}.cls-190{fill:#000;}.cls-191{fill:url(#radial-gradient-2);}.cls-192{fill:url(#radial-gradient-3);}.cls-193{fill:url(#radial-gradient-4);}.cls-194{fill:url(#radial-gradient-6);}.cls-195{fill:url(#radial-gradient-9);}.cls-196{fill:url(#radial-gradient-8);}.cls-197{fill:url(#radial-gradient-5);}.cls-198{fill:url(#radial-gradient-7);}.cls-199{fill:#8c0000;}.cls-200{fill:url(#linear-gradient-4);}.cls-201{fill:url(#linear-gradient-2);}.cls-202{fill:url(#linear-gradient-3);}.cls-203{fill:url(#linear-gradient-8);}.cls-204{fill:url(#linear-gradient-9);}.cls-205{fill:url(#linear-gradient-7);}.cls-206{fill:url(#linear-gradient-5);}.cls-207{fill:url(#linear-gradient-6);}.cls-208{fill:#fff;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 2132.84,
    cy: 964.63,
    fx: 2132.84,
    fy: 964.63,
    r: 1069.29,
    gradientTransform: "translate(-633.53 -129.38) scale(.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 815.72,
    y1: 711.98,
    x2: 1340.14,
    y2: 711.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b003f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0b0041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0d0049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#100056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#14006a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1a0082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2100a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2900c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2d00d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2b00c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2700a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#240080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#210065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1f004f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#1e003e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1c0032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1c002b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c002a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 425.48,
    y1: 730.08,
    x2: 345.83,
    y2: 868.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 991.62,
    y1: 268.65,
    x2: 1033.56,
    y2: 506.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ff0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ff0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ff2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ff6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ff8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ffb1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ffe0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fff5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ffc7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ff5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ff3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ff2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ff1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ff0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ff0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1207.67,
    y1: 294.11,
    x2: 1245.31,
    y2: 507.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ff0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#ff0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ff1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ff2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ff8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ffb1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffe0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ffc7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ff5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ff2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ff1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ff0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 671.74,
    y1: 396.83,
    x2: 671.74,
    y2: 546.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 3068.22,
    cy: 1391.23,
    fx: 3068.22,
    fy: 1391.23,
    r: 317.93,
    gradientTransform: "translate(-633.53 -129.38) scale(.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 904.67,
    y1: 757.96,
    x2: 1080.78,
    y2: 757.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1012.52,
    y1: 432.93,
    x2: 1031.39,
    y2: 539.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ff2727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ff7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#ffafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ffdada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fff5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ffc7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#ff5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ff3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ff1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ff0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ff0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 1260.84,
    cy: 1397.92,
    fx: 1260.84,
    fy: 1397.92,
    r: 313.22,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 2960.77,
    cy: 1477.91,
    fx: 2960.77,
    fy: 1477.91,
    r: 268.08,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 510.34,
    y1: 824.48,
    x2: 762.4,
    y2: 824.48,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 711.49,
    y1: 984.51,
    x2: 1145.02,
    y2: 984.51,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 413.91,
    y1: 503.16,
    x2: 498.26,
    y2: 418.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ff0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ff0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ff1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ff2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ff6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ff8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ffb1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ffe0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ffc7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ff3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ff2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ff1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ff0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ff0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 208.23,
    y1: 919.48,
    x2: 420.8,
    y2: 919.48,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 3067.31,
    cy: 1153.04,
    fx: 3067.31,
    fy: 1153.04,
    r: 144.27,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 730.55,
    y1: 531.08,
    x2: 691.8,
    y2: 598.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 887.31,
    y1: 913.06,
    x2: 989.9,
    y2: 853.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#cacaca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 132.97,
    y1: 928.69,
    x2: 505.28,
    y2: 928.69,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1205.29,
    y1: 628.98,
    x2: 1310.68,
    y2: 689.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 557.76,
    y1: 913.7,
    x2: 725.59,
    y2: 913.7,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 973.25,
    y1: 882.72,
    x2: 1107.78,
    y2: 882.72,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 1094.92,
    cy: 777.15,
    fx: 1094.92,
    fy: 777.15,
    r: 134.68,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 2867.87,
    cy: 1134.07,
    fx: 2867.87,
    fy: 1134.07,
    r: 84.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1470.06,
    y1: 912.18,
    x2: 1848.63,
    y2: 912.18,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1314.17,
    y1: 434.08,
    x2: 1432.46,
    y2: 434.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1167.36,
    y1: 906.62,
    x2: 1330.63,
    y2: 906.62,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 204.03,
    y1: 392.88,
    x2: 375.35,
    y2: 392.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 113.65,
    y1: 927.42,
    x2: 477.56,
    y2: 927.42,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 1534.15,
    cy: 1570.44,
    fx: 1534.15,
    fy: 1570.44,
    r: 123.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1421.99,
    y1: 425.26,
    x2: 1466.42,
    y2: 407.31,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 346.05,
    y1: 340.15,
    x2: 384.72,
    y2: 273.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1126.28,
    y1: 734.4,
    x2: 1221.78,
    y2: 789.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 586.02,
    y1: 819.8,
    x2: 504.4,
    y2: 961.17,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1510.1,
    y1: 617.71,
    x2: 1554.42,
    y2: 599.8,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 363.21,
    y1: 420.28,
    x2: 437.46,
    y2: 346.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#ff0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ff0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ff1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ff2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ff6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ff8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ffb1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ffe0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ffc7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ff5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ff3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ff2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ff0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ff0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 537.1,
    y1: 786.04,
    x2: 652.1,
    y2: 719.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1512.97,
    y1: 914.22,
    x2: 1863.74,
    y2: 914.22,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1058.81,
    y1: 842.48,
    x2: 1149.92,
    y2: 842.48,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 2743.46,
    cy: 1183.72,
    fx: 2743.46,
    fy: 1183.72,
    r: 72.16,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1443.62,
    y1: 327.12,
    x2: 1564.66,
    y2: 327.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ff0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ff0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ff1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ff2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ff6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ff8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ffb1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ffe0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ffc7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ff3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ff2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ff1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ff0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ff0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 1314.61,
    cy: 1049.1,
    fx: 1314.61,
    fy: 1049.1,
    r: 79.75,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 569.38,
    y1: 522.08,
    x2: 829.94,
    y2: 522.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b003f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0c003d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#120036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1b002a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c002a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 1313.56,
    cy: 1708.44,
    fx: 1313.56,
    fy: 1708.44,
    r: 89.72,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 671.15,
    y1: 591.43,
    x2: 660.62,
    y2: 609.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 1124.03,
    cy: 1090.04,
    fx: 1124.03,
    fy: 1090.04,
    r: 102.21,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1580.5,
    y1: 932.41,
    x2: 1758.02,
    y2: 932.41,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1525.4,
    y1: 404.53,
    x2: 1623.51,
    y2: 404.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ffff08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ffff1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ffff43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ffff76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ffffb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 939.61,
    y1: 991.1,
    x2: 1144.45,
    y2: 991.1,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 268.35,
    y1: 653.07,
    x2: 193.94,
    y2: 781.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#d4d2d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e0dbe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f1e7f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fff2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#eee3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d8d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#c7c3c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#bbbabb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1303.96,
    y1: 49.89,
    x2: 1356.75,
    y2: 49.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1012.14,
    y1: 578.66,
    x2: 1123.56,
    y2: 514.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "blue"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "blue"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "blue"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1176.5,
    y1: 571.21,
    x2: 1370.22,
    y2: 571.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1341.61,
    y1: 666.49,
    x2: 1426.63,
    y2: 666.49,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 955.47,
    cy: 1260.46,
    fx: 955.47,
    fy: 1260.46,
    r: 94.09,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 1099.13,
    cy: 1670.91,
    fx: 1099.13,
    fy: 1670.91,
    r: 89.39,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1546.32,
    y1: 438.03,
    x2: 1614.97,
    y2: 438.03,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 3314.75,
    cy: 1194.33,
    fx: 3314.75,
    fy: 1194.33,
    r: 87.16,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 958.9,
    cy: 1488.81,
    fx: 958.9,
    fy: 1488.81,
    r: 87.7,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 480.83,
    y1: 398.09,
    x2: 517.78,
    y2: 334.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b003f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0b0041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0d0049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#100056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#14006a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#1a0082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#2100a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2900c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2d00d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#2b00c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2700a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#240080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#210065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1f004f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1e003e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1c0032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1c002b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c002a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1171.19,
    y1: 905.31,
    x2: 1344.36,
    y2: 805.33,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1597.32,
    y1: 786.53,
    x2: 1626.27,
    y2: 774.83,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 3300.98,
    cy: 1607.12,
    fx: 3300.98,
    fy: 1607.12,
    r: 86.59,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 694.96,
    y1: 788.85,
    x2: 770.71,
    y2: 788.85,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1632.56,
    y1: 871.4,
    x2: 1667.58,
    y2: 857.25,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 3164.91,
    cy: 1072.72,
    fx: 3164.91,
    fy: 1072.72,
    r: 70.42,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 3393.64,
    cy: 1402.03,
    fx: 3393.64,
    fy: 1402.03,
    r: 86.69,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1476.49,
    y1: 602.03,
    x2: 1501.42,
    y2: 591.96,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1421.24,
    y1: 595.39,
    x2: 1457.06,
    y2: 595.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 1338.95,
    cy: 1098.31,
    fx: 1338.95,
    fy: 1098.31,
    r: 67.86,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 959.35,
    y1: 526.04,
    x2: 1190.93,
    y2: 526.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1442.11,
    y1: 307.44,
    x2: 1507.62,
    y2: 487.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#ff0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ff0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ff1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ff2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ff6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ff8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ffb1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ffe0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#ffc7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ff3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ff2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ff1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ff0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ff0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 562.65,
    y1: 762.81,
    x2: 677.89,
    y2: 696.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 3088.47,
    cy: 1414.71,
    fx: 3088.47,
    fy: 1414.71,
    r: 251.58,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 910.37,
    cy: 940.07,
    fx: 910.37,
    fy: 940.07,
    r: 50.86,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1147.06,
    y1: 623.67,
    x2: 1223.46,
    y2: 623.67,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 2819.82,
    cy: 865.64,
    fx: 2819.82,
    fy: 865.64,
    r: 38.72,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 868.22,
    y1: 992.61,
    x2: 940.04,
    y2: 992.61,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 285.99,
    y1: 912.3,
    x2: 334.85,
    y2: 912.3,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 755.87,
    y1: 737.48,
    x2: 810.02,
    y2: 737.48,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 846.82,
    y1: 571.6,
    x2: 915.06,
    y2: 571.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b003f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0c003c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#130034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c002a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1559.93,
    y1: 840.91,
    x2: 1582.68,
    y2: 815.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 505.32,
    y1: 724.45,
    x2: 564.22,
    y2: 690.44,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 960.67,
    cy: 928.56,
    fx: 960.67,
    fy: 928.56,
    r: 38.11,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1602.23,
    y1: 899.09,
    x2: 1629.16,
    y2: 867,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 361.73,
    y1: 906.32,
    x2: 413.04,
    y2: 906.32,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1344.2,
    y1: 300.91,
    x2: 1390.61,
    y2: 300.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 442.28,
    y1: 626.17,
    x2: 455.7,
    y2: 602.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 439.32,
    y1: 713.86,
    x2: 476.13,
    y2: 713.86,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1252.67,
    y1: 138.26,
    x2: 1293.96,
    y2: 138.26,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 775.64,
    y1: 811.16,
    x2: 827.17,
    y2: 811.16,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1088.98,
    y1: 690.08,
    x2: 1138,
    y2: 690.08,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1318.25,
    y1: 525.77,
    x2: 1336.83,
    y2: 557.95,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 1369.97,
    y1: 523.14,
    x2: 1399.28,
    y2: 523.14,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 1128.5,
    cy: 612.43,
    fx: 1128.5,
    fy: 612.43,
    r: 28.82,
    gradientTransform: "translate(-633.53 -129.38) scale(.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf0005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#bf0104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c10804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c41404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#c82504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#cd3b03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d45603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#dc7702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e69c01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f1c701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fcf500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fef501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fac708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f69c0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f37714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f05619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ee3b1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ec2521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ea1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e90825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#e90126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e90027"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 2953.03,
    cy: 1124.5,
    fx: 2953.03,
    fy: 1124.5,
    r: 29.05,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 283.53,
    y1: 872.38,
    x2: 353.24,
    y2: 872.38,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1244.74,
    y1: 917.95,
    x2: 1296.26,
    y2: 917.95,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1513.78,
    y1: 458.01,
    x2: 1537.07,
    y2: 444.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ff0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ff0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#ff1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ff2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ff8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ffb1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ffe0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ffc7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ff5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ff3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ff2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ff1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ff0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ff0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 767.51,
    y1: 772.67,
    x2: 818.28,
    y2: 772.67,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 564.64,
    y1: 698.12,
    x2: 585.37,
    y2: 677.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 446.98,
    y1: 387.08,
    x2: 486.4,
    y2: 318.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b003f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#0b0041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0d0049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#100056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#14006a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1a0082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2100a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2900c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2d00d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2b00c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2700a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#240080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#210065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1f004f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1e003e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1c0032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1c002b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c002a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 1395.97,
    y1: 518.32,
    x2: 1420.78,
    y2: 518.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1477.35,
    y1: 362.49,
    x2: 1520.29,
    y2: 337.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ff0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ff0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ff1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ff2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ff6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ff8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ffb1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ffe0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ffc7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ff5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#ff3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ff1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ff0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ff0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 1312.24,
    y1: 618.81,
    x2: 1337.52,
    y2: 618.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 1329.07,
    y1: 629.02,
    x2: 1357.47,
    y2: 629.02,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1527.48,
    y1: 441.27,
    x2: 1564.05,
    y2: 441.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 481.21,
    y1: 745.24,
    x2: 513.68,
    y2: 745.24,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 742.7,
    y1: 921.48,
    x2: 836.73,
    y2: 921.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 1019.1,
    y1: 968.59,
    x2: 1076.97,
    y2: 968.59,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 1162.41,
    y1: 639.98,
    x2: 1209.82,
    y2: 639.98,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 1132.7,
    y1: 953,
    x2: 1196.82,
    y2: 953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 1052.98,
    y1: 697.08,
    x2: 1095.19,
    y2: 697.08,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 895.43,
    cy: 1024.78,
    fx: 895.43,
    fy: 1024.78,
    r: 37.62,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 481.15,
    y1: 687.93,
    x2: 515.52,
    y2: 668.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 873.44,
    y1: 944.08,
    x2: 906.39,
    y2: 944.08,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 758.4,
    y1: 843.91,
    x2: 804.57,
    y2: 843.91,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 1486.15,
    y1: 213.16,
    x2: 1458.25,
    y2: 261.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 1124.9,
    y1: 894.04,
    x2: 1166.75,
    y2: 894.04,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 754.83,
    y1: 882.42,
    x2: 827.19,
    y2: 882.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 1385.55,
    y1: 283.99,
    x2: 1405.43,
    y2: 274.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1180.42,
    y1: 687.67,
    x2: 1224.18,
    y2: 763.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 1007.26,
    y1: 654.55,
    x2: 1040.77,
    y2: 654.55,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 1504.52,
    y1: 221.66,
    x2: 1478.97,
    y2: 265.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b003f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0b0041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#0d0049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#100056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#14006a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1a0082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#2100a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2900c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2d00d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2b00c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2700a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#240080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#210065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#1f004f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1e003e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1c0032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1c002b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c002a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1537.3,
    y1: 880.39,
    x2: 1564.46,
    y2: 880.39,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1523.67,
    y1: 921.13,
    x2: 1550.93,
    y2: 921.13,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1274.38,
    y1: 278.26,
    x2: 1300.83,
    y2: 278.26,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1449.52,
    y1: 316.86,
    x2: 1477.09,
    y2: 392.6,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 1356.64,
    y1: 529.82,
    x2: 1375.06,
    y2: 529.82,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 1170.46,
    y1: 913.16,
    x2: 1207.08,
    y2: 913.16,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 235.27,
    y1: 331.89,
    x2: 313.79,
    y2: 331.89,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 790.96,
    y1: 693.04,
    x2: 822.55,
    y2: 693.04,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 896.88,
    cy: 825.34,
    fx: 896.88,
    fy: 825.34,
    r: 17.51,
    xlinkHref: "#radial-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 834.38,
    y1: 970.68,
    x2: 869.64,
    y2: 970.68,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1100.63,
    y1: 754.62,
    x2: 1128.46,
    y2: 754.62,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 892.34,
    y1: 731.47,
    x2: 911.16,
    y2: 731.47,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 783.91,
    y1: 881.59,
    x2: 817.06,
    y2: 881.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 1182.02,
    y1: 819.26,
    x2: 1207.16,
    y2: 819.26,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 1267.69,
    y1: 748.58,
    x2: 1295.91,
    y2: 748.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 1348.2,
    y1: 271.62,
    x2: 1369.35,
    y2: 271.62,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 1479.93,
    y1: 373.65,
    x2: 1495.73,
    y2: 364.53,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 525.01,
    y1: 669.57,
    x2: 545.26,
    y2: 649.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 1108.8,
    y1: 936.47,
    x2: 1134.21,
    y2: 936.47,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 1158.44,
    y1: 719.89,
    x2: 1258.18,
    y2: 719.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 498.11,
    y1: 651.52,
    x2: 516.85,
    y2: 632.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 1411.99,
    cy: 1041.38,
    fx: 1411.99,
    fy: 1041.38,
    r: 29.01,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 1660.39,
    y1: 916.95,
    x2: 1696.96,
    y2: 916.95,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 2581.54,
    cy: 1343.68,
    fx: 2581.54,
    fy: 1343.68,
    r: 35.22,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1442.43,
    y1: 496.43,
    x2: 1453.48,
    y2: 491.96,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 1080.72,
    y1: 787.47,
    x2: 1111.86,
    y2: 787.47,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 1279.74,
    y1: 719.48,
    x2: 1311.14,
    y2: 719.48,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 2825.93,
    cy: 1216.5,
    fx: 2825.93,
    fy: 1216.5,
    r: 16.37,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 1060.86,
    y1: 662,
    x2: 1105.8,
    y2: 662,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 1097.07,
    y1: 969.92,
    x2: 1164.83,
    y2: 969.92,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 1167.66,
    y1: 710.8,
    x2: 1258.28,
    y2: 710.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 2942.84,
    cy: 1101.25,
    fx: 2942.84,
    fy: 1101.25,
    r: 20.63,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 517.23,
    y1: 370.01,
    x2: 536.77,
    y2: 370.01,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 339.66,
    y1: 918.68,
    x2: 359.37,
    y2: 918.68,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 1150.79,
    y1: 1028.42,
    x2: 1161.66,
    y2: 1028.42,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 1114.21,
    y1: 965.4,
    x2: 1147.3,
    y2: 965.4,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 2856.27,
    cy: 719.77,
    fx: 2856.27,
    fy: 719.77,
    r: 16.37,
    gradientTransform: "translate(-633.53 -129.38) scale(.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 786.36,
    y1: 881.99,
    x2: 827.76,
    y2: 881.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 1424.14,
    y1: 297.77,
    x2: 1447.57,
    y2: 297.77,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 1084.58,
    y1: 745.55,
    x2: 1099.84,
    y2: 745.55,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 1167.73,
    y1: 874.91,
    x2: 1184.41,
    y2: 874.91,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 1260.9,
    y1: 985.1,
    x2: 1302.54,
    y2: 985.1,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 1572.72,
    y1: 496.85,
    x2: 1588.31,
    y2: 496.85,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 841.58,
    y1: 600.16,
    x2: 861.25,
    y2: 600.16,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 1554.79,
    y1: 468.01,
    x2: 1577.47,
    y2: 468.01,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 1262.04,
    y1: 551.94,
    x2: 1287.85,
    y2: 551.94,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 757.99,
    y1: 933.27,
    x2: 809.71,
    y2: 933.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 337.65,
    y1: 893.04,
    x2: 357.64,
    y2: 893.04,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 1335.4,
    y1: 583.76,
    x2: 1355.95,
    y2: 583.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 1312,
    y1: 704.5,
    x2: 1334.67,
    y2: 704.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 1354.15,
    y1: 224.78,
    x2: 1373.88,
    y2: 219.49,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 1074.79,
    y1: 969.12,
    x2: 1097.28,
    y2: 969.12,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 1121.46,
    y1: 924.68,
    x2: 1169.68,
    y2: 924.68,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 922.17,
    y1: 557.77,
    x2: 954.66,
    y2: 557.77,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 271.64,
    y1: 909.71,
    x2: 281.08,
    y2: 909.71,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 973.11,
    y1: 645.58,
    x2: 1010.29,
    y2: 645.58,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 1320.82,
    y1: 271.67,
    x2: 1341.79,
    y2: 271.67,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 1371.43,
    y1: 570.26,
    x2: 1386.54,
    y2: 570.26,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 807.58,
    y1: 662.34,
    x2: 829.09,
    y2: 662.34,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 256.48,
    y1: 331.74,
    x2: 320.44,
    y2: 331.74,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 1536.04,
    y1: 259.85,
    x2: 1520.59,
    y2: 286.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 1561.41,
    y1: 261.31,
    x2: 1539.38,
    y2: 299.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 1502.88,
    y1: 224.32,
    x2: 1522.51,
    y2: 243.95,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 1503.31,
    y1: 218.43,
    x2: 1554.48,
    y2: 247.97,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 1333.39,
    y1: 313.74,
    x2: 1355.54,
    y2: 313.74,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 1268.3,
    y1: 160.87,
    x2: 1286.47,
    y2: 160.87,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 772.2,
    y1: 916,
    x2: 827.56,
    y2: 916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 1015.83,
    cy: 1498.3,
    fx: 1015.83,
    fy: 1498.3,
    r: 30.32,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 1244.33,
    y1: 136.58,
    x2: 1249.74,
    y2: 136.58,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 751.69,
    y1: 716.82,
    x2: 795.94,
    y2: 716.82,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 727.22,
    y1: 916.25,
    x2: 758.14,
    y2: 916.25,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 1349.3,
    cy: 1645.78,
    fx: 1349.3,
    fy: 1645.78,
    r: 18.93,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 3140.48,
    cy: 1128.14,
    fx: 3140.48,
    fy: 1128.14,
    r: 21.82,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 2794.25,
    cy: 1407.82,
    fx: 2794.25,
    fy: 1407.82,
    r: 20.88,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 1226.81,
    cy: 1656.32,
    fx: 1226.81,
    fy: 1656.32,
    r: 20.03,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 1044.88,
    y1: 1008.66,
    x2: 1084.75,
    y2: 1008.66,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 1090.72,
    y1: 844.75,
    x2: 1119.69,
    y2: 844.75,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 1371.44,
    y1: 648.82,
    x2: 1405.54,
    y2: 648.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 1354.77,
    y1: 740.02,
    x2: 1371.62,
    y2: 740.02,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 1669.41,
    y1: 917.4,
    x2: 1686.33,
    y2: 917.4,
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M432.26,638.43c-.01-6.96-2.51-12.18-6.28-16.09-7.56-7.85-15.96-14.88-23.86-22.41-2.01-1.91-5.32-5.09-4.8-6.5,1.39-3.81,5.2-1.46,7.96-.96,27.4,4.88,54.22,11.82,79.62,23.48,6.35,2.92,11.48,1.62,16.56-3.03,13.78-12.58,27.94-24.74,41.63-37.4,2.93-2.71,5.03-6.65,6.61-10.4,1.96-4.66,2.97-9.72,4.61-15.39-5-4.18-10.84-8.06-17.69-9.59-42.54-9.46-81.75-27.27-119.78-47.86-25.01-13.55-49.69-27.73-74.36-41.89-5.99-3.44-11.98-4.87-18.72-3.75-46.92,7.81-93.88,15.39-140.75,23.51-15.87,2.75-30.16,9.58-42.24,20.58-1.68,1.53-3.64,2.77-5.81,4.4.8.86,1.25,1.79,1.95,2.04,5.27,1.84,6.66,5.74,5.19,10.59-1.33,4.38-.13,7.44,2.93,10.66,4.86,5.12,4.88,8.12-.7,12.07-5.43,3.85-11.37,7.51-17.64,9.49-6.66,2.1-11.57,5.38-15.5,11-14.99,21.4-30.19,42.66-45.27,63.99-3.92,5.55-7.78,10.85-14.68,13.46-2.66,1-4.71,4.36-6.43,7.03-8.3,12.96-16.35,26.08-24.57,39.1-1.24,1.96-2.74,3.79-4.33,5.48-3.3,3.5-7.16,3.94-11.46,1.81-4.42-2.19-5.16-5.97-3.96-10.07,1.96-6.71,4.72-13.18,6.57-19.91,2.84-10.32,5.49-20.71,7.7-31.18,4.04-19.09,12.04-36.74,19.3-54.67,3.77-9.29,7.49-18.61,10.97-28.01,2.1-5.69,1.28-6.11-4.16-8.92-4.64-2.4-8.85-5.75-12.93-9.08-3.24-2.64-4.42-5.91-3.13-10.54.85-3.06-.42-6.83-1.19-10.18-.73-3.16-2.13-6.16-3.11-9.27-1.47-4.7.19-8.31,4.35-10.65,21.92-12.38,43.58-25.29,65.93-36.85,19.38-10.02,40.61-15.47,62.02-18.91,34.3-5.51,68.81-9.66,103.23-14.44,2.66-.37,5.26-1.12,7.89-1.7.14-.52.29-1.05.43-1.57-1.75-1.23-3.42-2.62-5.28-3.68-19.05-10.84-38.05-21.78-57.27-32.32-6.17-3.38-9.34-7.21-8.89-14.83.33-5.58-1.97-11.34-3.26-16.99-1.14-4.98-3.1-9.85-3.65-14.88-1.44-13.19,4.99-23.76,17.1-29.19,1.7-.76,3.52-1.26,5.2-2.07,4.23-2.05,4.74-3.73,2.4-7.6-.6-.99-1.69-1.76-2.05-2.81-.55-1.62-1.22-3.56-.75-5.01.26-.8,2.71-1.23,4.19-1.26,8.17-.19,15.7,2.11,22.5,6.54,5.39,3.51,10.69,4.36,17.18,2.72,20.79-5.25,41.75-3.77,62.47.52,36.99,7.67,73.86,15.91,110.82,23.7,15.06,3.17,30.21,5.92,45.37,8.56,3.11.54,6.5.11,9.67-.41,8.97-1.48,17.01.03,24.48,5.54,3.49,2.57,7.83,4.01,11.82,5.87,11.99,5.57,21.8,13.35,23.31,27.39.62,5.79-.82,11.98-2.28,17.75-1.18,4.68-3.93,8.95-5.71,13.5-2.26,5.76-1.27,8.07,4.62,10.07,4.84,1.65,9.83,2.96,14.84,4.05,31.65,6.92,63.25,14.11,95.01,20.48,29.56,5.93,59.63,8.08,89.69,9.63,22.59,1.16,45.22,1.73,67.82,2.66,8.04.33,16.06.97,25.23,1.54.15-.33,1.31-1.88,1.55-3.56,2.95-20.69,13.64-37.45,26.66-53.05,22.05-26.43,46.56-50.37,73.68-71.54,12.5-9.75,25.75-18.52,38.42-28.06,23.35-17.59,49.85-21.91,78.19-19.63,47.74,3.84,93.97,14.21,138.89,30.78,3.96,1.46,8.65,1.32,12.99,1.26,3.93-.05,7.84-1.09,11.78-1.56,10.89-1.3,20.92,1.11,29.8,7.57,28.11,20.44,56.16,40.97,84.23,61.47.94.69,1.84,1.43,2.75,2.17,9.16,7.44,9.16,9.02.96,17.46-2.45,2.52-4.3,5.61-6.77,8.89,2.02.66,2.8,1.21,3.26,1.02,11.59-4.9,23.25-9.65,34.66-14.93,8.12-3.76,8.84-8.31,2.06-14.29-6.08-5.36-9.52-11.79-11.6-19.44-3.43-12.59-9.9-23.56-18.76-33.18-6.21-6.74-6.11-7.19-1.65-15.63,1.83-3.46.67-5.34-4.07-5.45-10.87-.25-21.42.85-30.48,7.96-7.6,5.97-15.88,6.21-24.27,1.79-5.69-3-7.45-6.93-6.55-13.34,1.26-8.94,7.15-15,16.24-16.56,6.51-1.12,11.96-4.19,15.9-9.37,3.94-5.19,7.39-10.75,10.92-16.23,2.21-3.43,1.99-6.99.22-10.64-4.66-9.65-9.16-19.38-13.82-29.04-1.82-3.78-3.78-7.5-5.84-11.15-5.83-10.32-14.48-15.41-26.56-14.42-3.7.3-7.47.08-11.18-.28-6.42-.62-9.54-3.08-10.37-9.39-2.18-16.47-3.01-33.03-.19-49.51,1.48-8.68,6.17-12.76,15.01-12.6,12.03.22,23.61,2.89,33.86,9.62,6.32,4.15,9.98,10.12,8.94,17.77-1.56,11.52-3.32,23.06-5.94,34.37-1.21,5.21-1.26,9.38,1.79,13.81,5.4,7.86,10.4,16.03,19.8,22.12.54-1.02,1.1-2.02,1.59-3.05,2.39-5,6.62-6.67,11.87-7.25,12.98-1.41,12.71-1.69,10.13-14.11-2.7-13-4.31-26.22-6.76-39.28-1.2-6.39-2.82-12.77-5-18.9-3.71-10.46-10.29-18.86-20.4-23.89-5.67-2.82-8.48-7.09-8.5-13.28-.09-20.74-.18-41.49-.14-62.23,0-2.77.64-5.57,1.24-8.29,1.65-7.5,4.97-10.83,12.61-10.22,10.87.86,21.92,1.84,32.39,4.65,13.93,3.73,20.04,14.1,17.66,28.33-1.41,8.46-4.28,16.68-6.62,24.97-2.09,7.4-4.02,14.87-6.62,22.09-2.27,6.29-5.57,12.21-8.03,18.44-1.49,3.77-3.94,8.29-3.03,11.68,3.79,14.14,8.37,28.09,13.39,41.85,1.3,3.57,5.43,6.03,7.94,9.26,1.6,2.06,3.22,4.45,3.72,6.92.74,3.61.42,7.43.69,11.15.38,5.29,3.02,8.65,8.43,9.63,3.67.66,7.31,1.49,10.96,2.26,9.5,2,10.94,4.19,8.83,13.49-.41,1.82-1.02,3.6-1.32,5.44-.94,5.79.96,8.58,6.77,8.89,12.73.69,25.49,3.46,38.15-1.2,4.09-1.51,7.62,1,8.71,4.83,1.13,3.99-.51,6.66-5.15,8.34-7.21,2.62-7.37,2.67-5.41,9.65,1.17,4.17-.4,6.35-4.27,7.09-2.27.44-4.66.19-6.96.53-3.43.51-7.07.68-10.18,2.02-6.91,2.97-7.88,6.87-3.88,13.18,2.75,4.33,5.58,8.62,8.46,12.86,4.51,6.64,17.71,10.69,25.05,7.85,2.91-1.13,3-3.26,2.28-5.7-1.25-4.25-2.48-8.51-3.91-12.7-1.24-3.62-.26-6.11,2.76-8.49,2.45-1.94,4.66-4.43,6.33-7.08,6.86-10.84,13.63-21.73,20.12-32.79,6.93-11.8,18.92-16.16,30.42-21.16,4.27-1.85,7.74,1.31,10.48,4.08,9.5,9.61,19.25,19.05,27.99,29.33,17.72,20.83,29.99,44.86,40.04,70.19,3.33,8.38,8.01,16.24,12.38,24.16,2.93,5.3,6.8,10.09,9.51,15.48,1.95,3.86,3.64,8.31,3.72,12.53.11,5.81,1.66,10.91,3.86,16.11,10.15,23.94,17.67,48.57,20.77,74.54,2.41,20.18-.76,38.97-10.69,56.71-2.24,4-5.2,6.35-9.62,7.27-7.3,1.51-14.55,3.26-21.84,4.86-8.92,1.95-17.01-.64-21.59-8.05-7.69-12.42-17.61-17.42-32.13-15.43-6.05.83-12.48-1.2-18.75-1.77-2.45-.23-4.93-.04-7.96-.04,1.28,6.73,7.87,6.38,10.48,10.19,2.71,3.96,5.27,8.02,8.35,12.74,2.02-1.43,4.05-2.8,6.01-4.26,5.42-4.03,9.87-4.43,14.06-1.2,4.2,3.24,5.89,8.25,2.89,13.8-3.05,5.64-7.19,10.83-11.56,15.56-6.06,6.55-6.66,7.68-2.88,15.91,10.31,22.47,20.64,44.93,31,67.37,3.59,7.78,5.43,8.65,13.61,6.52,66.5-17.33,131.3-11.79,194.51,14.55,1.84.77,3.12,2.88,4.67,4.36-1.65,1.07-3.17,2.67-4.97,3.11-6.11,1.51-12.32,2.59-18.48,3.91-.82.18-1.55.8-3.4,1.78,2.93,1.34,4.94,2.32,6.99,3.19,45.16,19.25,84.58,46.31,115.49,84.92,26.25,32.8,43.46,70.01,53.35,110.67,17.92,73.69,5.92,142.53-34.02,206.72-38.1,61.23-92.06,101.61-161.61,120.06-61.41,16.29-121.73,11.13-179.91-14.59-80.49-35.57-131.32-97.1-155.62-180.95-14.21-49.03-11.78-98.25,1.04-147.25.76-2.9,1.53-5.79,2.46-9.32-2.13,0-3.67-.24-5.11.05-3.2.64-6.31,1.7-9.51,2.29-6.39,1.17-8.18-.94-6.04-7.26,1.57-4.64,3.45-9.16,5.21-13.74,12.99-33.75,29.21-65.63,53.8-92.64,4.67-5.13,5.16-11.21,4.35-17.7-2.67-21.29-5.27-42.6-7.87-63.9-.59-4.86-1.05-9.74-1.69-14.6-.19-1.47-.81-2.89-1.71-5.93-1.35,2.79-2.2,4.04-2.59,5.43-12.19,44.29-24.32,88.6-36.51,132.9-1.67,6.07-3.57,12.07-5.38,18.1-2.62,8.76-6.82,11.29-15.74,9.15-15.65-3.75-31.25-7.68-46.9-11.42-9.95-2.38-12.25-.25-13.06,10.08-.61,7.87-1.3,15.91-3.44,23.46-6.07,21.51-4.28,42.87-1.02,64.51,3.59,23.79,11.31,46.13,21.27,67.86,5.09,11.09,8.69,22.68,9.88,34.86,3.07,31.52-11.09,54.31-41.54,67.02-19.88,8.3-40.8,11.48-62.18,11.84-17.73.3-35.47.09-53.2.23-3.47.03-7.17-.02-10.36,1.12-7.11,2.55-14.01,1.81-21.31,1.09-14.59-1.44-29.29-2.19-43.95-2.34-31.96-.31-63.93-.45-95.89.13-16.29.3-32.6,1.88-48.81,3.68-14.31,1.59-27.86-1.23-41.38-4.99-16.4-4.56-32.71-9.42-49.13-13.9-9.31-2.54-18.95-3.95-28.36-1.24-10.21,2.94-19.29.67-28.33-3.77-20.93-10.28-41.89-20.5-62.83-30.75-7.96-3.9-16-7.65-23.82-11.79-4.48-2.37-8.82-5.13-12.83-8.22-5.6-4.32-12-4.46-18.57-4.83-15.57-.88-31.2-1.49-46.67-3.33-9.65-1.15-19.1-4.16-28.55-6.68-8.81-2.35-10.64-1.43-12.74,7.38-20.97,87.93-72.85,151.65-152.97,192.05-55.44,27.95-114.79,36.18-175.74,25.08-133.65-24.33-208.36-123.52-227.43-220.58-18.62-94.77,5.5-179.71,70.91-251.47,43.03-47.21,96.82-76.12,159.77-87.4,37.87-6.79,75.71-5.82,113.28,2.61,4.72,1.06,8.51.56,12.14-2.99,3.83-3.75,5.78-3.37,9.18.7,1.94,2.32,3.64,4.87,5.72,7.06,3.42,3.59,7.46,6.18,13.45,7.1ZM757.99,925.44c-8.73-2.96-16.78-6.7-21.08-15.74-1.42-2.99-4.35-3.35-7.16-1.55-2.51,1.61-3.45,3.82-1.44,6.46,1.11,1.46,2.26,3.49,3.78,3.93,8.62,2.48,17.36,4.55,26.05,6.76,3.31,2.28,6.55,4.69,9.96,6.83,11.24,7.04,23.75,9.18,36.76,9.12,1.61,0,3.22-.63,4.84-.96,0-.48.01-.97.02-1.45-5.98-1.64-11.93-3.35-17.94-4.89-11.25-2.89-22.52-5.67-33.78-8.5ZM1295.25,977.75c-1.46,12.49-9,20.06-20.14,24.5-4.62,1.84-9.47,3.13-14.22,4.67,28.31-.25,48.44-22.07,39.5-43.65-1.95,5.42-3.62,10.07-5.3,14.72.41-7.64,1.5-15.31,1.07-22.9-.61-10.65-6.92-19.09-12.71-27.6-18.28-26.89-27.89-56.21-24.8-89.07.18-1.9-.2-3.86-.32-5.8-.72-.41-1.44-.82-2.16-1.23-.59,1.24-1.02,2.58-1.8,3.69-7.09,10.2-7.39,21.2-4.37,32.8,4.95,19.02,14.22,35.83,25.16,51.97,5.46,8.06,10.81,16.48,14.46,25.44,9.53,23.4-.97,44.93-24.96,52.76-6.51,2.12-13.17,3.75-19.91,5.65.38.47.53.78.65.77,19.74-1.55,38.83-4.34,48.43-25.31.26-.58.94-.96,1.43-1.44ZM898.61,814.98c-.4-2.22-.73-4.46-1.21-6.66-3.01-13.87-7.05-27.61-8.89-41.64-4.16-31.74,4.45-60,25.68-84.26,22.48-25.68,51.28-39.87,84.25-46.23,45.26-8.74,85.63,1.01,119.95,32.7,1.71,1.58,3.46,3.16,5.35,4.5,8.86,6.26,18.16,2.2,19.23-8.55.48-4.85.59-9.81.2-14.66-1.99-24.57,7.36-43.93,26.08-59.51,18.95-15.79,40.98-25.83,63.64-34.52,33.73-12.93,67.7-25.2,101.62-37.63,4.14-1.52,6.19-3.82,5.51-8.32-.71-4.65-3.21-7.13-7.8-7.34-1.86-.08-3.75,0-5.59.26-22.85,3.26-45.7,6.54-68.55,9.87-18.22,2.66-36.37,6.71-54.67,7.68-15.69.83-31.56-1.79-47.34-3-7.5-.57-14.98-1.42-23.58-2.24,1.24,2,1.64,2.8,2.18,3.48,4.56,5.73,4.72,8.75-.03,14.02-2.64,2.92-5.7,5.52-8.82,7.93-11.27,8.68-22.66,17.21-34,25.8-8.18,6.2-16.28,12.51-24.57,18.55-5.42,3.94-11.46,7.08-18.24,4.02-16.99-7.66-33.85-15.59-50.66-23.64-3.89-1.86-6.8-5.05-6.63-9.9.18-5.12,4.02-6.99,7.96-8.68,6.16-2.65,12.35-5.26,18.52-7.88-3.84-.17-7.31.78-10.7,1.97-42.5,14.89-83.87,32.54-124.99,50.8-15.8,7.02-26.21,18.98-32.54,34.83-7.96,19.92-15.38,40.08-24.2,59.62-11.26,24.96-12.27,50.59-6.83,76.7,3.9,18.7,9.03,37.14,13.76,55.67,2.09,8.21,5.8,15.61,10.92,22.5,2.18,2.93,2.73,7.19,3.58,10.95,1.12,4.92,1.5,10.03,2.78,14.9,1.12,4.26,3.04,8.31,4.65,12.44,4.5,11.5,8.77,23.1,13.62,34.46,3.28,7.69,11.57,9.59,17.04,3.8,2.27-2.41,3.25-6.56,3.7-10.06,1.71-13.4,2.73-26.88,4.45-40.28,1.6-12.47,3.82-24.87,5.64-37.31.23-1.6-.3-3.32-.58-5.86-7.1,11.51-13.09,15.04-21.06,13.06-6.58-1.63-12.3-8.44-12.71-15.14-.4-6.49,4.51-13.73,11.12-16.36,7.65-3.05,13.56-.45,22.77,9.17ZM291.36,668.56c-2.44,1.58-5.32,2.77-7.26,4.84-4.78,5.09-9.39,10.4-13.62,15.95-22.59,29.65-36.11,64.05-50.78,97.83-1.8,4.16-.2,7.26,3.17,9.68,1.7,1.22,3.55,2.22,5.37,3.27,31.77,18.18,63.56,36.33,95.33,54.53,50.17,28.74,100.32,57.53,150.51,86.26,7.29,4.17,8.54,3.71,12.35-3.68,4.17-8.08,8.33-16.17,12.49-24.25,17.49-34.03,35.29-67.88,58.23-98.71,3.94-5.29,3.41-6.48-3.07-9.89-41.07-21.57-82.1-43.2-123.24-64.64-43.2-22.52-86.49-44.87-129.78-67.24-2.86-1.48-5.98-2.45-9.7-3.95ZM844.29,539.91c2.09-.67,3.94-.84,5.25-1.77,3.8-2.68,7.49-5.54,11.04-8.55,43-36.42,88.02-69.92,138.86-94.79,12.49-6.11,25.45-11.69,38.75-15.64,15.73-4.67,31.93-1.88,47.85.93,8.26,1.46,16.5,3.13,24.82,4.2,5.65.73,7.46-1.32,6.35-6.83-.96-4.78-2.56-9.44-4.02-14.11-4.29-13.79-9.14-27.43-12.83-41.38-2.87-10.83.73-17.1,11.58-20.23,7.01-2.02,14.79-3.48,21.91-2.62,17.56,2.12,34.94,5.73,52.39,8.75,1.84.32,3.78,1.19,5.48.86,2.76-.54,6.29-1.17,7.73-3.08,1.12-1.49-.07-5.14-.96-7.57-.77-2.12-2.6-3.84-3.87-5.79-4.05-6.26-8.46-12.33-11.9-18.92-1.7-3.26-2.59-7.64-2.05-11.24,1.16-7.71,1.27-8.66-6.16-11.3-9-3.2-18.04-6.29-27.2-8.98-31.18-9.16-63.06-14.8-95.37-18-28.38-2.81-55.49.97-79.57,17.53-32.35,22.25-62.9,46.74-90,75.26-13.97,14.71-27.67,29.73-37.78,47.52-11.38,20.03-13.65,40.81-5.08,62.52,2.48,6.28,4.72,12.68,6.61,19.16,5,17.2,6.52,34.36-1.65,51.18-.26.54-.11,1.28-.2,2.89ZM1167.01,380.52c.14-.96.28-1.92.41-2.88,2.57,0,5.19-.34,7.7.05,41.74,6.52,79.96,21.56,114.03,46.84,17.04,12.65,34.28,25.03,51.52,37.41,3.06,2.2,6.55,3.8,9.85,5.68.47-.49.95-.98,1.42-1.47-1.3-1.97-2.51-4.01-3.93-5.89-8.15-10.8-16.54-21.43-24.51-32.36-11.83-16.22-11.06-36.88,1.62-52.43,4.58-5.62,4.43-7.27-1.14-12.08-.88-.76-1.78-1.51-2.73-2.19-29.37-21.08-58.66-42.28-88.22-63.08-3.57-2.51-8.6-4.06-12.97-4.1-8.12-.06-16.3.97-24.36,2.2-9.35,1.44-12.44,7.81-8.43,16.4.98,2.1,2.28,4.07,3.57,6.01,3.89,5.82,8.03,11.47,11.71,17.42,2.55,4.12,5.62,8.77,2.05,13.58-3.5,4.7-8.87,4.47-14.12,3.51-.46-.08-.91-.2-1.37-.29-13.05-2.54-26.05-5.34-39.16-7.53-11.75-1.97-23.64-3.55-35.26.84-7.93,3-10.87,8.38-8.81,16.57,1.47,5.87,3.56,11.58,5.33,17.38,4.01,13.14,8.75,26.12,11.69,39.5,1.51,6.87,4.63,10.27,10.5,13.29,9.7,4.99,19.34,10.37,28.16,16.75,14.85,10.75,26.29,25.06,37.81,39.17,4.72,5.78,9.12,11.82,13.76,17.66,3.14,3.94,6.99,5.74,12.28,4.55,30.26-6.78,60.54-13.4,90.83-20.04,10.7-2.35,21.46-4.46,32.12-7.01,1.94-.47,4.25-2.27,4.94-4.03.44-1.11-1.71-3.35-2.9-4.93-.52-.7-1.56-.99-2.33-1.52-8.79-6.14-17.83-11.96-26.31-18.5-23.11-17.81-46.21-35.61-72.35-48.9-6.75-3.43-13.68-6.51-20.53-9.76,11.93,12.43,14.46,21.05,8.44,31.09-5.25,8.76-15.37,12.82-24.68,9.93-9.67-3.01-16.29-12.79-15.23-22.54,1.28-11.74,8.85-17.45,27.41-19.78-19.27-8.09-38.54-11.33-57.84-14.52ZM560.67,464.84c1.46,1.59,2.81,3.29,4.39,4.76,7.68,7.18,16.92,11.68,26.94,14.24,14.45,3.69,29.17,6.36,43.58,10.16,56.35,14.85,112.64,29.97,168.94,45.01,8.79,2.35,17.52,4.89,26.32,7.16,3.48.9,7.47,1.55,8.28-3.47,1.84-11.47,4.87-23.02,4.65-34.49-.42-21.97-8.11-42.44-16.56-62.52-2.28-5.42-6.22-7.88-11.98-7.86-6.77.02-13.55.25-20.3-.1-34.93-1.85-69.95-2.89-104.77-6.04-55.22-4.99-108.94-18.22-162.36-32.6-15.04-4.05-16.54-3.63-25.13,9.53-.51.78-.96,1.6-1.47,2.38-2.48,3.76-1.89,7.2,1.52,9.9,4.38,3.47,8.78,7.01,13.56,9.86,19.43,11.57,39.02,22.89,58.54,34.32,2,1.17,3.93,2.48,5.89,3.73-.27.48-.54.95-.81,1.43-6.82.21-12.19-4.64-19.25-5.39ZM1469.61,784.72c-.54-.2-1.08-.39-1.61-.59-2.17,3.13-4.64,6.1-6.46,9.43-13.78,25.15-23.73,51.77-28.59,80.03-10.19,59.35,1.97,114.62,32.47,165.99,46.24,77.89,142.77,126.08,239.82,110.06,73.64-12.16,129.19-51.16,166.84-114.4,38.34-64.39,43.71-133.99,17.89-203.57-30.07-81.03-88.75-132.59-174.06-151.5-14.46-3.21-29.6-3.45-44.46-4.72-5.56-.47-7.12,1.44-7.22,6.88-.17,9.35,3.38,13.06,13.02,13.12,22.69.15,44.36,5.38,65.55,12.98,68.51,24.58,128.89,94.24,138.96,172.64,6.16,47.97-.18,94.18-23.71,136.96-41.46,75.38-134.62,137.26-250.72,105.67-85.96-23.39-151.42-102.76-158.29-191.76-2.95-38.21,1.82-74.89,19.36-109.48,6.24-12.31,4.67-25.12,1.22-37.75ZM904.67,730.97c.22,2.79.22,5.61.69,8.35,4.88,28.44,13.52,55.67,26.94,81.24,5.98,11.39,13.56,21.76,23.31,30.35,15.27,13.45,30.22,14.97,47.19,3.75,26.95-17.82,49.78-39.81,66.63-67.71,9.97-16.51,13.46-34.09,10.11-53-2.76-15.57-9.5-29.19-20.92-40.26-4.67-4.53-6.35-4.52-10.98-.06-2.62,2.53-5.18,2.95-8.16,1.26-4.26-2.41-8.43-4.97-12.67-7.41-2.96-1.7-4.41-3.9-3.33-7.49,1.46-4.89-1.07-7.84-5.11-10.23-4.79-2.83-9.76-5.57-13.94-9.17-7.36-6.34-15.4-7.91-24.73-6.16-29.55,5.54-51.55,21.56-66.83,47.26-5.39,9.06-8.21,18.72-8.2,29.26ZM1102.8,470.59c-.04.56-.09,1.12-.13,1.68-2.48-.31-5.01-.43-7.45-.96-10.47-2.28-20.91-4.71-31.37-7.04-18.21-4.07-36.45-4.56-53.28,4.34-23.47,12.42-46.52,25.67-69.41,39.13-7.78,4.57-14.74,10.62-21.72,16.42-4.16,3.46-3.78,5.89.79,8.71,5.75,3.55,11.86,6.52,17.54,10.17,4.68,3,9.04,2.83,13.86.6,32.21-14.89,65.58-26.75,99.31-37.65,34.06-11,68.66-15.51,104.09-7.73,10.46,2.3,20.75,5.41,31.15,8.02,5.31,1.33,10.69,2.37,16.04,3.55.32-.44.63-.87.95-1.31-1.9-3.06-3.51-6.35-5.75-9.14-8.17-10.18-16.17-20.54-24.91-30.22-35.2-38.99-79.97-48.78-129.95-41.51-17.36,2.53-32.59,10.82-47.81,19.07-46.52,25.21-89.58,55.43-130.24,89.17-3.1,2.58-5.9,5.52-9.58,9.01,2.87,1.03,4.31,1.61,5.79,2.08,8.89,2.79,18.16,4.71,26.59,8.5,13.62,6.12,26.61,5.77,39.74-.68,3.4-1.67,6.74-3.48,10.1-5.23-.09-.62-.17-1.24-.26-1.86-2.16-1.19-4.29-2.43-6.48-3.56-5.58-2.89-11.43-5.35-16.73-8.68-6.59-4.15-6.74-7.85-1.2-13.46,1.96-1.98,4.16-3.75,6.37-5.45,28.79-22.18,60.59-39.28,93.18-55.02,3.31-1.6,7.02-2.55,10.65-3.33,28.33-6.08,54.31,2.68,80.12,12.37ZM218.91,689.86c-.34-.48-.67-.97-1.01-1.45-2.19.69-4.5,1.14-6.55,2.12-33.11,15.92-61.18,38.19-84.45,66.63-27.17,33.23-45.5,70.63-51.45,113.24-5.7,40.85-1.37,81.27,12.34,120.06,49.39,139.69,202.22,190.62,318.07,140.29,73.26-31.83,119.67-86.98,140.89-163.65,2.04-7.39,3.19-15.06,4.3-22.66.75-5.15-1.24-6.53-5.97-4.73-6.92,2.64-12.03,7.01-13.9,14.53-1.07,4.3-2.3,8.55-3.38,12.85-29.77,118.52-169.78,202.55-303.59,143.71-78.23-34.41-147.28-127.39-126.99-239.29,10.61-58.53,38.69-106.67,87.09-141.73,13.29-9.62,25.47-19.19,31.7-34.77.72-1.81,1.92-3.43,2.89-5.14ZM1786.15,1128.79c-.4-.35-.8-.69-1.2-1.04-1.04.48-2.09.91-3.1,1.44-16.39,8.55-33.5,15.27-51.38,19.98-36.71,9.68-73.65,10.34-110.9,3.19-30.63-5.88-59.23-16.66-84.95-34.38-31.45-21.66-55.85-50.06-75.75-82.31-31.27-50.69-40.85-105.48-29.55-163.95,6.16-31.9,18.22-61.61,33.34-90.2.77-1.46,1.28-3.06,1.91-4.6-.41-.29-.83-.57-1.24-.86-15.16,11.19-29.12,23.82-42.75,36.83-2.99,2.86-2.73,6.33-.13,9.44,2.84,3.4,6.1,6.47,8.65,10.06.95,1.33.43,3.71.58,5.61-1.87-.07-4.41.61-5.48-.35-4.12-3.71-7.64-8.06-11.64-11.92-2.03-1.96-4.51-4.6-6.92-4.75-3.89-.24-4.76,3.76-5.56,6.96-2.83,11.31-5.5,22.66-8.48,33.92-1.59,6.01-.22,10.75,3.99,15.34,7.09,7.73,14.06,15.61,20.39,23.96,2.99,3.94,4.64,9,6.37,13.75,1.04,2.85.75,5.97-2.62,7.89-2.82-4.94-5.1-9.93-8.28-14.26-3.29-4.48-7.59-8.21-11.2-12.48-3.45-4.07-6.58-8.42-9.84-12.64-.59.24-1.18.47-1.78.71-.22,7.39-.44,14.79-.66,22.18-.55,18.47,8.13,31.53,23.73,40.57,2.11,1.22,4.07,2.73,6.2,4.17-3.77,4.01-3.8,4.1-7.34,2.92-6.85-2.28-12.32-6.46-16.58-12.29-1.11-1.51-2.42-2.88-3.63-4.31-.59.28-1.19.56-1.78.84,1.76,9.08,2.82,18.36,5.42,27.2,5.92,20.15,14.81,37.75,39.62,39.09,1.35.07,2.6,2.1,3.9,3.22-1.49,1.11-2.93,3.07-4.49,3.18-7.91.58-15.18-1.78-21.92-5.9-1.6-.98-3.3-1.79-4.96-2.67,4.4,18.25,12.31,34.22,21.95,49.36.8,1.26,2.39,2.29,3.83,2.84,10.41,4,20.36,9.32,31.84,10.12,6.48.45,12.09,3.44,16.81,7.86,2.26,2.12,4.59,4.46,2.99,8.88-12.75-9.82-28.16-9.08-42.3-13.8,0,1.38-.18,1.95.03,2.26,1.64,2.54,3.33,5.06,5.05,7.54,11.97,17.22,27.13,28.16,49.41,25.09.23-.03.5-.12.69-.03,1.39.61,2.76,1.26,4.13,1.89-1.04,1.33-1.9,3.58-3.16,3.83-4.28.85-8.7,1.07-13.07,1.4-2.07.16-4.16.03-7.02.03,6.88,9.61,28.04,24.42,38.56,27.97,9.18,3.09,17.89,2.3,26.4-2.07,1.66-.85,3.26-2.31,4.97-2.43,1.77-.13,3.63,1.03,5.44,1.62-.69,1.54-.98,3.94-2.14,4.48-4.59,2.14-9.42,3.82-14.24,5.43-2.02.68-4.24.76-6.37,1.11,8.66,8.89,18.38,12.98,29.87,9.28,5-1.61,9.48-4.82,14.27-7.16,1.12-.55,2.52-.51,3.79-.74.18,1.48,1.07,3.59.41,4.32-2.41,2.69-5.17,5.14-8.1,7.26-1.91,1.39-4.34,2.08-7.68,3.6,9.67,6.08,18.74,6.91,27.92,4.43,6.24-1.69,12.24-4.48,18.13-7.23,5.87-2.74,11.88-4.28,18.28-3.49,2.17.27,4.19,1.69,6.28,2.59,0,.75-.02,1.5-.03,2.24-12.59.37-22.75,6.57-33.29,12.64,7.01,2.14,14.03,3.27,20.95,4.8,12.85,2.84,23.94-.66,33.9-8.78,1.89-1.54,3.9-2.95,6.67-5.03,3.42,9.3-5.71,11.01-8.95,17.58,12.03-.95,22.62-2.1,33.25-2.55,13.87-.59,24.25-5.93,29.53-19.41.98-2.49,2.71-4.99,5.76-3.33,3.1,1.68,1.44,4.41.36,6.73-1.42,3.06-2.86,6.11-4.88,10.44,3.68-.39,5.96-.37,8.1-.92,2.91-.75,5.86-1.62,8.53-2.97,8.26-4.18,10.83-12.77,13.99-20.62,8.36,3.21,2.07,9.64,4.93,14.38,8.21-.97,15.01-4.81,19.7-11.45,5.31-7.52,9.73-15.67,14.53-23.55ZM706.88,887.91c3.56-.16,6.39-.64,9.14-.34,4.64.51,6.94-1.67,8.14-5.8,3.15-10.86,11.2-15.51,21.73-16.86,3-.38,6.08-.24,9.05-.73,6.84-1.11,8.6-3.47,6.78-10.03-1.68-6.05-4.02-11.92-6.22-17.81-1.42-3.81-4.5-5.31-8.3-6.66-5.38-1.9-10.92-4.29-15.32-7.81-6.33-5.07-12.11-11-17.4-17.19-13.39-15.66-30.36-22.43-50.68-22.36-9.78.03-19.71.02-29.32-1.54-37.74-6.12-75.38-12.87-113.06-19.34-1.55-.27-4.13-.79-4.6-.09-2.55,3.77-5.14,7.72-6.46,11.99-.41,1.31,2.77,4.47,4.92,5.73,17.92,10.46,35.83,20.94,55.83,27.2,10.55,3.3,16.69,10.65,18.25,21.72.98,6.93,2.15,13.83,3.05,20.76.61,4.65,2.92,7.62,7.37,9.22,16.67,5.98,33.28,12.11,49.94,18.12,18.72,6.76,37.71,12.29,57.14,11.81ZM1061.52,1039.96c0,.32,0,.64.01.96,23.33,0,46.65-.03,69.98.01,13.67.03,13.67.08,13.46-13.38-.13-8.38-1.02-9.76-9.48-10.46-16.72-1.38-33.47-3.03-50.23-3.27-26.35-.38-52.72.84-79.06.37-20.5-.36-40.99-2.21-61.47-3.53-4.84-.31-8.43.36-10.56,5.64-2.1,5.23-4.69,5.82-10.11,3.57-3.22-1.34-6.32-3-9.47-4.51-13.75-6.56-27.81-12.1-43.27-12.95-4.51-.25-6.05-3-7.47-6.94-1.85-5.17-3.87-10.86-7.55-14.65-5.08-5.24-11.25-10.06-17.86-13.07-23.1-10.54-46.55-20.34-69.95-30.21-10.52-4.44-21.2-8.5-31.89-12.53-5.18-1.95-6.87-.65-7.02,4.78-.04,1.39.15,2.79.22,4.19.53,11.25-3.56,20.49-12.09,27.8-1.59,1.36-3.2,2.72-4.71,4.18-2.1,2.03-2.06,4.09.31,5.88,1.3.98,2.66,1.93,4.11,2.64,32.66,16.01,65.3,32.03,98.02,47.91,6.21,3.02,12.77,4.12,19.72,2.37,9.9-2.49,19.97-2.54,29.79.07,16.22,4.3,32.3,9.1,48.42,13.77,15.1,4.38,30.31,7.72,46.19,5.59,6.01-.81,12-2.17,18.02-2.35,27.97-.81,55.95-1.3,83.93-1.9ZM350.7,379.21c-.46.46-.93.92-1.4,1.38,2.41,4.44,4.92,8.82,7.2,13.32,6.95,13.71,14.07,27.35,20.59,41.27,3.26,6.95,3.34,14.47.32,21.79-3.22,7.78-3.29,7.94,4.41,12.01,20.19,10.69,40.78,20.66,60.62,31.95,38.1,21.69,79.4,30.3,122.63,31.75,8.46.28,9.43-.8,8.9-9.07-1.61-25.24-12.22-45.43-32.94-60.43-26.06-18.87-56.12-26.8-86.94-32.79-5.79-1.13-7.34.7-6.11,6.51,3.65,17.35,7.57,34.62,15.44,50.7,1.3,2.67,2.19,5.54,3.26,8.31-.68.29-1.36.59-2.04.88-2.19-4-4.59-7.9-6.52-12.01-6.9-14.68-10.59-30.36-13.48-46.2-1.48-8.11-5.84-13.27-12.96-16.99-23.55-12.3-46.97-24.85-70.46-37.27-3.44-1.82-6.99-3.41-10.49-5.11ZM307.54,966.38c-5.89-5.07-5.95-5.16-13.29-.58-4.87,3.04-9.56,3.23-14.42.15-5.08-3.22-6.04-7.87-5.01-13.41,1.37-7.37,1.3-7.38-5.56-9.74-6.91-2.38-9.57-8.07-6.76-15.22,1.23-3.14.23-4.9-2.49-6.16-2.32-1.08-4.8-1.89-6.99-3.17-5.01-2.93-6.86-7.41-5.95-13.05.93-5.76,5.19-7.76,9.95-9.59,7.47-2.88,7.82-4.68,2.6-10.77-.3-.35-.65-.67-.95-1.03-2.34-2.71-3.29-5.64-1.26-8.95,2.08-3.4,5.1-4.61,8.97-3.7,1.13.27,2.24.71,3.38.9,4.59.76,6.6-1.16,5.99-5.77-.53-4-2.74-6.75-6.38-8.58-5.01-2.52-7.63-6.55-7.53-12.37.13-7.19-3.9-12.78-7.6-18.45-2.23-3.41-4.81-3.19-7.52-.63-3.22,3.05-6.49,6.04-9.57,9.23-33.34,34.47-35.08,85.9-19.22,118.55,26.87,55.35,92.61,76.71,146.91,47.55,31.77-17.06,48.88-45.03,55.78-79.76,1.04-5.24-2.41-8.18-6.93-5.62-10.84,6.13-24.92,6.86-31.92,19.99-1.69-5.81-4.21-7.15-7.12-4.34-1.4,1.35-2.04,3.55-2.86,5.43-.65,1.51-1.05,3.13-1.71,5.15q-7.59-8.1-13.38-4.41c1.02,1.28,2.03,2.54,3.51,4.38-6.62,1.23-7.39,5.09-6.12,10.1.39,1.56.51,3.25.38,4.86-.76,9.4-10.75,14.22-18.54,8.99-1.35-.91-2.56-2.03-3.85-3.03-5.13-4.01-6.1-3.78-9.59,1.92-1.46,2.38-3.15,4.62-5.5,8.03-1.85-5.63-5.24-9.47.71-12.96,1.01-.59,1.59-3.44,1.09-4.76-1.08-2.87-2.99-5.42-4.97-8.8-1.32,1.89-2.27,2.71-2.53,3.7-1.31,5.14-2.44,10.32-3.74,15.94ZM1673.11,760.48c-5.65,3.48-10.23,8.61-16.22,2.87-3.51-3.37-4.18-6.81-1.97-10.66,3.74-6.51,9.2-4.7,14.66-2.64.3-1.01.74-1.69.64-2.28-3.04-19.34-5.64-38.76-9.35-57.97-3.32-17.17,4.9-31.14,22.01-34.32,21.31-3.95,42.71-7.43,64.06-11.17,5.16-.9,10.28-2.02,17.01-3.35-2.59-1.82-3.68-3.05-5.02-3.46-15.35-4.73-30.53-10.23-46.15-13.8-37.52-8.59-75.4-8.44-113.25-1.9-8.25,1.43-16.41,3.48-24.54,5.5-3.38.84-6.5,2.69-4.25,6.96,6.61,12.57,13.12,25.21,20.27,37.48,4.15,7.13,10.97,10.3,19.47,10.12,12.59-.26,25.18-.1,37.78-.05,1.41,0,2.82.49,4.23.76.05.61.09,1.21.14,1.82-2.48.5-4.94,1.4-7.43,1.43-12.36.16-24.72,0-37.08.15-6.8.09-7.79,1.87-5.06,8.17.56,1.28,1.18,2.53,1.79,3.79,7.39,15.32,14.92,30.58,22.15,45.98,16.24,34.6,32.31,69.28,48.5,103.91.78,1.67,1.94,3.16,3.66,5.92.85-2.98,1.39-4.25,1.56-5.56,1.23-9.47,2.41-18.95,3.54-28.44.81-6.78-.1-7.63-7.17-6.99-.7.06-1.39.25-2.08.26-5.8.12-9.45-3.25-9.58-8.8-.12-4.95,3.36-8.58,8.75-8.99,1.95-.15,3.92-.02,6.84-.02-2.76-12.1-5.26-23.06-7.92-34.73ZM777.04,621.96c-.28.57-.55,1.15-.83,1.72-2.23-.94-4.58-1.68-6.67-2.86-12.58-7.11-25.1-14.35-37.66-21.5-37.46-21.33-74.01-44.34-114.16-60.69-6.46-2.63-11.8-2.49-18.9.86,3.59,2.55,6.22,4.69,9.09,6.42,53.92,32.5,107.82,65.02,161.87,97.31,5.32,3.18,11.34,5.59,17.35,7.14,18.05,4.66,31.57-1.32,40.44-17.7,2.97-5.5,4.95-11.54,7.24-17.39,2.62-6.68,1.43-12.97-2.94-18.45-9.31-11.69-20.23-21.27-35.02-25.52-9.18-2.64-18.3-5.51-27.49-8.13-45.06-12.84-90.14-25.63-135.21-38.43-14.13-4.01-28.24-8.09-42.4-12-5.92-1.64-7.91-.05-7.6,6.03.17,3.24.66,6.53,1.57,9.63,1.19,4.08,3.79,7.03,9.32,8.66-.95-2.3-1.35-3.31-1.78-4.31-2.47-5.63-1.71-8.48,3-11.12,4.93-2.77,9.3-2.03,11.9,2.9,2.93,5.57,7.38,8.87,13.02,10.97,20.53,7.63,40.84,15.91,61.64,22.7,32.34,10.55,65.03,20.03,97.53,30.11,3.8,1.18,7.33,3.22,10.98,4.87-.23.56-.46,1.12-.7,1.68-37.99-11.4-75.97-22.81-113.96-34.21-.27.68-.55,1.36-.82,2.04,33.73,19.75,67.46,39.51,101.19,59.26ZM1047.11,952.92c-11.73-3.04-21.79-5.68-31.87-8.24-12.65-3.21-25.32-6.31-37.97-9.54-6.87-1.75-8.62-4.46-7.32-10.98.41-2.05.98-4.08,1.5-6.11,3.64-14.46,7.35-28.91,10.9-43.4,1.82-7.45,1.42-8.23-6.29-10.01-11.23-2.59-21.44-7.38-28.79-16.17-6.97-8.34-13.78-17.25-18.46-26.97-7.55-15.7-13.22-32.3-19.88-48.44-.87-2.11-3.24-5.44-4.35-5.23-2.29.43-4.85,2.48-6.13,4.57-3.8,6.2-3.12,12.95-1.12,19.62,1.14,3.79,2.57,7.5,3.63,11.32,4.75,17.17,2.68,34.21-1.11,51.21-3.97,17.81-6.17,35.83-6.53,54.08-.07,3.62.34,6.87,3.71,9.22,8.53,5.95,8.56,6.05,4.72,15.18-1.08,2.56-1.1,4.8,1.41,6,5.94,2.86,7.73,8.31,9.61,13.9,3.56,10.58,8.1,13.09,18.99,10.46,4.67-1.13,8.4-.48,10.44,4.27,1.94,4.51,5.42,5.96,10.07,5.94,12.59-.06,25.2.38,37.77-.08,3.86-.14,8.21-1.79,11.34-4.1,6.59-4.87,7.18-5.41,13.56.22,3.07,2.71,5.5,2.69,8.6.36,4.47-3.37,9.12-6.48,13.67-9.75,2.92-2.1,5.78-4.27,9.92-7.33ZM424.18,925.03c-2.19,7.61-4.21,14.27-6.02,20.98-1.84,6.84-1.02,8.11,6.18,9.07,8.55,1.14,17.17,1.78,25.7,3.08,9.21,1.41,18.44,2.9,27.47,5.14,9.31,2.31,13.37,8.47,13.35,17.97-.02,7.5-2.72,14.07-6.38,20.44-17.86,31.02-44.75,52.07-75.73,68.55-15.67,8.34-32.36,13.22-50.22,13.28-15.42.05-25.61-9.47-25.96-24.98-.23-10.2.56-20.46,1.42-30.64.67-7.83-1.15-10.32-9.06-10.16-2.33.05-4.65.32-6.97.55-6.87.66-7.54,1.39-6.63,8.29,1.43,10.86,3.35,21.67,4.46,32.56,2.03,20.01-8.35,28.81-28.03,24.17-.23-.05-.45-.12-.68-.18-30.42-7.08-56.94-21.64-80.42-41.99-17.52-15.18-31.46-33.1-40.69-54.46-1.34-3.11-2.92-7.05-2.11-9.97,2.35-8.51,6.83-15.92,15.93-18.99,7.07-2.38,14.22-4.5,21.34-6.72,8.51-2.66,9.32-4.07,7.11-12.56-.23-.9-.54-1.79-.78-2.69-2.29-8.58-2.79-8.86-10.78-4.96-8.37,4.09-16.54,8.61-25.04,12.4-6.02,2.68-12.39,2.4-18.16-1.1-1.85-1.13-4.04-3.09-4.43-5.01-1.7-8.42-3.69-16.93-3.98-25.46-1.74-50.72,13.34-95.55,47.96-133.27,1.89-2.06,3.91-4.05,5.46-6.36,2.36-3.52,2.96-7.14-.87-10.63-1.23.77-2.37,1.19-3.1,1.98-6.65,7.19-13.88,13.95-19.73,21.75-38.63,51.47-51.03,108.49-35.02,171.16,18.31,71.69,84.99,130.93,158.61,138.42,72.85,7.41,133.49-16.78,178.92-75.53,11.49-14.85,20.53-31.13,26.66-48.94,2.44-7.1,1.86-7.64-5.12-9.61-3.96-1.12-8.32-2.58-11.25-5.25-8.54-7.79-18.55-12.2-29.45-15.26-3.79-1.06-7.46-2.68-11.06-4.32-7.37-3.35-14.66-6.87-22.91-10.76ZM1239.16,594.73c-1.75,1.43-4.34,2.92-6.09,5.09-12.89,15.97-25.66,32.04-38.37,48.15-4.22,5.35-4.21,7.32-.17,13.12,8.4,12.05,16.78,24.12,25.46,35.97,2.13,2.9,5,5.84,8.19,7.29,14.21,6.45,28.67,12.37,43.04,18.46,3.53,1.5,6.98,1.51,9.57-1.66,4.43-5.4,10.14-10.4,12.57-16.64,3.35-8.61,7.95-14.68,15.86-19.64,5.23-3.28,8.27-9.93,12.58-14.81,3.22-3.64,2.94-6.85.33-10.64-8.73-12.67-17.12-25.59-26.06-38.11-2.17-3.04-5.62-5.69-9.06-7.2-13.86-6.08-27.95-11.66-41.97-17.39-1.5-.61-3.07-1.05-5.89-1.99ZM703.23,900.59c2.07,2.84,3.65,4.54,4.7,6.53,3.02,5.73,6.43,11.36,8.54,17.43,1.78,5.12-.91,7.35-6.34,6.21-3.87-.81-7.74-1.73-11.53-2.85-7.42-2.19-12.35-6.86-14.99-14.34-1.52-4.32-4.06-8.3-6.4-12.29-1.88-3.2-4.56-5.98-6.11-9.32-1.84-3.96-4.73-6.05-8.65-7.45-19.08-6.8-38.11-13.73-57.17-20.58-9.14-3.28-12.03-2.79-16.65,5.81-10.24,19.06-19.89,38.44-29.59,57.78-2.46,4.9-1.42,7.12,3.81,9.07,6.54,2.44,13.27,4.37,19.83,6.76,26.53,9.67,53.27,18.43,81.65,20.86,13.73,1.17,27.45,2.12,41.04-.97,10.81-2.46,18.06-9.13,19.6-20.18,1.02-7.27.61-14.85-.01-22.22-1.03-12.04-7.49-18.11-21.72-20.27ZM1092.71,947.16c1.17-1.67,2.46-3.26,3.46-5.01,3.24-5.67,6.41-11.38,9.53-17.11,3.2-5.89,3.09-6.45-3.06-9.38-6.16-2.94-10.09-7.05-10.3-14.41-.08-2.81-1.21-6.63-3.24-8.14-6.47-4.82-13.53-8.88-20.52-12.96-1.17-.68-3.17,0-4.77.14-7.05.62-10.78-3.99-7.87-10.28,1.9-4.1,2.15-7.94.84-12.16-2.82-9.13-3.17-18.38-.47-27.59,1.05-3.56,2.59-6.98,3.99-10.43,1.41-3.48,1.03-6.19-2.91-8.04-1.4,1.32-2.57,2.4-3.71,3.51-10.52,10.26-20.87,20.69-31.6,30.72-8.06,7.53-17.31,13.29-27.79,17.17-2.69.99-5.94,3.74-6.65,6.32-5.04,18.19-9.47,36.55-14.12,54.85-.92,3.63.46,5.86,3.95,6.92,1.56.47,3.11.97,4.69,1.37,17.4,4.38,34.79,8.83,52.22,13.09,10.87,2.66,21.8,5.05,32.72,7.51,2.54.57,4.88.95,6.54-2.16,6.16-11.54,6.74-11.62,17.19-4.37.18.12.45.11,1.87.44ZM365.56,1079.3c.12.34.24.68.36,1.02,8.65-2.56,17.46-4.7,25.92-7.77,37.93-13.75,67.5-37.93,88.86-72.15,4.47-7.17,6.77-14.84,5.01-23.31-1.15-5.56-3.84-7.43-9.44-6.94-1.39.12-2.77.41-4.12.72-26.09,6.04-52.19,12.02-78.23,18.24-3.54.85-7.29,2.27-10.1,4.5-10.34,8.19-21.49,14.68-34.04,18.84-4.76,1.58-7.9,5.1-8.22,10.3-.7,11.39-1.57,22.79-1.62,34.19-.05,11.84,6.44,19.15,18.01,21.48,2.5.5,5.08.6,7.62.88ZM119.69,475.55c8.17-7.19,17.62-12.3,28.05-14.67,13.82-3.14,27.91-5.15,41.93-7.38,38.45-6.1,76.92-12.05,115.37-18.13,1.57-.25,3.02-1.2,6.19-2.52-8.32-4.95-15.21-8.72-21.74-13.03-5.72-3.78-11.44-4.34-17.96-2.59-13.95,3.76-28.01,7.14-42.05,10.56-2.14.52-4.43.45-6.65.66-.1-.58-.2-1.15-.3-1.73,15.69-4.42,31.37-8.83,47.06-13.25-.12-.65-.23-1.29-.35-1.94-2.35.25-4.72.43-7.06.77-11.08,1.58-22.1,3.68-33.23,4.74-36.03,3.43-71.85,7.82-106.69,18.26-15.68,4.7-31.44,8.97-44.35,19.76-1.13.95-2.01,2.19-4.15,4.57,10.18-1.41,18.71-2.59,27.23-3.77.12.62.25,1.25.37,1.87-3.21.98-6.37,2.19-9.64,2.91-11.38,2.5-22.79,4.85-34.2,7.2-6.67,1.37-7.86,3.69-4.88,9.65,2.08,4.17,4.08,8.38,6.14,12.55,2.37,4.8,4.92,6.3,9.39,4.87,13.32-4.24,26.59-8.63,39.86-13.03,2.3-.76,4.52-1.8,7.08-2.83-.75,8.15.65,9.71,8.06,9.9,7.66.2,14.6-1.5,21.1-5.98,12.19-8.4,25.51-14.71,40.08-17.64,16.68-3.36,33.45-6.34,50.26-9.02,27.4-4.37,54.87-8.32,82.3-12.54,2.27-.35,4.43-1.4,7.28-2.33-5.69-4.58-7.45-5.18-13.8-4.13-11.73,1.94-23.39,4.31-35.14,6.08-29.97,4.52-59.98,8.73-89.95,13.25-10.82,1.63-21.81,2.93-32.26,5.97-11.26,3.28-21.97,8.42-33.37,12.93ZM1464.58,695.69c1.99,13.6,3.96,27.21,5.98,40.81.96,6.45,1.65,12.96,3.12,19.3,1.58,6.83,4.43,8.68,11.14,9.53,2.92.37,5.94,1.13,8.58,2.4,9.04,4.32,17.97,8.85,26.86,13.47,4.83,2.52,10.67,3.71,13.09,9.7.39.95,2.27,1.53,3.56,1.85,6.4,1.61,12.63,1.23,17.96-2.99,4.19-3.31,8.04-7.07,11.96-10.71,3.7-3.43,4.29-7.61,2.44-12.15-1.05-2.58-2.34-5.07-3.58-7.58-8.67-17.54-17.36-35.08-26.04-52.62-2.7-5.46-4.08-10.94-.36-16.57,2.17-3.3,1.54-6.66,0-9.99-4.01-8.67-7.93-17.39-12.07-26-2.74-5.71-5.4-6.97-10.46-3.56-16.01,10.8-31.77,21.97-47.45,33.26-3.79,2.73-5.31,7.01-4.72,11.85ZM1674.13,722.89c-.11.87-.22,1.73-.32,2.6,5.16.85,10.33,1.7,15.49,2.55,15.29,2.51,30.04,6.64,43.54,14.53,6.47,3.78,11.25,8.91,13.54,16.24,2.46,7.89,1.19,15.17-2.83,22.19-1.51,2.63-3.19,5.22-.53,8.28,4.95,5.7,10.43,5.55,14.86-.56,1.09-1.51,2.15-3.06,3.37-4.47,5.55-6.38,11.46-8.02,19.45-5.3,7.26,2.47,13.27,6.92,18.03,12.82,31.6,39.15,46.11,83.77,41.87,134.06-1.4,16.61-10.11,25.07-26.6,27.5-6.91,1.02-8.65,3-10.12,10.24-1.1,5.44,3.28,5.99,6.33,7.7,9.05,5.09,12.18,10.64,9.65,20.8-1.6,6.45-4.35,12.86-7.77,18.58-21.12,35.28-52.8,57.85-90.05,73.35-10.13,4.22-20.74,7.27-31.91,7.07-13.65-.25-23.37-9.11-25.06-22.57-1.19-9.48-3.9-11.55-13.14-10.47-3.37.39-5.13,2-5.17,5.34-.04,3.03.28,6.07.1,9.09-.76,12.36-6.68,18.6-19.06,18.43-7.6-.11-15.38-1.34-22.72-3.38-37.47-10.42-67.37-32.47-91.86-62.04-6.01-7.26-10.97-15.78-14.71-24.45-7.69-17.82-.26-32.42,18.32-38.21,2.23-.69,4.52-1.23,6.68-2.09,5.94-2.39,6.88-6.65,3.39-14.68-2.19-5.04-4.1-5.65-10.08-3.14-5.8,2.44-11.46,5.27-17.39,7.3-7.2,2.46-13.51.27-17.93-5.84-2.28-3.14-4.16-6.83-5.19-10.56-3.14-11.33-4.01-22.94-2.93-34.66,1.7-18.4,4.94-36.48,11.62-53.81.38-1,.36-2.15.53-3.24-2.17,2.11-3.31,4.56-4.25,7.09-12.07,32.31-14.16,65.31-7.47,99.09,20.57,103.92,126.08,174.21,231.13,147.63,87.41-22.11,148.31-102.77,143.4-192.69-3.27-59.95-28.11-109.14-76.81-145.21-26.96-19.96-57.06-32.4-90.81-35.09-2.19-.17-4.4-.02-6.6-.02ZM1314.17,498.1c.09.41.18.83.28,1.24,8.73-.67,17.46-1.42,26.2-2,5.66-.38,11.08.26,16.14,3.35,5.37,3.28,7.4,2.03,7.61-4.23.06-1.86-.17-3.73-.04-5.59.4-5.81,3.01-10.16,8.5-12.58,6.77-2.99,11.93-1.66,17.01,4.94,2.66,3.46,5.32,5.82,9.97,3.78,8.95-3.93,17.95-7.76,26.93-11.63,3.5-1.51,5.62-3.86,5.68-7.95.16-10.81-.64-21.35-5.46-31.35-5.45-11.33-10.48-22.87-15.71-34.31-4.65-10.17-9.23-20.37-14-30.48-2.54-5.4-4.65-6.59-9.13-4.71-19.76,8.28-39.54,16.51-59.08,25.27-9,4.03-12.13,12.19-8.88,21.6,1.57,4.54,3.94,8.97,6.73,12.9,5.93,8.35,12.42,16.31,18.59,24.5,5.33,7.07,10.85,14.02,15.69,21.42,4.83,7.39,3.35,11.44-4.79,14.51-4.78,1.8-9.77,3.07-14.71,4.37-9.15,2.4-18.34,4.65-27.51,6.97ZM1302.92,773.28c-.7-.26-1.4-.52-2.09-.79-4.08,4.29-8.32,8.44-12.23,12.88-23.36,26.59-30.16,57.65-24.11,91.91,3.27,18.54,12.99,34.19,22.8,49.89,6.26,10.01,12.3,20.45,16.44,31.44,6.99,18.6-.69,36.81-18.11,46.41-3.45,1.9-7.14,3.45-10.88,4.7-13.85,4.64-28.25,6.05-42.72,6.39-18.41.44-36.83.24-55.23.66-7.43.17-8.96,2.11-9.32,9.29-.07,1.4-.11,2.8-.12,4.19,0,8.26,2.03,10.49,10.27,10.49,16.08.01,32.17.02,48.24-.29,22.73-.44,44.95-3.5,66.38-11.85,35.34-13.77,48.87-55.17,29.54-86.24-6.28-10.09-12.28-20.37-17.88-30.84-15.55-29.06-19.72-59.17-9.26-91.15,4.18-12.76,6.08-26.28,8.75-39.51.49-2.4-.29-5.05-.49-7.59ZM311.57,1057.88c-1.15-7.38-2.91-18.43-4.59-29.49-1.14-7.53-3.48-9.98-10.95-11.44-34.41-6.73-61.24-23.98-77.58-55.87-3.16-6.17-7.19-8.03-13.91-6.28-7.21,1.87-14.38,4.06-21.34,6.71-6.24,2.38-10.01,7.25-11.64,13.89-2.32,9.44,1,17.47,5.82,25.14,23.45,37.3,56.93,61.77,98.29,75.64,7.07,2.37,15.19,3.03,22.67,2.47,10.87-.81,14.38-6.17,13.22-20.76ZM319.95,399.08c-.43.74-.85,1.48-1.28,2.22-1.79-.82-3.65-1.52-5.37-2.48-27.71-15.42-55.4-30.87-83.09-46.32-15.39-8.59-13.57-8.66-24.4,6.43-2.98,4.15-2.23,6.32,2.39,8.97,4.24,2.44,8.63,4.64,12.85,7.11,46.93,27.38,93.84,54.8,140.76,82.2,6.3,3.68,11.25,1.74,13.06-5.35.56-2.18.66-4.72.13-6.89-1.26-5.19-2.26-10.66-4.72-15.31-9.47-17.92-19.35-35.63-29.42-53.22-1.5-2.61-4.63-4.56-7.4-6.11-8.35-4.65-16.81-9.1-25.36-13.36-19.4-9.68-38.82-19.33-58.39-28.65-2.86-1.36-7.36-2.25-9.78-.93-5.12,2.78-9.37,7.17-14.93,11.67,3.38,2.1,5.38,3.57,7.58,4.66,5.43,2.68,10.96,5.17,16.44,7.77,24.22,11.48,48.45,22.96,72.65,34.49,2.26,1.08,4.33,2.54,6.49,3.83-.37.67-.74,1.34-1.11,2.02-22.75-10.17-45.51-20.35-68.26-30.52-.25.48-.5.96-.76,1.45,20.64,12.11,41.29,24.22,61.93,36.34ZM199.36,779.58c-2.87,2.38-4.6,3.56-6.01,5.04-3.37,3.54-7.01,6.93-9.81,10.9-25.43,35.97-37.08,75.94-34.26,119.99.42,6.61,2.23,12.88,6.67,18.08,4.97,5.83,9.12,6.88,16,3.79,8.72-3.92,17.29-8.17,26.04-12,5.25-2.3,6.89-5.78,6.7-11.54-.28-8.34-.25-16.9,1.31-25.05,4.93-25.76,16.77-47.77,37.25-64.75,5.71-4.73,5.53-7.58-.66-11.12-8.7-4.98-17.36-10.12-26.5-14.17-8.29-3.67-15.48-7.66-16.72-19.15ZM196.5,744.93c-25.73,17.64-44.14,41.35-58.86,68.09-22.45,40.77-28.49,84.33-20.87,130.05,17.67,106.02,110.34,161.6,179.58,166.26,35.53,2.39,69.86-2.49,102.42-17.15,31.79-14.31,74.16-49.94,78.79-66.03-4.19,3.91-8.11,8.1-12.04,12.28-62.14,65.95-153.23,77.76-227.28,42.04-65.38-31.54-125.24-111.36-105.19-212.17,7.03-35.34,21.51-67.44,46.57-94.05,4.79-5.09,9.86-9.92,14.76-14.92,4.55-4.63,5.06-7.64,2.12-14.4ZM580.14,647.51c.18.64.37,1.28.55,1.92,4.77-.75,9.51-1.72,14.3-2.2,30.3-3,57.91,3.8,82,22.98,3.88,3.09,7.64,4.91,12.79,2.61,3.99-1.79,7.84-.44,10.68,2.96,2.68,3.21,3.12,7,.86,10.41-3.31,4.98-2.25,9.18,1.24,13.32,11.87,14.07,23.74,28.14,35.63,42.2.6.7,1.3,1.37,2.09,1.85,4.95,3.07,10.28.47,10.1-5.35-.19-5.75-.81-11.61-2.26-17.16-2.28-8.74-.63-11.4,8.61-12.13,2.46-.19,5.48-.41,7.16-1.87,3.56-3.06,7-3.73,11.56-2.91,5.17.93,9.12-3.26,7.05-7.3-4.41-8.64-8.19-17.77-17.72-22.72-8.89-4.61-17.38-10-26-15.12-22.46-13.34-44.91-26.69-67.31-40.12-5.06-3.03-9.62-4.18-14.66.3-1.63,1.45-4.76,2.13-6.99,1.79-6.09-.92-11.56.55-16.96,2.97-12.13,5.41-24.27,10.81-36.4,16.23-5.45,2.43-10.88,4.9-16.31,7.35ZM542.01,1078.94c.71.09,1.42.18,2.14.28,1.35-1.5,2.99-2.83,4-4.53,12.32-20.59,24.75-41.12,36.7-61.93,3.96-6.9,5.57-14.75,5.44-22.89-.33-20.68-12.18-35.13-26.11-48.38-3.06-2.91-5.85-1.93-7.33,2.5-1.62,4.83-2.48,9.93-3.56,14.93-14.08,65.37-49.49,116.31-104.23,154.2-1.09.75-2.06,1.69-3.4,2.8,10.23,13.62,2.51,26.65-1.8,41.15,9.53-3.84,17.21-7.91,24.46-12.87,8.98-6.13,14.45-14.42,15.46-25.37.53-5.8.57-11.65,1.32-17.41,1.39-10.64,11.45-16.26,21.98-11.38-1.84,1.51-3.37,2.57-4.67,3.88-2.24,2.27-5.76,4.45-6.2,7.09-1.31,7.85-1.38,15.91-2.01,25.03,2.53-1.11,3.73-1.32,4.49-2.02,8.45-7.64,17.5-14.76,25.07-23.2,8.65-9.66,11.61-21.64,8.93-34.61-1.61-7.75-3.47-15.45-5.11-23.19-.6-2.85-1.51-6,2.76-7.34,8.93,13.12,16.13,26.45,11.68,43.26ZM1500.58,491.9c-1.66-4.03-2.87-7.3-4.32-10.46-13.9-30.3-27.84-60.59-41.76-90.88-9.15-19.91-18.26-39.84-27.46-59.73-3.81-8.25-6.76-9.16-14.76-5.26-5.65,2.76-11.41,5.28-17.15,7.84-6.84,3.05-7.99,5.74-5.19,12.54.53,1.29,1.1,2.57,1.69,3.84,20.65,44.9,41.3,89.8,61.96,134.7,3.12,6.78,6.2,13.58,9.41,20.31,1.77,3.71,4.27,6.25,8.84,4.02,7.95-3.89,15.98-7.64,23.8-11.79,2-1.06,3.32-3.4,4.93-5.13ZM259.4,287.81c-.18.66-.37,1.33-.55,1.99,2.2,1.11,4.37,2.27,6.59,3.32,26.72,12.65,53.5,25.2,80.17,37.96,28.77,13.76,58.26,26.06,85.74,42.44,6.13,3.65,8.07,2.72,11.49-2.7,7.94-12.62,15.87-25.24,23.99-37.74,6.48-9.97,5.92-11.1-5.92-13.53-44.04-9.03-88.02-18.41-132.1-27.26-14.81-2.98-29.82-5.16-44.83-6.96-8.23-.98-16.58.05-24.58,2.49ZM1243.56,860.05c-.6-.09-1.2-.17-1.8-.26-1.36,3.31-3.48,6.51-3.93,9.94-.97,7.33-1.44,14.77-1.48,22.17-.05,10.92,1.1,21.88.53,32.76-.58,11.07-4.49,21.41-11.15,30.45-5.48,7.43-12.51,11.63-22.21,10.26-7.71-1.09-14.32,1.68-19.65,7.07-3.25,3.29-5.67,7.37-8.77,10.82-4.47,4.96-9.24,9.66-13.86,14.49-.73.76-1.37,1.61-3.09,3.63,3.68.37,6.07.8,8.46.81,14.45.04,28.91.39,43.34-.14,16.99-.62,33.98-1.7,50.49-6.43,24.96-7.15,35.04-28.16,24.05-51.75-4.2-9.02-9.69-17.52-15.3-25.78-10.69-15.75-19.81-32.11-23.52-51.03-.47-2.38-1.39-4.67-2.11-7ZM1177.19,812.99c.71-.09,1.43-.17,2.14-.26,2.3-2.5,4.78-4.86,6.86-7.53,5.69-7.28,7.54-7.58,14.56-1.82,4.39,3.6,6.36,3.63,10-.62,4.25-4.95,8.38-10.04,12.19-15.32,1.22-1.69,2.23-4.47,1.72-6.31-1.51-5.47-.01-10.01,2.56-14.67,2.85-5.15,2.51-7.12-2.07-10.85-18.81-15.32-37.75-30.47-56.57-45.78-3.56-2.89-6.48-3.08-9.56.59-3.68,4.39-8.39,6.31-14.23,5.99-1.79-.1-4.24.9-5.41,2.24-4.75,5.44-9.13,11.2-13.63,16.86-2.36,2.97-1.67,5.61,1.01,7.94,1.05.92,2.24,1.69,3.27,2.63,4.34,3.96,4.63,7.44.97,12.17-1,1.29-2.2,2.41-3.27,3.64-4.92,5.65-4.92,7.08.77,11.94,8.68,7.41,17.44,14.74,26.31,21.93,2.69,2.18,5.66,4.32,8.86,5.52,5.89,2.21,12.16,3.54,13.52,11.71ZM495.04,932.58c-1.75,2.47-3.67,4.76-5.14,7.31-4.36,7.54-1.17,14.77,7.46,16.04,3.24.48,7.13-.04,10.06-1.47,13.4-6.55,26.7-13.33,39.72-20.61,3.41-1.9,6.42-5.46,8.31-8.96,10.75-19.87,21.24-39.89,31.48-60.03,1.69-3.32,2.48-7.53,2.32-11.27-.24-5.78-1.63-11.52-2.56-17.28-.78-4.83-1.41-9.7-2.48-14.47-.85-3.8-2.71-6.23-7.51-4.69-2.11.68-5.22.43-7.08-.71-4.52-2.74-7.46-1.13-10.19,2.4-1.43,1.84-2.79,3.74-4.12,5.65-19.48,28.03-35.63,58-51.39,88.19-3.3,6.32-3.23,6.44,2.82,11.99,2.38,2.18,3.21,4.6,1.73,7.48-1.48,2.89-4.1,3.79-7.11,3.02-1.98-.5-3.82-1.54-6.32-2.59ZM1552.61,688.95c.24-.03.75,0,1.16-.18,9.09-4.15,18.26-8.16,27.16-12.69,1.28-.66,1.93-3.99,1.65-5.91-.35-2.43-1.95-4.69-3.02-7.02-17.65-38.3-35.3-76.59-52.93-114.89-2.24-4.87-4.22-9.86-6.65-14.63-3.07-6-5.74-6.71-11.85-3.73-5.65,2.75-11.22,5.7-16.96,8.23-11.18,4.93-11.46,5.54-6.43,16.35,13.65,29.35,27.22,58.74,40.89,88.08,6.29,13.52,12.72,26.97,19.12,40.44,1.54,3.25,3.3,6.3,7.88,5.95ZM236.47,291.84c-.19.38-.38.75-.57,1.13,3.11,1.8,6.17,3.71,9.35,5.4,22.02,11.72,44.18,23.18,66.05,35.16,11.41,6.25,21.09,14.83,27.34,26.41,3.4,6.31,8.13,10.5,14.3,13.75,27.45,14.43,54.71,29.21,82.26,43.43,6.96,3.59,14.63,5.91,22.16,8.23,6.67,2.05,13.62,3.15,20.39,4.92,30.89,8.09,59.57,20.38,82.35,43.76.52.53,1.46.65,3.17,1.36-2.05-6.68-6.36-10.2-10.79-13.42-14.52-10.57-29.11-21.04-43.75-31.44-8.89-6.31-17.33-12.73-12.67-25.5-7.5-1.71-14.42-2.76-20.99-4.91-11.05-3.61-22.26-7.09-32.68-12.14-11.04-5.34-20.74-13.51-31.86-18.6-55.95-25.59-112.18-50.59-168.33-75.75-1.81-.81-3.81-1.2-5.73-1.78ZM659.92,743.15c-27.59-6.59-54.01-13.28-80.61-19.13-17.9-3.94-36.08-4.59-54.14-.3-5.57,1.32-10.88,4.48-16.95,1.74-.82-.37-2.88.61-3.44,1.54-.48.79-.07,2.97.68,3.54,6.79,5.11,9.54,12.52,11.74,20.2,1.5,5.21,4.86,7.38,10.04,8.18,21.66,3.33,43.29,6.93,64.93,10.41,28.8,4.63,57.66,8.66,86.85,9.79,1.9.07,3.81-.15,5.71-.23.22-.52.43-1.04.65-1.56-1.44-1.66-2.77-3.43-4.33-4.98-5.3-5.26-10.56-10.56-16.05-15.61-3.92-3.61-7.49-7.15-5.08-13.57ZM1620.71,1085.94c14.94.44,22.29-6.96,20.61-20.13-.93-7.31-3.85-10.49-11.25-12.33-1.81-.45-3.6-.96-5.39-1.48-17.7-5.06-33.14-14.76-48.86-23.87-13.23-7.66-25.26-16.88-34.61-29.05-6.37-8.29-12-17.15-17.77-25.89-3.84-5.82-6.01-6.58-12.03-3.39-9.05,4.79-13.99,14.68-10.6,24.85,2.68,8.04,6.66,15.97,11.54,22.91,19.27,27.46,45.62,46.26,75.92,59.89,10.51,4.73,21.51,7.59,32.42,8.46ZM1514.01,1038.82c-.35.42-.69.84-1.04,1.26,2.54,3.02,4.87,6.24,7.64,9.03,52.75,53.26,115.82,74.65,189.53,58.33,84.99-18.82,147.77-91.63,153.12-178.37,4.9-79.54-26.97-141.96-93.9-185.67-23.96-15.65-50.43-25.13-79.15-27.67-2.53-.22-5.1-.03-7.65-.03-.03.49-.06.98-.08,1.47,1.96.52,3.92,1.03,5.87,1.57,14.12,3.96,28.61,6.94,42.29,12.09,42.55,16.02,76.2,42.98,97.45,83.81,20.24,38.9,27.81,80.56,23.79,124.05-3.98,43.04-21.92,79.72-53.67,109.28-25.71,23.93-55.73,40.42-89.29,50.58-35.18,10.65-70.32,10.91-105.3-.81-29.48-9.87-54.89-26.5-77.58-47.51-4.05-3.75-8.01-7.61-12.01-11.42ZM1110.96,885.53c11.47.55,14.59-.23,20.01-4.32,21.18-15.98,25.3-44.88,8.83-65.63-11.27-14.2-27.44-19.52-44.31-16.72-16.76,2.78-28.41,14.96-34.33,30.88-7.59,20.4,3.95,46.38,23.94,55.27,3.83,1.7,8.56,1.85,12.87,1.83,5.09-.02,10.17-.99,12.98-1.3ZM1457.51,695.32c-2.64,2.02-4.04,2.83-5.12,3.94-26.82,27.45-48.38,58.38-62.22,94.4-2.75,7.17-5.88,14.2-8.5,21.41-2.1,5.79-.71,7.22,5.46,6.05,9.53-1.8,17.64-5.67,22.42-14.83,1.45-2.78,3.79-5.09,5.73-7.61l1.44,1.02c-1.81,3.98-3.61,7.95-5.42,11.93.52.42,1.03.84,1.55,1.27,2.12-1.42,4.4-2.65,6.34-4.29,12.97-10.97,25.47-22.54,38.94-32.85,7.71-5.9,10.38-12.23,8.85-21.57-2.69-16.31-4.67-32.72-7.06-49.08-.42-2.87-1.38-5.67-2.41-9.78ZM1562.83,390.73c.61-.54,1.22-1.07,1.83-1.61-1.46-2.71-2.81-5.49-4.39-8.13-12.65-21.22-25.77-42.19-37.85-63.73-6.08-10.84-11.58-21.83-21.22-30.06-.6-.51-.87-1.41-1.3-2.13.2-.35.4-.69.6-1.04,4.79,1.81,9.58,3.63,14.37,5.44-10.69-10.5-22.74-18.44-37.48-21.31-8.92-1.74-17.93-3.07-26.92-4.43-6.31-.95-8.04.91-6.1,6.83,2.75,8.42,5.65,16.8,8.83,25.06,4.57,11.89,12,21.54,23.26,27.93,1.21.69,2.34,1.53,3.44,2.39,6.89,5.43,6.95,5.52,13.43.06,3.38-2.84,6.38-2.19,9.4.32,3.55,2.95,4.16,6.21,1.93,9.78-3.82,6.12-3.87,6.18,1.46,10.52,15.39,12.51,30.77,25.03,46.28,37.39,3.21,2.56,6.93,4.49,10.42,6.71ZM274.64,653.64c.31.71.62,1.42.92,2.14,7.54-1.01,13.84,1.13,19.39,6.15,1.44,1.3,4.34,1.23,6.59,1.31,2.54.09,5.11-.53,7.66-.54,37.36-.15,73.33,6.35,107.29,22.46,4.1,1.95,8.31,3.69,12.46,5.52.42-.38.84-.76,1.27-1.14-.84-2.24-1.93-4.42-2.47-6.73-.72-3.09-1.85-6.43-1.34-9.41,1.66-9.69-5.89-16.7-15.32-13.69-4.89,1.56-9.66,3.51-14.59,4.88-7.32,2.03-13.92-1.26-16.46-8.05-.51-1.36-.15-3.04-.19-4.57,1.69.01,3.82-.64,5,.15,5.05,3.36,10.13,2.97,15.37.93,2.82-1.1,5.52-2.53,8.38-3.53,3.77-1.31,3.8-3.45,1.98-6.45-3.84-6.36-8.96-10.57-16.74-11.04-19.03-1.15-36.53,3.55-52.6,13.63-5.33,3.34-10.37,7.14-15.69,10.51-1.67,1.06-3.82,1.38-7.01,2.47.79-2.67.83-3.9,1.44-4.69,10.32-13.53,23.66-22.66,40.47-27.08-19.19-2.6-38.02-3.35-57.51-1.94,1.75,1.86,2.89,3.08,4.13,4.4-6.16,3.88-12.13,7.13-17.51,11.18-5.28,3.97-9.96,8.74-14.91,13.15ZM1693.2,1086.04c3.9-.85,9.42-1.74,14.77-3.27,39.72-11.31,70.18-35.66,94.59-68.15,4.12-5.49,7.01-12.08,9.6-18.51,2.31-5.71,2.67-11.89-1.34-17.35-4.79-6.52-9.75-6.05-13.95.78-5.24,8.51-10.22,17.3-16.42,25.08-25.92,32.51-60.21,49.72-101.31,53.94-9.69,1-12.58,5.95-8.57,14.83,4.05,8.99,11.85,11.91,22.64,12.64ZM569.38,478.57c.55,3.87.61,6.11,1.21,8.19,2.87,9.88,10.95,13.09,19.82,15.51,64.25,17.56,128.48,35.2,192.72,52.83,11.68,3.2,23.32,6.52,35,9.72,6.75,1.85,8.89.57,10.55-6.12.22-.9.2-1.89.55-2.74,1.83-4.43.04-5.95-4.35-7.14-29.22-7.92-58.31-16.35-87.53-24.26-28.54-7.72-57.18-15.08-85.8-22.48-20.5-5.3-41.11-10.24-61.56-15.72-6.42-1.72-12.51-4.69-20.6-7.79ZM319.58,1182.36c10.01,0,19.44-.1,28.87.02,17.73.23,29.19-9.19,37.26-23.91,2.02-3.68,3.7-7.55,5.96-11.06.79-1.22,2.87-1.62,4.36-2.39.43,1.44,1.39,2.95,1.19,4.3-1.18,8.1-2.75,16.1-8.14,22.74-.72.88-.89,2.21-2.01,5.15,13.55-4.28,25.49-7.99,37.37-11.9,1.41-.46,2.83-1.74,3.65-3.02,6.64-10.44,13.5-20.86,13.71-33.85.04-2.26-.7-5.26-2.23-6.55-1.06-.9-4.39.02-6.21,1.02-44.96,24.68-92.84,35.47-144.06,30.58-2.28-.22-4.58-.29-7.74-.48-1.57,11.88-10.71,17.16-20.08,22.76,7.58,2.33,14.76,4.17,22.06,5,13.53,1.54,25.29-2.63,34.89-12.48,1.46-1.5,2.83-3.14,4.49-4.4,7.14-5.4,18.49-2.55,21.7,6.4-11.09-1.59-19.57,1.97-25.02,12.08ZM546.64,537.21c-.16.58-.32,1.15-.48,1.73,3.08,1.89,6.07,3.94,9.25,5.65,10.65,5.73,21.71,10.8,32.01,17.1,45.32,27.71,90.38,55.85,135.65,83.63,15.29,9.38,30.94,18.18,46.43,27.22,6.79,3.96,8.41,3.54,12.2-3.01.47-.81.78-1.74,1.37-2.43,3.21-3.79,1.65-5.86-2.18-8.08-15.92-9.23-31.72-18.66-47.48-28.16-46.1-27.78-92.08-55.76-138.31-83.32-6.7-3.99-14.32-6.8-21.86-8.89-8.65-2.41-17.71-2.19-26.6-1.43ZM1813.28,916.17c-.91,7.04-2.17,16.5-3.35,25.98-.67,5.37,1.13,7,6.28,5.65,7.22-1.89,13.14-6.14,15.22-13.19,2.34-7.93,4.09-16.35,4.18-24.58.37-36.22-10.73-69.27-29.36-100-5.24-8.63-11.39-16.56-19.84-22.32-2.65-1.81-5.63-3.42-8.69-4.28-7-1.97-12.81,1.3-17,8.97-2.65,4.86-1.91,7.44,3.89,13.34,1.14,1.16,2.34,2.28,3.52,3.41,29.8,28.47,43.19,63.97,45.15,107.02ZM163.08,679c-26.89,13.94-39.34,35.25-41.5,63.06-.23,2.91-2.28,7.33,1.88,8.49,1.68.47,4.84-2.82,6.73-4.94,26.9-30.14,59.1-52.51,96.82-67.03,4.25-1.64,8-4.65,11.88-7.17,6.03-3.93,11.64-8.68,18.06-11.77,4.87-2.34,8.68-5,11.44-9.62,5.56-9.3,13.68-15.76,23.42-20.32,1.78-.83,3.49-1.82,6.31-3.3-2.2-.4-3.08-.77-3.92-.68-14,1.41-27.65,4.07-40.22,10.86-11.44,6.18-19.55,15.56-26.62,26.2-2.65,3.99-5.99,7.84-9.83,10.64-5.36,3.92-11.28,2.68-15.15-2.02,4.94-3.6,10.5-6.6,14.64-10.96,4.34-4.56,7.32-10.42,11.31-16.31-1.71,0-2.41-.15-3.01.02-31.94,9.33-53.86,28.79-62.42,61.76-.47,1.79-.96,3.66-1.88,5.23-.7,1.19-2.11,1.96-3.2,2.92-.64-.25-1.29-.49-1.93-.74.22-11.28,2.58-22.25,7.19-34.35ZM1666.68,997.97c-9.97-6.73-11.97-11.58-9.13-21.33,1.66-5.71,5.17-10.08,10.78-12.05,7.67-2.69,15.49-5.03,23.35-7.14,8.89-2.4,16.55.81,23.33,6.32,3.64,2.95,5.21,7.09,4.68,11.86-.2,1.78-.46,3.56-.74,5.71,1.45.32,2.54.75,3.63.75,3.51,0,17.45-9.53,18.07-12.87.44-2.35.05-5.18-.98-7.3-.41-.85-3.55-.34-5.44-.52-2.72-.26-5.8.14-8.09-1-7.71-3.86-13.33-9.95-13.77-18.86-.61-12.31,1.86-24.26,8.34-34.87,6.87-11.24,21.72-12.47,30.67-3.06.25.26.85.2,2.53.56,1.41-3.46,4.27-7.23,4.07-10.83-.24-4.34-2.79-8.69-4.89-12.75-1.96-3.79-5.21-6.29-9.7-6.74-4.76,15.95-13.75,19.92-29.13,13.33-10.75-4.61-18.05-12.93-24.24-22.45-1.03-1.59-2.15-3.12-3.33-4.84-1.71,4.48-3.15,8.23-4.71,12.3,8.42,2.44,15.31,6.92,19.96,14.41,3.23,5.2,3.12,7.83-.37,12.75-.85,1.2-1.42,2.6-2.15,3.96,10.85,4.57,12.19,6.92,10.53,18.31-.5,3.46-.93,6.99-2.02,10.28-1.51,4.54-1.37,8.58,1.35,12.62,2.19,3.24,1.56,6.48-1.69,8.49-3.09,1.92-6.1,1.38-8.62-1.71-4.35-5.33-4.5-5.32-10.17-.98-5.78,4.42-12.06,6.87-19.48,6.15-4.84-.47-7.8-2.62-8.47-7.61-.22-1.65-.78-3.26-1.27-5.27-1.31.88-2.02,1.14-2.41,1.65-6.64,8.65-12.13,8.08-20.35.27-1.51-1.43-2.79-3.14-4.01-4.83-6.46-8.96-5.02-13.51,5.22-17.28,2.03-.75,3.82-2.12,5.73-3.21-.28-.65-.56-1.29-.84-1.94-2.39.45-4.8.84-7.17,1.37-8.09,1.84-10.54.3-12.1-7.91-.39-2.05-.28-4.19-.67-6.24-.28-1.44-1.03-2.78-1.56-4.17-.54-.07-1.08-.13-1.62-.2-.71,1.7-1.87,3.36-2.06,5.11-.92,8.88-6.28,14.84-12.82,20.02-4.75,3.76-10.14,3.57-15.13.96-2.38-1.24-3.91-4.11-5.84-6.27-7.59,10.54-1.94,28.97,9.15,30.33.31-.34.78-.62.91-1.02,4.43-13.64,13.49-17.55,26.35-11.03,12.57,6.37,21.49,16.2,26.36,29.5.86,2.36,1.31,4.98,1.41,7.5.27,6.63-2.45,10.47-8.6,12.81-1.84.7-3.66,1.45-5.49,2.18,1.24,3.01,1.97,5.47,3.24,7.62.71,1.2,2.7,2.92,3.45,2.63,6.05-2.26,10.83.76,15.5,3.51,3.54-2.36,6.74-4.5,10.43-6.97ZM1527.16,305.75c-.59.4-1.17.81-1.76,1.21,1.17,3.17,1.91,6.59,3.58,9.46,15.02,25.8,30.2,51.49,45.32,77.23,1.78,3.03,3.96,4.89,7.88,4.56,1.79-.15,3.87.84,5.54,1.79,3.74,2.14,7.06,5.27,11.02,6.74,6.02,2.23,9.98,5.84,11.55,12,4.32,16.98,8.02,34.06,8.32,51.68.2,12.14-3.54,15.78-15.83,15.63-1.16-.01-2.34-.05-3.49-.19-3.29-.41-6.63-1.27-7.58,3.56-1,5.11.9,11.91,3.96,13.21,4.59,1.94,13.02-.41,15.49-4.92,3.47-6.32,7-12.72,9.37-19.49,4.87-13.87,2.66-28.16.96-42.27-2.99-24.79-12.02-47.83-20.99-70.89-4.65-11.95-12.17-21.48-22.78-28.49-11.09-7.32-22.33-14.41-33.63-21.39-5.49-3.39-11.28-6.31-16.94-9.44ZM574.81,666.08c2.22,2.51,3.09,3.83,4.27,4.77,10.25,8.08,20.27,16.51,30.94,23.99,8.73,6.12,17.74,12.43,27.56,16.3,21.22,8.36,43.02,15.24,64.63,22.58,1.47.5,3.37-.3,5.08-.49-.39-1.64-.34-3.6-1.25-4.86-5.07-6.97-10.48-13.7-15.55-20.67-3.06-4.2-6.32-6.7-11.76-4.26-3.74,1.68-6.8-.19-9.41-2.76-2.79-2.75-3.16-6.01-1.82-9.66,2.92-7.92,2.75-8.13-3.98-13.05-20.69-15.12-44.09-19.34-68.98-16.79-6.26.64-12.34,3.01-19.72,4.9ZM1144.45,998.89c-.07-.74-.15-1.48-.22-2.21-1.57-.9-3.03-2.18-4.72-2.64-17.93-4.93-35.83-10.06-53.9-14.41-7.36-1.77-14.72.09-21.61,3.73-2.73,1.45-6.14,2.22-9.25,2.25-25.87.23-51.73.13-77.6.31-6.31.05-11.65-1.05-16.49-5.79-5.61-5.48-12.75-3.61-15.78,3.61-1.89,4.49-3.24,9.23-4.58,13.93-1.7,5.92-.35,7.71,5.94,7.57,6.99-.15,13.96-.91,20.95-.95,46.37-.27,92.74-.37,139.11-.66,7.91-.05,15.85-.41,23.71-1.27,4.89-.53,9.64-2.27,14.45-3.47ZM204.61,783.62c.16,4.25,2.42,6.93,5.83,7.09,1.63.08,4.18-2.66,4.95-4.65,1.78-4.63.54-8.94-2.49-13.09-1.2-1.64-1.33-5.06-.41-6.92.76-1.53,4.17-3.15,5.72-2.64,6.52,2.14,8.06-2.07,10.02-6.55,14.06-32.14,28.81-63.86,54.88-88.59,1.19-1.13,2.5-4.02,1.97-4.68-1.28-1.62-3.64-3.41-5.51-3.35-6,.19-12.22.38-17.93,2.04-13.97,4.06-23.96,14.2-33.57,24.38-18.27,19.32-26.08,42.71-25.09,69.07.35,9.44,5.24,18.61,1.63,27.88ZM1356.75,30.34c-.18-12.94-6.33-20.43-17.59-22.85-7.03-1.51-14.24-2.3-21.39-3.18-7.73-.95-9.76.75-9.99,8.45-.21,6.98.25,13.99-.18,20.95-.93,15.09-2.22,30.17-3.43,45.24-.34,4.26-.75,8.43,3.24,11.44,13.74,10.38,30.64,5.07,35.77-11.28,3.2-10.21,6.52-20.4,9.43-30.7,1.89-6.7,3.13-13.57,4.14-18.07ZM1101.69,518.72c-7.35,1.55-16.5,2.45-24.89,5.46-23.88,8.56-47.44,17.99-71.13,27.08-1.08.42-2.23.78-3.17,1.42-3.26,2.24-3.5,4.84-.59,7.42,1.38,1.22,3.02,2.23,4.68,3.03,12.78,6.15,25.67,12.07,38.37,18.39,7.62,3.79,13.96,2.65,20.63-2.53,17.65-13.72,35.66-26.97,53.49-40.47,2.78-2.1,5.53-4.31,7.96-6.79,4.73-4.83,4.22-7.64-2.23-9.22-6.96-1.71-14.17-2.39-23.14-3.81ZM1213.57,915.57c.61-.11,1.23-.22,1.84-.33,1.97-6.93,1.78-14.04.75-21.14-2.19-15.02.33-29.21,6.76-42.88,7.95-16.91,16.9-33.19,27.4-48.71,4.47-6.61,6.93-14.61,10.02-22.09.61-1.47-.07-3.48-.16-5.24-1.97.11-4.16-.3-5.85.44-3.61,1.57-7.41,3.23-10.35,5.76-9.88,8.49-19.56,17.23-28.93,26.28-1.58,1.53-1.24,5.04-1.81,7.63-.42,1.9-.44,4.05-1.38,5.64-2.01,3.4-4.6,6.44-6.77,9.74-3.34,5.08-7.4,8.38-13.83,9.53-11.14,1.99-16.02,13.7-10.14,23.31,8.88,14.53,17.95,28.93,26.95,43.38,1.81,2.91,3.67,5.8,5.51,8.69ZM1176.5,590.38c.12.82.23,1.65.35,2.47,3.34,0,6.7.25,10.02-.04,16.48-1.46,32.96-2.94,49.41-4.64,20.65-2.13,41.15-5.06,61.05-11.35,7.96-2.52,15.97-5.3,24.17-6.52,11.94-1.78,23.65.9,35.09,4.45,3.15.98,6.29,1.99,9.22-.65,7.25-6.52,5.29-16.8-4.03-19.51-19.13-5.56-38.55-7.55-57.82-1.06-25.36,8.55-51.37,13.25-78.01,15.02-19.17,1.27-34.4,11.43-49.46,21.83ZM1365.47,766.9c6.2-.25,9.09-2.44,10.75-6.08,1.15-2.53,1.92-5.25,2.68-7.94,11.33-40.13,22.64-80.26,33.93-120.4,4.42-15.69,8.91-31.37,13.1-47.12,1.92-7.22-.06-11.81-6.35-14.29-5.38-2.12-11.08-3.58-16.75-4.78-4.32-.91-7.79,1.15-9.76,5.11-1.13,2.27-1.99,4.72-2.68,7.17-12.92,45.49-25.8,90.99-38.68,136.48-3.05,10.76-6.12,21.51-9.11,32.28-1.81,6.52-1.25,10.35,3.12,12.31,6.96,3.13,14.34,5.31,19.77,7.25ZM116.65,722.76c-.52-.18-1.03-.36-1.55-.53-11.07,10.84-20.9,22.49-22.45,38.86-.72,7.64-.86,15.35-.94,23.03-.07,6.85-2.43,12.39-8.43,15.83-1.71.98-4.13.74-6.22,1.07.41-1.86.31-4.06,1.3-5.51,4.76-6.95,3.65-14.25,1.83-21.9-3,3.97-5.04,8.27-7.28,12.45-11.55,21.54-14.72,43.54-3.98,66.44,1.25,2.67,2.32,5.7-1.07,8.59-6.14-5.82-7.89-14.37-13.59-21.66-3.21,11.47-5.04,21.94-5.42,32.66-.46,12.94,3.99,24.26,11.71,34.38,1.13,1.48,3.26,2.18,4.92,3.25.88-1.76,2.24-3.43,2.55-5.28.54-3.2.46-6.51.59-9.77.75-18.28,3.81-36.19,9.01-53.69,8.1-27.27,20.22-52.64,36.85-75.78,2.47-3.44,3.76-6.76,2.03-11.03-3.28-8.06-2.88-16.41-1.24-24.77.43-2.21.91-4.41,1.37-6.62ZM205.67,1156.26c1.59,1.08,2.58,2.04,3.76,2.51,8.01,3.17,15.94,6.61,24.12,9.24,14.71,4.72,26.93-1.35,38.2-10.05,3.21-2.48,2.57-5.24-1.35-6.76-2.81-1.09-5.82-1.69-8.78-2.32-46.65-9.87-86.82-31.83-120.9-65-4.27-4.15-7.89-6.89-14.42-5.02-4.02,1.15-8.75-.2-13.16-.45-1.73-.1-3.46-.29-5.24-.44,0,1.03-.19,1.62.03,1.9,1.84,2.4,3.77,4.73,5.64,7.11,10.38,13.23,22.39,22.82,40.78,21.22,7.31-.64,15.57,7.5,16.8,14.6.16.95-.22,2.52-.9,2.96-.71.47-2.31.27-3.12-.25-2.34-1.51-4.37-3.51-6.72-5-4.24-2.68-8.69-3.56-15.09-.22,12.99,8.35,24.6,16.45,36.85,23.44,6.33,3.61,13.93,3.61,21.19,1.76,5.19-1.32,10.29-3.02,15.52-4.14,2.05-.44,4.35.24,8.05.52-6.41,7.79-14.49,9.56-21.26,14.39ZM1547.06,395.02c4.71,6.43,4.22,10.91-.23,15.35-1.01,1.01-.38,4.42.45,6.31,1,2.27,2.97,4.13,4.6,6.1,11.55,14.06,22.16,28.67,29.33,45.61,4.16,9.84,11.72,13.4,23.36,12.51,9.21-.7,11.32-2.59,10.05-11.79-2.12-15.41-5.12-30.7-7.56-46.07-1.18-7.43-5.65-11.18-12.59-13.17-9.38-2.7-18.62-5.91-27.93-8.85-5.87-1.86-11.78-3.63-19.48-6ZM1915.13,834.4c-.57-2.96-.71-4.74-1.27-6.37-1.79-5.29-3.97-10.47-5.58-15.82-2.95-9.84-7.91-17.34-19.11-18.82-1.2-.16-2.18-1.96-3.26-3,1.24-1.22,2.28-2.85,3.76-3.54,1.73-.8,3.85-.77,6.72-1.25-7.32-13.38-14.29-25.69-23.76-36.39-3.4-3.84-7.82-4.86-12.75-3.55-1.58.42-3.16,1.48-4.66,1.33-2-.2-3.92-1.28-5.88-1.98,1.14-1.74,1.9-4.09,3.5-5.09,2.62-1.63,5.78-2.37,8.66-3.47-4.11-12.09-14.61-16.86-26.67-13.07-1.91.6-4.15.13-6.23.15.85-2.42,1.15-5.3,2.69-7.14,1.63-1.95,4.44-2.91,7.28-4.65-6.6-7.43-13.07-13.83-23.14-13.39-4.32.19-8.51,2.33-12.85,3.07-4.16.71-8.43.76-12.65,1.09,1.55,2.47,3.44,3.68,5.33,4.9,17.51,11.29,33.6,24.31,47.93,39.46,18.43,19.49,33.01,41.54,44.29,65.85,1.15,2.48,3.27,5.59,5.54,6.2,3.41.92,5.04,2.77,6.68,5.42,3.3,5.36,8.15,8.38,15.42,10.04ZM73.25,1026.62c3.77,6.55,7.88,12.93,11.24,19.68,7.08,14.27,18.62,22.32,33.96,25.25,1.97.37,4.21-.72,6.33-1.13-.47-2.06-.39-4.51-1.51-6.13-4.52-6.49-9.72-12.52-14.11-19.1-24.09-36.07-37.07-75.99-40.66-119.09-.23-2.77-.22-5.15-3.13-7.17-4.69-3.25-8.79-7.37-13.1-11.17-1.4-1.23-2.66-2.62-4.98-4.94-1.52,17.73-1.91,33.38,9.84,46.48,2.49,2.77,4.58,5.89,7.06,8.68,5.27,5.93,5.1,12.71,3.3,19.76-.39,1.54-1.06,3.01-1.61,4.51-.86-.51-1.73-1.02-2.59-1.53-2.69-7.2-1.75-16.55-11.85-20.62.46,2.77.58,4.75,1.12,6.62,2.58,8.95,5.33,17.86,7.92,26.81,2.85,9.84,8.73,17.47,17.09,23.13,4.22,2.86,8.93,5,13.29,7.67,2.19,1.34,5.55,2.17,4.22,6.07-5.5.74-10.71-.44-21.83-3.8ZM502.28,327.75c-3.27-.42-6.37,1.06-8.55,4.66-9.5,15.72-19.24,31.31-28.51,47.17-4.2,7.19-2.86,9.23,5.48,11.56,4.47,1.25,9.02,2.43,13.22,4.35,11.72,5.37,24.39,2.13,30.1-9.44,4.69-9.5,7.91-19.77,11.25-29.88,4.36-13.18-10.04-27.45-23-28.43ZM1205.61,961.35c6.25-.1,10.47-1.79,12.84-5.86,4.31-7.41,8.72-14.87,11.92-22.78,5.06-12.53,3.33-25.69,1.74-38.7-1.77-14.55.61-28.31,7.88-41.16,3.1-5.48,5.95-11.09,9.03-16.58,16.32-29.03,34.65-56.45,61.85-76.72.37-.28.7-.61,1.06-.91,3.26-2.72,2.52-5.6.44-8.63-2.33-3.38-4.95-2.91-7.69-.68-5.23,4.27-10.76,8.24-15.56,12.96-27.79,27.34-48.34,59.63-64.25,95.02-4.38,9.75-5.85,20-5.07,30.71.85,11.84,1.36,23.71,1.74,35.57.41,12.71-1.97,23.88-16.6,27.81-3.21.86-4.34,3.93-3.21,6.73.69,1.7,3.17,2.66,3.89,3.22ZM1463.26,680.5c.74.24,1.49.48,2.23.72,1.81-1.34,3.61-2.69,5.42-4.03,6.74-5,13.4-10.12,20.26-14.95,7.32-5.16,8.06-6.91,4.3-15.05-14.07-30.49-28.23-60.94-42.42-91.37-.57-1.22-1.82-2.12-2.75-3.17-.49.21-.98.42-1.47.63,4.72,42.42,8.88,84.91,14.43,127.24ZM1644.03,818.8c-.93-2.23-1.51-3.74-2.17-5.2-6.74-14.83-13.44-29.68-20.27-44.47-4.88-10.56-9.93-21.05-14.93-31.55-3.45-7.23-4.2-7.49-11.69-4.23-2.56,1.11-5.11,2.25-7.66,3.39-7.6,3.39-8.35,5.35-4.84,12.83,6.13,13.06,12.3,26.11,18.42,39.18,5.33,11.38,10.57,22.8,15.92,34.18,3.5,7.45,4.52,7.9,12.31,4.92,3.68-1.41,7.29-3.1,10.73-5.02,1.66-.93,2.85-2.69,4.19-4.01ZM1893.32,1003.8c-1.38,2.59-2.69,4.66-3.63,6.88-7.35,17.5-16.62,33.94-28.11,49.03-16.35,21.46-34.88,40.71-58.04,55.02-2.92,1.81-4.8,3.88-4.85,7.8-.03,2.08-1.85,4.54-3.52,6.13-5.57,5.32-8.2,11.96-9.77,19.45,7.16-3.24,13.67-7.16,20.36-10.76,6.01-3.23,10.35-7.95,13.18-14.01,1.26-2.7,1.67-5.8,2.76-8.6.68-1.76,1.91-3.31,2.9-4.96,1.01,1.54,2.11,3.03,3,4.64.71,1.3,1.16,2.74,1.9,4.54,10.24-6.29,17.5-14.79,25.25-22.79,6.7-6.92,9.59-14.69,7.07-24.19-.3-1.12-.68-2.43-.36-3.43.44-1.37,1.32-2.83,2.44-3.64.39-.28,2.55,1,3.1,2.01,1.51,2.75,2.6,5.74,3.85,8.63.58.14,1.16.28,1.74.43,3.43-5.92,7.25-11.65,10.14-17.83,2.04-4.36-.24-8.57-2.64-12.48-.53-.86-.24-3.21.41-3.59,1.14-.66,3.18-.89,4.27-.29,2.09,1.17,3.79,3.05,5.62,4.61,10.22-10.7,11.59-29.1,2.93-42.62ZM770.71,803.31c-10.01-11.45-19.9-24.19-31.33-35.35-8.03-7.84-19.38-9.84-30.59-9.75-2.07.02-5.9,2.07-5.89,3.15.06,6.24-2.75,10.43-7.94,12.94.41,1.14.45,1.7.74,1.99,12.47,12.22,24.57,24.84,37.58,36.45,8.72,7.79,19.75,7.53,31.8,5.6-4.94-10.27,1.14-13.86,5.64-15.03ZM1653.06,904.16c7.33-4.18,12.66-7.92,18.53-10.38,6.06-2.54,6.45-2.42,5.2-8.92-4.12-21.4-16.17-39.49-24.71-59.04-.45-1.02-3.33-2.02-4.46-1.54-8.13,3.42-16.11,7.2-24.11,10.91-3.44,1.59-3.99,4.27-2.53,7.54,6.45,14.43,12.52,29.05,19.55,43.19,3.34,6.71,8.52,12.51,12.53,18.24ZM1669.08,667.13c.18.7.36,1.41.54,2.11,12.78,1.66,25.67,2.74,38.31,5.13,12.55,2.37,25.07,5.39,37.21,9.34,12.25,3.99,24.02,9.46,36.31,14.42v-5.14c10.06,3.63,19.19,1.52,29.77-3.8-8.32-5.31-15.41-10.02-22.7-14.42-9.27-5.6-18.41-5.82-27.34,1.09-1.35,1.05-3.67.85-5.54,1.23.43-2.29.2-5.04,1.43-6.74,1.79-2.48,4.62-4.19,8.13-7.19-7.91-3.25-14.5-7.3-21.59-8.58-14.79-2.68-30.51-6.51-40.61,10.42-.61,1.02-3.03,1.85-4.11,1.45-1.05-.39-2.05-2.48-2.06-3.84-.03-4.31-2.4-5.42-5.91-4.53-5.61,1.43-11.19,3.04-16.63,5.01-1.97.71-3.49,2.67-5.21,4.05ZM1926.15,904.57c.64-2.42,1.59-4.33,1.58-6.23-.06-8.68-3.26-15.82-10.72-20.81-1.74-1.16-3.01-3.02-4.49-4.56,1.88-.97,3.67-2.49,5.65-2.79,3.33-.51,5.82-2.05,5.01-5.29-1.44-5.78-2.39-12.58-6.07-16.68-5.64-6.27-13.42-10.61-21.41-16.61.47,2.56.59,3.66.88,4.72,2.72,9.88,6.09,19.62,8.09,29.64,7.13,35.7,6.95,71.29-2.46,106.7-1.32,4.95-.55,10.48-.54,15.75,0,2.9.83,5.82.61,8.68-.43,5.71.73,10.78,4.26,15.58,4.15-5.89,11.77-26.36,11.35-32.36-.29-4.03-1.94-8.02-3.32-11.91-.86-2.45-4.39-4.76-1.33-7.19,1.08-.87,4.35,1.03,6.64,1.62.42.11.89.02,2.22.02.64-2.34,1.66-4.89,1.99-7.53,1.07-8.32,1.7-16.7,2.84-25.01,1.37-9.92-.3-18.18-10.61-22.49-.21-.09-.51-.21-.57-.39-.56-1.76-1.08-3.53-1.61-5.3,1.64-.25,3.39-.98,4.9-.64,2.18.49,4.19,1.76,7.11,3.08ZM1456.88,553.01c1.52,3.9,2.76,7.64,4.4,11.2,11.86,25.81,23.82,51.57,35.71,77.36q5.84,12.65,18.13,5.79c6.84-3.81,7.11-4.71,3.7-12.09-7.52-16.27-15.04-32.54-22.55-48.81-5.37-11.62-10.6-23.31-16.13-34.85-3.4-7.11-15.46-9.13-20.78-3.59-1.18,1.23-1.61,3.17-2.49,4.98ZM1421.99,492.93c-.47,2.19-.83,2.89-.72,3.51,4.07,22.18,2.99,45.14,10.23,66.84.73,2.18,1.01,4.57,1.09,6.88.3,8.81-.19,17.69.74,26.43,3.45,32.41,7.34,64.77,11.07,97.15.47,4.07,2.67,5.15,6.29,3.14,4.74-2.62,6.99-8.04,6.23-14.42-2.96-24.98-5.79-49.97-8.79-74.94-2.83-23.58-5.65-47.16-8.8-70.69-2.07-15.45-8.69-29.25-17.34-43.9ZM1741.47,765.24c-.89-8.77-6.34-15.96-14.94-20.79-14.88-8.35-31.22-11.9-47.98-13.75-4.98-.55-6.37.99-5.53,6.09,1.28,7.8,3.09,15.52,4.43,23.32.97,5.64,4.23,8.63,9.7,9.36,13.7,1.84,26.85,5.39,39.41,11.33,2.19,1.04,6.27.5,8.27-.97,4.2-3.07,6.68-7.69,6.64-14.6ZM304.38,668.2c-.14.48-.28.97-.41,1.45,9.18,4.8,18.23,9.86,27.58,14.27,4.58,2.16,9.62,3.78,14.62,4.52,31.1,4.6,60.11,14.81,86.88,31.36,1.05.65,2.38.87,4.36,1.56-.41-3.49-1.1-6.21-.97-8.89.43-8.88-3.94-14.07-11.6-18.06-36.83-19.15-76.08-27.47-117.38-27.05-1.03.01-2.06.55-3.09.84ZM1190.58,515.07c.12-.48.23-.95.35-1.43-1.37-.6-2.7-1.38-4.13-1.75-7.66-2-15.35-3.94-23.04-5.82-30.13-7.38-60.26-8.77-90.63-.94-37.12,9.56-72.82,23.08-108.14,37.7-1.7.7-3.54,1.6-4.66,2.95-.85,1.03-1.28,3.21-.75,4.34.51,1.08,2.44,1.78,3.86,2.07,1.01.21,2.24-.48,3.33-.87,25.02-8.89,50.28-17.17,74.99-26.87,24.72-9.71,50.09-14.71,76.5-13.59,17.44.74,34.82,2.92,52.25,4.14,6.66.47,13.38.08,20.07.08ZM1432.41,310.97c-4.76,1.83-5.53,5.46-5.06,9.27.33,2.7,1.46,5.38,2.61,7.9,6.29,13.78,12.77,27.48,19.06,41.26,14.81,32.45,29.54,64.93,44.31,97.39,6.51,14.3,17.27,19.21,31.85,14.27-.88-1.16-1.57-2.34-2.51-3.27-10.72-10.69-19.04-22.85-23.91-37.34-2.62-7.8-7.78-13.49-15.47-17.15-9.35-4.46-12.16-10.62-9.63-20.6,1.48-5.84.78-10.88-2.24-16.04-9.32-15.88-18.29-31.97-27.65-47.83-4.75-8.05-10.02-15.79-9.85-25.69,0-.54-.73-1.09-1.51-2.16ZM536.15,715.85c.11.54.21,1.08.32,1.61,1.48,0,2.97.11,4.44-.02,14.99-1.33,29.73-.3,44.38,3.42,16.93,4.3,33.92,8.41,51.01,12.01,19.37,4.07,38.88,7.51,58.34,11.15,2.97.56,7.14,3.09,8.45-1.35,1.36-4.6-3.55-5.12-6.56-6.57-.21-.1-.44-.17-.65-.25-25.12-9.23-50.27-18.38-75.33-27.75-6.61-2.47-13.05-3.37-19.7-.6-11.06,4.62-22.56,4.98-34.34,4.24-6.67-.42-13.47.3-20.15,1.05-3.47.39-6.81,1.99-10.2,3.05ZM1493.75,1023.73c33.73,60.1,115.96,110.37,211.44,92.58,86.95-16.2,155.21-88.38,165.37-178.24,9.82-86.93-35.47-163.23-89.92-194.71,33.65,25.12,58.83,56.82,74.7,95.74,16.05,39.37,17.48,79.88,8.38,120.89-9.17,41.31-30.12,76-61.24,104.58-82.93,76.17-227.62,76.54-308.72-40.85ZM78.78,540.49c-1.55-1.44-2.9-3.38-4.76-4.26-3.56-1.7-7.42-2.75-11.12-4.14-8.1-3.06-10.54-1.95-13.73,6.26-3.46,8.9-6.93,17.8-10.45,26.68-5.41,13.65-10.87,27.27-16.29,40.92-.69,1.73-1.22,3.52-1.91,5.26-1.5,3.75-1.04,7.01,2.77,8.94,4.03,2.06,6.03-1.03,7.8-3.79,14.99-23.33,29.93-46.7,44.85-70.09.99-1.55,1.65-3.32,2.85-5.78ZM1223.46,594.82c-2.31-.64-3.21-1.15-4.06-1.08-16.26,1.45-32.55,2.67-48.74,4.7-3.5.44-7.07,3.38-9.81,6-2.63,2.51-4.54,5.94-6.22,9.24-5.04,9.89-8.73,20.28-7.21,31.55.4,2.97,3.42,5.59,5.23,8.37,2.12-1.54,4.67-2.73,6.29-4.68,8.18-9.88,16.28-19.84,24.09-30.01,5.74-7.47,12.84-10.35,22.07-8.43,1.93.4,4.51.68,5.99-.26,5.56-3.52,9.14-8.77,12.38-15.4ZM1449.67,541.22c6.05-7.86,6.27-8.04,14.27-2.98,4.7,2.97,9.17,2.77,13.89.55,9.05-4.27,18.11-8.5,27.12-12.84,2.92-1.41,5.98-2.79,8.44-4.83,1.57-1.3,3.44-4.26,2.93-5.67-2-5.54-3.84-11.81-7.78-15.78-3.4-3.42-8.02,1.5-11.89,3.21-13.61,6.01-27.12,12.25-40.71,18.31-10.28,4.58-12.38,10.65-6.27,20.04ZM1552.81,294.82c-.78-1.97-1.79-6.14-3.91-9.64-4.72-7.76-10.27-15.01-14.97-22.78-4.38-7.23-10.26-11.16-18.8-11.23-4.3-.04-9.49-2.16-12.64-.4-3.31,1.85-4.55,7.27-6.91,11-2.5,3.94-1.92,6.74,2.15,9.27,16.05,9.95,31.96,20.15,48.02,30.09,5.17,3.2,7.19,1.87,7.05-6.31ZM873.98,979.18c-6.13,3.58-6.02,8.4-5.58,12.93.43,4.41,4.3,4.73,7.84,5.45,6.15,1.24,12.42,2.3,18.29,4.42,9.4,3.39,18.53,7.53,27.73,11.45,3.14,1.34,6.68,3.06,8.3-1.24,3.53-9.36,6.62-18.89,9.4-28.5.43-1.49-1.24-4.47-2.78-5.49-4.03-2.66-8.62-4.46-12.81-6.91-3.15-1.84-5.29-1.01-7.04,1.77-1.49,2.37-2.79,4.85-4.27,7.22-8.98,14.33-25.97,15.52-36.89,2.56-.89-1.06-1.45-2.39-2.19-3.66ZM286,899.32c1.22,11.82,2.23,21.78,3.3,31.73.38,3.56,1.64,6.57,6.02,6,11.31-1.46,22.63-2.92,33.9-4.7,3.41-.54,6.07-2.6,5.58-6.75-1.28-10.87-2.52-21.74-3.93-32.59-.54-4.19-3.19-5.98-7.41-5.44-9.93,1.28-19.88,2.38-29.78,3.87-5.74.86-7.84,3.89-7.68,7.88ZM798.06,727.89c-4.57-1.9-7.91-4.24-11.42-4.56-7.85-.7-15.79-.38-23.69-.5-4.6-.07-6.91,2.27-6.98,6.78-.07,5.11-.2,10.23.05,15.33.26,5.35,1.95,6.97,7.38,7.1,7.9.18,15.81.03,23.72.07,4.7.02,7.3-2.28,8.17-6.87.56-2.94,1.41-5.82,2.21-9.04.38,2.71.11,5.33,1.18,7.17.99,1.69,3.32,3.27,5.25,3.55,1.99.29,6.03-.99,6.05-1.68.19-6.07-.27-12.17-.73-18.25-.04-.57-1.38-1.13-2.2-1.54-4.41-2.21-7.53-.5-8.99,2.44ZM859.79,552.06c0,6.69,1.69,13.3-.48,18.22-2.13,4.85-8.16,7.99-12.49,11.9,8.63,9.68,23.1,11.74,35.52,5.12,8.58-4.57,17.52-8.48,26.3-12.7,2.15-1.03,4.28-2.1,6.42-3.15-.05-.65-.09-1.3-.14-1.95-18.36-5.81-36.73-11.62-55.13-17.45ZM1610.34,840.73c-4.92-6.57-58.88-37.33-66.04-38.28,1.66,7.55-.97,13.19-8.51,16.07,1.09,1.35,1.4,2.04,1.93,2.34,14.77,8.38,29.52,16.8,44.41,24.97,2.33,1.28,5.58,2.44,7.94,1.83,6.62-1.71,13-4.36,20.28-6.93ZM573.34,706.24c-2.84-2.44-4.46-3.99-6.24-5.33-5.78-4.33-11.91-8.26-17.37-12.97-5.04-4.34-9.84-4.6-15.29-1.38-10.03,5.92-20.11,11.76-30.12,17.72-7.29,4.33-7.69,7.19-2.26,13.54,2.21,2.58,4.67,3.68,8.02,2.26,1.92-.82,3.98-1.33,5.96-2.01,17.01-5.85,34.08-11.41,52.48-10.17,1.01.07,2.08-.68,4.82-1.66ZM72.41,597.99c13.04-18.43,26.38-37.21,39.62-56.07,2.25-3.2.06-4.69-2.8-5.4-8.41-2.1-24.07,3.52-28.42,11.16-6.8,11.92-12.78,24.31-19.15,36.48-1.56,2.99-.26,4.5,2.25,6.22,2.86,1.96,5.23,4.63,8.49,7.61ZM1643.05,898.64c-2.91-5.03-5.66-9.26-7.87-13.75-2.98-6.06-5.48-12.36-8.32-18.49-1.84-3.96-4.89-5.93-9.02-3.48-8.33,4.93-17.04,7.23-26.75,5.63-3.96-.66-6.03,1.73-6.46,5.61-1.15,10.47,2.46,14.17,9.76,15.64,14.62,2.96,29.17,6.24,43.78,9.29,1.21.25,2.57-.22,4.89-.46ZM412.36,912.26c.23-.83.45-1.66.68-2.49-1.47-.68-3-1.26-4.4-2.06-13.34-7.56-26.59-15.25-40-22.68-5.03-2.78-7.1-1.17-6.89,4.87.37,10.43.81,20.86,1.2,31.3.26,7,2.56,9.15,9.21,6.81,12.68-4.47,25.11-9.65,37.64-14.55.88-.34,1.71-.8,2.57-1.2ZM1374.29,284.47c.32.21.64.43.96.64-1.83,3.3-2.96,7.41-5.64,9.72-5.78,4.99-12.88,1.79-15.26-6.25-1.56-5.27-3.9-6.45-7.58-3.75-3.25,2.39-3.17,5.04-1.13,8.44,6.44,10.74,12.67,21.6,18.82,32.51,2.81,4.97,4.01,5.74,8.54,2.63,5.15-3.55,9.96-7.62,14.75-11.67,2.96-2.51,3.4-5.86,2.32-9.56-3.06-10.47-5.89-21-9.15-31.41-.55-1.76-2.84-4.28-4.22-4.21-3.22.16-4.55,2.78-3.85,6.09.48,2.27.96,4.55,1.44,6.82ZM412.96,599.44c8.9,12.45,18.97,23.28,34.09,28.13,5.75,1.85,11.46,3.87,17.07,6.1,11.66,4.63,19.02,1.56,24.95-11.5-24.19-11.41-49.29-19.51-76.11-22.73ZM440.75,697.92c-2.33,7.64-1.87,14.44,1.8,19.79,4.93,7.18,11.33,13.36,17.2,19.87.69.76,2.05,1.26,3.11,1.28,6.39.09,14-9.07,13.21-15.42-.71-5.69-.89-11.45-1.62-17.14-.44-3.41-1.03-6.93-2.35-10.07-3.61-8.59-6.9-9.47-13.98-3.68-5,4.09-9.95,7.68-17.37,5.38ZM1293.89,129.67c.61-6.64-2.73-12.38-9.63-15.2-7.28-2.97-14.91-5.25-22.56-7.11-6.73-1.64-7.65-.36-7.78,6.48-.29,16.29-.77,32.58-1.15,48.88-.03,1.38-.37,3.09.29,4.07.87,1.3,2.59,2.04,3.94,3.02.47-1.37,1.37-2.75,1.32-4.1-.07-1.81-1.09-3.57-1.32-5.4-.91-7.56,1.44-13.79,7.86-18.2,5.83-4,11.85-6.46,18.89-2.8,8.51,4.42,9.12,4,9.86-5.79.07-.93.12-1.86.25-3.85ZM776.56,788.67c-.31.68-.61,1.36-.92,2.04,1.52,1.62,2.96,3.33,4.57,4.86,4.72,4.5,9.51,8.94,14.27,13.39,6,5.62,11.93,11.18,5.13,20.18-.6.79.14,3.13.96,4.22.42.56,2.59.34,3.63-.18,6.2-3.14,12.21-6.64,18.46-9.68,3.75-1.82,5.32-4.19,4.1-8.32-1.71-5.81-3.26-11.67-4.89-17.5-1.13-4.06-3.68-6.17-8.02-6.47-10.46-.73-20.9-1.7-31.35-2.51-1.97-.15-3.96-.02-5.95-.02ZM1107.08,665.94c-3.4,4.3-.43,6.13,1.16,8.12,2.29,2.87,4.35,5.5,1.6,9.28-2.89,3.96-6.19,5.19-10.82,3.59-1.54-.53-3.09-1.73-4.55-1.62-1.81.14-4.13.91-5.12,2.23-.75.99-.29,3.69.6,4.92,1.46,2.03,3.61,3.62,5.64,5.17,4.38,3.34,7.66,6.91,4.79,13-.38.8.42,2.64,1.24,3.36.52.46,2.28.06,3.12-.51,1.11-.76,1.83-2.08,2.78-3.1,3.75-4,5.67-4.2,10.23-1.08,2.22,1.52,4.39,3.13,6.9,4.92,7.37-8.47,10.87-18,13.18-28.01.76-3.28-1.01-5.57-4.6-5.37-7.16.39-12.38-3.25-17.36-7.69-2.72-2.42-5.63-4.64-8.79-7.22ZM1357.05,543.04c-1.34-7.36-2.45-14.74-4.08-22.01-.98-4.37-2.81-4.65-8.05-2.42-12.42,5.29-24.85,10.53-37.31,15.72-3.86,1.61-7.87,2.88-11.73,4.49-3.07,1.28-5.17,3.33-3.81,7.05,1.28,3.5,3.71,5.31,7.55,4.58,1.36-.26,2.68-.78,4.02-1.19,14.53-4.38,29.22-5.47,44.12-2.12,1.36.31,2.73.64,4.12.77,3.52.31,5.19-1.42,5.17-4.88ZM1370.19,493.04c-.09,1.63-.34,2.56-.17,3.4,2.6,12.74,5.24,25.48,7.9,38.2,1.05,5,1.93,10.06,3.37,14.95,1.5,5.1,5.75,7.28,9.38,5.36,5.74-3.03,9.56-10.46,8.4-17.02-1.69-9.6-3.62-19.17-5.46-28.74-1.16-6.03-2.34-12.05-3.6-18.54q-10.48,9.13-19.83,2.4ZM201.14,354.46c1.12-.34,2.05-.32,2.37-.75,6.87-9.27,15.75-16.32,24.81-23.29,1.89-1.46,2.97-5.33,2.74-7.94-.88-10.04-11.11-18.24-20.36-16.93-9.26,1.31-17.33,11.79-15.97,21.42,1.11,7.82,2.87,15.55,4.47,23.28.3,1.45,1.25,2.77,1.92,4.21ZM1613.48,994.41c.25-5.09-2.35-8.49-6.27-11.03-10.39-6.75-19.78-14.58-27.82-24.08-3.58-4.24-6.67-4.5-10.34-1.99-3.55,2.43-4.35,5.44-1.76,10.41,8.52,16.39,20.69,29.66,35.74,40.27,3.58,2.53,6.9,1.44,8.24-2.69,1.14-3.5,1.5-7.25,2.21-10.9ZM1567.09,732.32c1.76-.32,2.25-.32,2.66-.5,10.97-4.94,22.02-9.72,32.86-14.95,3.21-1.55,4.35-4.85,2.58-8.37-2.42-4.81-3.09-11-9.54-12.75-.81-.22-1.88.09-2.7.45-11.23,5-22.5,9.92-33.58,15.23-1.52.73-3.2,3.74-2.86,5.25.87,3.78,2.41,7.6,4.55,10.82,1.51,2.28,4.44,3.61,6.03,4.82ZM283.53,886.03c.38.66.76,1.32,1.14,1.99,22.75-3.09,45.5-6.19,68.25-9.28.11-.62.21-1.24.32-1.86-1.61-1.11-3.17-2.33-4.85-3.32-8.23-4.81-16.48-9.58-24.75-14.33-6.09-3.5-6.97-3.48-12.28,1.12-8.09,7-16.08,14.11-24.05,21.25-1.43,1.28-2.52,2.94-3.77,4.43ZM1522.86,421.24c-6.29,2.26-11.64,4.43-17.15,6.08-4.48,1.34-4.69,3.83-2.93,7.4,4.74,9.62,9.27,19.36,14.24,28.86,4.03,7.69,10.53,11.63,19.46,11.01,2.56-.18,5.15-.05,7.69-.36,3.19-.38,7.19-.47,7.25-4.68.01-1.03-4.26-2.56-6.72-3.09-3.7-.79-7.75-.92-9.51-4.85-3.69-8.28-7.45-16.57-10.36-25.14-1.52-4.48-1.29-9.54-1.96-15.23ZM767.51,780.44c1.11,3.23,4.66,3.39,8.18,3.6,7.89.48,15.78.98,23.67,1.42,4.64.26,9.29.47,13.93.65,3.16.13,4.53-1.53,4.84-4.62,1.2-11.95-4.89-19.82-16.81-21.35-3.92-.5-7.87-.93-11.81-.94-5.1,0-9.57,1.58-12.46,6.29-2.97,4.83-6.1,9.56-9.54,14.94ZM546.69,680.17c2.48,2.27,4.04,3.89,5.8,5.27,4.96,3.88,9.97,7.69,15,11.47,13.31,10.01,9.8,9.28,24.93,3.97,3.58-1.25,7.93-1.15,10.26-5.37-.73-1.03-1.21-2.17-2.06-2.84-9.19-7.16-18.39-14.32-27.72-21.3-1.38-1.03-3.62-1.89-5.17-1.54-7.48,1.69-14,5.4-21.03,10.34ZM492.92,322.57c-8.18-3.35-12.19-2.39-16.47,3.87-8.16,11.93-16.26,23.91-24.11,36.05-3.15,4.87-5.72,10.15-8.27,15.37-1.43,2.92-1.26,5.78,1.62,8.16,5.23,4.32,8.54,3.52,12.1-2.66,10.71-18.57,21.59-37.04,32.38-55.56.91-1.56,1.68-3.19,2.75-5.23ZM1420.75,542.8c-.8-6-1.66-12.22-2.44-18.45-1.26-10.15-2.32-20.33-3.83-30.45-.33-2.2-1.76-5.39-3.46-6.02-6.4-2.37-16.21,6.29-14.94,13.21,2.38,13.03,5.28,25.96,7.97,38.93,1.16,5.58,4.97,8.14,10.28,8.9,5.47.79,6.66-.33,6.42-6.13ZM1548.1,388.88c.29-.51.58-1.02.87-1.53-1.63-1.45-3.2-2.98-4.91-4.35-28.73-22.99-57.44-46-86.29-68.84-2.14-1.7-4.59-6.68-7.77-2.69-2.48,3.11,2.02,5.05,4.08,6.91,17.1,15.46,34.66,30.43,51.35,46.33,10.54,10.04,22.18,17.59,35.95,22.02,2.24.72,4.48,1.44,6.72,2.16ZM1323.3,649.61c.91-1.54,2.15-2.93,2.61-4.54,3.79-13.2,7.76-26.37,11.01-39.71,1.97-8.12-1.08-13.97-7.09-16.4-5.45-2.21-7.97-.59-9.26,5.17-2.13,9.54-4.19,19.13-7.06,28.45-3.25,10.54-.35,20.05,9.79,27.04ZM1357.46,605.87c.25-8.24-3.38-12.37-8.41-9.91-2.29,1.12-4.27,4.22-5.07,6.82-4.96,16.26-9.53,32.63-14.27,48.96-1.53,5.27-.36,8.47,4.01,10.36,3.82,1.66,6.89.41,9.33-4.78,7.77-16.61,12.14-34.21,14.42-51.45ZM1549.42,462.47c.93,0,1.86.04,2.78,0,4.75-.24,8.4-2.34,10.88-6.45,2.53-4.18-.44-7.08-2.48-10.03-4.88-7.07-9.86-14.08-14.97-20.98-3.94-5.31-7.43-6.16-12.54-3.51-5.29,2.74-6.81,6.66-4.69,12.9,2.02,5.93,4.29,11.78,6.47,17.65,2.94,7.9,5.95,10.02,14.54,10.42ZM513.67,754.82c0-.46.03-.93,0-1.39-.79-11.25-16.49-27.96-27.7-29.49-3.57-.49-5.56,1.85-4.44,5.69.9,3.11,2.14,6.14,3.5,9.08,1.99,4.32,2.28,8.08-.93,12.27-3.21,4.19-2.41,6.35,2.24,8.89,3.86,2.11,7.82,4.11,11.91,5.7,8.56,3.33,15.33-1.48,15.42-10.75ZM836.73,934.28c-1.82-.76-3.19-1.47-4.65-1.91-21.84-6.63-43.73-13.07-65.48-19.96-4.49-1.42-8.67-4.17-12.63-6.84-3.99-2.69-6.08-2.64-9.53,1.08-3.14,3.38-1.58,6.01,1.18,8.27,1.93,1.59,4.12,3.23,6.46,3.9,23.98,6.77,48,13.4,72.05,19.94,4.77,1.3,9.08.31,12.61-4.47ZM1019.1,978.67c.09.48.19.95.28,1.43,2.44,0,4.89-.05,7.33,0,5.33.12,10.76-.29,15.97.56,11.35,1.85,20.7-1.39,28.16-9.9,2.46-2.81,4.11-6.33,6.12-9.53-3.56-1.39-7.01-3.43-10.7-4.04-6.57-1.09-13.49-2.66-19.6,1.61-9.28,6.49-18.39,13.23-27.57,19.86ZM1202.34,613.94c-.22-.33-.44-.66-.66-.99-3.49,1.99-7.92,3.21-10.29,6.12-9.55,11.71-18.48,23.93-27.58,35.99-2.13,2.82-1.73,5.55.54,8.23,4.55,5.35,8.13,4.98,12.84-1.31,8.77-11.73,17.59-23.42,26.42-35.12,1.68-2.23,3.55-4.31,5.2-6.56,1.82-2.48,1.11-4.42-1.7-5.41-1.51-.54-3.18-.65-4.77-.96ZM1161.26,945.26s0-.04,0-.07c-6.04-.3-12.07-.72-18.11-.85-6.51-.14-10.4,2.49-10.45,6.68-.04,3.93,3.44,6.66,9.47,7.39.46.06.93.07,1.39.1,14.84,1.04,29.68,2.12,44.52,3.08,6.35.41,8.26-1.04,8.68-6.16.45-5.51-1.65-7.83-7.67-8.26-9.27-.67-18.55-1.27-27.83-1.91ZM1082.33,722.95c3.82-4.44,7.32-8.03,10.25-12.04,3.79-5.2,3.56-6.15-1.34-10.45-9.99-8.77-20.05-17.48-30.1-26.18-1.22-1.06-2.49-2.29-3.96-2.8-2.42-.85-4.9.44-4.01,2.89,1.95,5.35,3.95,11.11,7.52,15.36,7.27,8.63,14.06,17.39,18.44,27.87.59,1.42,1.58,2.68,3.2,5.36ZM42.08,608.91c-15.07,18.81-20.31,41.14-26.69,63.15,2.49-1.5,4.39-3.37,5.75-5.58,6.35-10.32,12.28-20.91,18.91-31.04,2.98-4.55,6.93-8.64,11.06-12.24,5.1-4.44,7.71-9.76,9.59-16.84-6.94,1.71-11.47,10.33-18.62,2.56ZM520.76,677.17c-3.04-3.31-5.03-5.57-7.13-7.72-2.95-3.02-6.66-4.96-10.71-3.49-7.4,2.69-14.68,5.81-21.79,9.22-3.74,1.8-4.23,5.15-2.2,8.9,3.93,7.28,9.46,11.72,13.14,10.21,1.49-.61,2.85-1.57,4.24-2.41,5.38-3.24,10.76-6.49,16.14-9.73,2.7-1.63,5.42-3.24,8.3-4.97ZM906.39,954.85c-1.29-2.93-1.7-4.16-2.34-5.25-4.21-7.23-8.84-14.25-12.6-21.7-2.6-5.16-6.2-4.44-10.49-3.62-4.33.83-7.51,2.46-7.51,7.5,0,9.99-.03,19.98,0,29.97,0,.6.53,1.2,1.25,2.71,7.68-12.9,17.9-15.73,31.68-9.61ZM541.79,633.17c2.56-.61,3.89-.72,5.03-1.23,12.97-5.76,25.91-11.61,38.88-17.37,3.18-1.41,6.6-2.35,9.68-3.94,2.33-1.2,4.31-3.1,6.44-4.69-1.79-1.89-3.47-3.9-5.41-5.62-1.19-1.06-2.81-1.63-4.2-2.48-6.66-4.07-8.47-4.04-14.16,1.09-11.24,10.14-22.39,20.39-33.54,30.62-.76.7-1.28,1.67-2.74,3.63ZM758.4,830.85c3.07,9.75,5.23,18.89,10.53,26.99,3.5-6.98-3.74-12.59-1.75-19.44,2.13,3.22,3.67,6.66,5.21,10.11,1.78,4.01,4.25,5.65,8.82,3.66,4.46-1.93,9.3-2.95,13.87-4.65,3.31-1.23,6.45-2.93,9.49-4.34-3.78-3.92-6.71-7.44-10.16-10.35-1.77-1.49-4.43-2.53-6.74-2.64-7.43-.34-14.88-.2-22.33-.14-2,.02-3.99.44-6.94.79ZM1462.46,261.03c1.19-.84,4.56-2.06,6.07-4.45,7.06-11.18,13.76-22.6,20.26-34.11,2.34-4.14.8-7.41-3.42-9.76-4.2-2.34-6.48,0-8.43,3.29-7.21,12.18-14.48,24.34-21.62,36.57-3.35,5.74-1.61,8.49,7.14,8.47ZM1163.43,914.45c3.28-3.93,4.07-7.92,2.62-11.61-.66-1.67-3.87-2.53-6.07-3.35-3.66-1.37-5.95-3.56-5.85-7.67.13-4.72,3.37-6.07,7.29-7,4.5-1.07,5.62-3.69,3.94-8.2-1.64-4.41-4.66-3.03-7.35-1.55-4.24,2.32-8.41,3.75-13.29,1.99-1.07-.39-2.94.09-3.88.86-6.15,5.02-11.98,10.37-14.95,18.05-.95,2.44-2.13,5.09,1.29,6.48,3.46,1.4,5.85-.16,7.18-3.45.43-1.07.55-2.25.89-3.36,1.57-5.06,4.51-7.27,8.39-6.33,4.78,1.15,6.81,4.56,5.32,10.14-.85,3.18-.47,5.47,2.25,7.24,3.88,2.52,7.8,4.97,12.21,7.78ZM827.19,911.08c-.81-5.09-1.37-8.21-6.54-7-1.53.36-3.27.36-4.8.03-15.96-3.41-31.9-6.96-47.86-10.39-3.44-.74-6.24-2.09-7.01-5.85-.85-4.15-.22-8.03,3.31-10.73,1.8-1.38,4.01-2.35,6.17-3.15,11.81-4.36,23.66-8.59,35.49-12.89,1.53-.56,3.4-.87,4.41-1.95,1.05-1.13,1.24-3.05,1.81-4.62-1.41-.27-2.93-.98-4.22-.7-2.01.44-3.85,1.62-5.8,2.39-13.01,5.14-26.02,10.26-39.04,15.37-3.59,1.41-6.75,3.16-7.65,7.4-2.31,10.87,1.54,16.87,12.27,19.01,1.83.37,3.64.82,5.46,1.22,17.51,3.85,35.02,7.69,53.98,11.85ZM1377.88,253.97c1.96,1.85,3.34,3.43,4.98,4.65,8.37,6.17,11.3,14.96,7.29,24.54-2.47,5.89-1.27,10.63,3.16,14.48,3.84,3.33,8.17,6.17,12.53,8.82,2.43,1.48,4.35.04,3.79-2.72-.59-2.93-1.81-5.79-3.17-8.48-1.7-3.36-2.68-6.4.31-9.59,2.57-2.74,1.48-5.45-.27-8.25-3.57-5.72-6.96-11.56-10.42-17.36-3.85-6.45-9.75-8.69-18.22-6.09ZM117.74,500.17c-6.52-.38-9.86,2.84-10.1,9.43-.18,5.04-.84,10.08-.84,15.12,0,2.04.59,4.78,1.97,5.96,3.18,2.7,10.17,2,12.75-1.27,5.01-6.37,9.64-13.04,14.28-19.69,2.13-3.06.86-5.57-2.42-6.41-5.14-1.33-10.42-2.11-15.64-3.12ZM1167.78,694.97c-2.16,6.96.87,10.06,4.36,12.93,10.61,8.71,21.23,17.42,31.85,26.11,8.1,6.63,16.2,13.28,24.36,19.84,3.38,2.72,6.97,4.44,11.75.02-24.04-19.58-47.7-38.85-72.32-58.9ZM1533.52,245.21c-1.05.77-2.57,1.33-2.68,2.1-.21,1.4-.03,3.24.76,4.35,5.27,7.41,10.87,14.59,16.11,22.02,6.31,8.95,10.56,18.66,9.86,29.97-.08,1.36.07,2.84.52,4.12,1.3,3.77,6.72,7.22,9.85,6.47,2.33-.56,5.85-6.06,5.27-9.11-.47-2.46-1.5-4.98-2.89-7.06-11.25-16.85-22.64-33.61-34.04-50.37-.61-.9-1.65-1.51-2.75-2.49ZM1027.42,668.68c.19-.33.38-.67.56-1,1.84-.21,3.71-.27,5.51-.66,5.84-1.28,10.62-6.89,4.25-12.63-3.62-3.26-6.77-7.06-10.51-10.15-6.5-5.38-6.74-5.18-11.99,1.18-1.77,2.15-3.91,3.99-5.66,6.15-3.23,4.02-3.3,6.54,1.11,9.24,5.22,3.2,11.11,5.3,16.72,7.87ZM1499.99,219.04c-.49-.16-.97-.32-1.46-.47-.86.63-2.02,1.08-2.53,1.93-7.42,12.39-14.76,24.83-22.11,37.26-1.69,2.85-.74,5.38,2.04,6.23,3,.92,6.59,1.61,9.49.82,6.98-1.9,15.31-17.9,13.13-24.97-1.68-5.43-1.8-10.42.79-15.56.75-1.48.46-3.48.65-5.24ZM1725.75,923.52c-1.29.52-2.94.86-4.19,1.75-3.58,2.55-6.03,14.97-3.67,18.71,3.33,5.28,8.42,8.31,14.47,8.53,5.88.21,7.74-5.17,10.09-9.38.78-1.39,1.35-3.04,1.46-4.62.11-1.52,0-3.49-.87-4.59-4.35-5.47-10.18-8.66-17.29-10.42ZM1551.86,867c-7.84-.44-14.26,5.18-14.55,12.73-.27,7.24,5.42,13.55,12.67,14.04,7.5.51,14.01-5.31,14.45-12.93.44-7.46-4.97-13.41-12.57-13.84ZM1537.48,907.41c-6.38.06-13.69,7.22-13.81,13.52-.12,6.76,7.34,14.16,14.03,13.92,6.68-.24,13.28-7.18,13.23-13.89-.05-6.78-6.83-13.6-13.45-13.54ZM1706.08,831.03c4.06,3.31,7.31,6.23,10.86,8.72,1.83,1.29,4.17,2.41,6.34,2.55,4.07.26,14.25-15.86,12.83-19.82-2.97-8.27-13.01-10.98-19.18-4.82-3.73,3.72-6.7,8.19-10.85,13.38ZM1300.81,277.73c-.21-1.97-.33-4.54-.79-7.05-1.01-5.41-3.13-6.72-8.35-4.89-3.93,1.38-7.89,2.92-11.49,4.98-6.18,3.55-7.5,10.28-3.61,16.19,3.02,4.59,6.87,5.59,13.54,3.5,8.86-2.77,10.96-5.15,10.7-12.75ZM1748.48,950.27c-.03,7.7,5.47,11.27,17.3,11.22,4.77-.02,10.45-6.91,10.66-12.93.19-5.74-7.68-10.93-16.89-11.14-7.21-.16-11.02,4.27-11.06,12.84ZM1440.14,320.27c.26.73.55,2.27,1.29,3.56,11.87,20.83,23.8,41.63,35.75,62.42.69,1.2,1.48,2.61,2.6,3.21,1.22.66,3.67,1.16,4.19.55.96-1.13,1.42-3.22,1.14-4.75-.26-1.46-1.69-2.72-2.65-4.04-4.94-6.78-9.88-13.55-14.83-20.31-2.15-2.94-3.8-5.92-1.56-9.6,2.16-3.54.43-6.16-2.14-8.57-8.03-7.56-16.03-15.14-23.79-22.47ZM1375.06,548.04c-2.68-13.16-5-25.28-7.7-37.31-.82-3.64-3.65-4.12-7.12-1.94-3.21,2.02-3.93,5.02-3.48,8.48.66,5.08,1.16,10.19,2.14,15.21,1.03,5.24,2.3,10.47,3.92,15.55,1.18,3.7,4.58,4.75,7.96,3.78,1.77-.51,3.07-2.65,4.28-3.77ZM1195.76,895.12c-2.31,1.85-3.85,2.84-5.08,4.12-2.59,2.67-4.84,5.71-7.59,8.2-3.09,2.79-6.67,5.03-9.86,7.73-4.61,3.9-3.22,13.86,2.42,15.83,1.79.63,4.73-.16,6.3-1.38,1.03-.8,1.06-3.67.63-5.4-1.46-5.94-.62-9.26,3.48-11.46,3.89-2.09,7.82-.91,11.54,3.49.45.53.74,1.19,1.18,1.73,1.69,2.13,4,3.05,5.95.98,1.34-1.43,2.86-4.49,2.21-5.71-3.23-6.06-7.15-11.75-11.17-18.12ZM1558.07,938.69c-.89-1.06-1.65-2.78-2.57-2.87-1.35-.14-3.63.5-4.1,1.48-2.07,4.37-4.22,8.85-5.22,13.53-.9,4.22-1.88,7.65-6.48,8.86-3.7.98-4.09,3.35-2.58,6.43,1.47,2.98,2.96,6.55,7.17,4.22,3.6-1.99,6.37-1.22,9.75.53,4.74,2.47,8.67-.66,8.15-5.97-.18-1.83-.65-3.85-.1-5.49,1.38-4.16-.42-5.76-4.05-7.25-5.43-2.22-5.76-3.98-2.77-9.04.82-1.39,1.72-2.73,2.79-4.42ZM1782.8,995.14c-5.64-3.13-9.33-6.31-8.35-12.9.42-2.79-4.8-5.33-7.59-3.88-4.6,2.39-8.54,5.65-9.66,11.19-1.38,6.89-1.69,7.25-8.42,7.02-2.87-.1-5.63.12-5.21,3.65.35,2.99,2.99,3.92,5.88,3.31,4.08-.86,8.38-1.27,12.15-2.89,4.06-1.75,7.27-2.44,10.62,1.16,2.27,2.44,4.63,1.55,6.48-.85,1.25-1.62,2.36-3.35,4.11-5.83ZM313.79,354.14c-9.67-9.41-72.55-44.2-78.51-44.5,3,6.8,7.55,11.65,14.21,14.75,20.04,9.34,39.99,18.86,59.99,28.27,1.37.64,2.88.99,4.32,1.48ZM790.96,695.53c.12.65.25,1.3.37,1.95,6.24,4.91,12.49,9.81,19.91,15.64,3.91-11.22,7.52-20.75,10.53-30.47,2.24-7.24-.19-9.71-9.42-9.68,1,14.39-4.81,23.41-21.4,22.56ZM1478.44,890.84c3.67-2.08,5.81-3.33,7.97-4.52,4.87-2.69,5.38-3.64,2.6-8.65-2.17-3.9-2.1-7.66-.2-11.29,2.8-5.33,6.04-10.42,9.1-15.61,1.53-2.59,3.37-5.05,4.55-7.79,1.56-3.64-.72-8.69-4.28-9.76-4.26-1.28-5.16,2.31-6.05,5.01-3.71,11.21-7.46,22.43-10.64,33.8-1.57,5.64-1.94,11.61-3.06,18.81ZM1703.48,841.56c-9.17-.24-15.02,6.99-12.09,12.75,2.44,4.79,6.52,8.88,10.4,12.75,2.23,2.22,5.16,1.64,7.12-1.28,2.2-3.27,4.78-6.35,6.56-9.83.88-1.73,1.26-5.34.28-6.13-4.41-3.54-9.38-6.38-12.27-8.26ZM44.93,478.19c-2.62.41-3.82.44-4.9.8-2.85.94-5.72,1.89-8.47,3.07-8.05,3.46-8.34,4.26-5.14,12.53.5,1.29,1.08,2.56,1.72,3.79,1.41,2.72,3.26,3.35,6.27,2.03,3.13-1.37,6.53-2.48,9.91-2.87,10.38-1.19,11.1-2.18,7.44-12.1-.32-.87-.45-1.98-1.06-2.54-2.07-1.88-4.32-3.55-5.76-4.71ZM566.24,585.16c-.37-.48-.74-.95-1.11-1.43-1.56.61-3.39.87-4.63,1.87-15.02,12.12-30.02,24.28-44.82,36.67-1.31,1.09-2.07,5.33-1.6,5.61,2.13,1.26,4.81,2.19,7.25,2.11,1.46-.04,2.97-2.04,4.28-3.34,11.57-11.46,23.12-22.93,34.61-34.47,2.17-2.18,4.02-4.69,6.01-7.04ZM834.53,957.76c-.05.54-.1,1.08-.15,1.62,5.13,3.39,10.62,6.36,15.3,10.29,4.88,4.1,8.98,9.12,13.65,13.97,6.04-4.39,6.15-10.45,6.31-16.07.18-6.25-2.03-8.2-8.36-8.77-5.33-.48-10.68-.79-16.04-1.01-3.56-.15-7.14-.03-10.7-.03ZM1150.44,859.29c2.26,2.52,3.66,5.16,5.81,6.11,1.39.61,4.43-.74,5.75-2.14,3.34-3.55,6.24-7.54,9.12-11.49,5.89-8.11,5.07-11.34-3.47-16.78-3.2-2.04-6.02-2.14-7.59,1.26-3.39,7.33-6.25,14.9-9.61,23.06ZM1420.88,315.23c-1.71-4.13-4.14-3.31-6.65-2.33-19.1,7.51-37.2,16.97-54.62,27.77-1.87,1.16-4.77,2.73-2.57,5.26.95,1.09,4.11.56,6.2.27,1.27-.18,2.38-1.38,3.61-2.04,11.47-6.14,22.91-12.35,34.45-18.34,5.15-2.67,10.58-4.8,15.79-7.38,1.5-.74,2.63-2.21,3.78-3.21ZM1128.46,752.7c-4.05-3.81-7.35-7.63-11.35-10.46-3.42-2.42-6.08.81-8.26,3.08-2.55,2.65-4.77,5.64-7.02,8.57-1.78,2.33-1.51,4.55.31,6.94,6.85,8.96,12.1,9.39,19.63,1.14,2.27-2.49,4-5.48,6.7-9.26ZM894.73,766.88c9.32-4.11,10.4-5.93,8.79-15.04-.44-2.52-1.01-5.01-1.52-7.51-2.47-12.16-1.79-24.05,3.16-35.53,1.8-4.18,3.86-8.25,5.99-12.75-15.7,12.28-22.94,54.6-16.42,70.82ZM783.91,884.1c.12.69.24,1.38.35,2.06,8.22,2.06,16.42,4.22,24.69,6.09,1.37.31,3.29-.27,4.5-1.1,4.08-2.8,4.76-9.46,1.74-14.5-3.22-5.37-7.83-7.32-12.74-4.51-6.38,3.65-12.38,7.95-18.54,11.97ZM1195.54,805.38c-3.56.97-7.53,4.45-11,9.85-4.09,6.35-3.32,10.06,3.16,15.39,4.64,3.81,6.43,3.48,12.18-2.33,1.3-1.31,2.65-2.63,3.67-4.15,1.72-2.55,5.32-5.11,2.64-8.45-3.07-3.83-7.07-6.91-10.66-10.31ZM1295.91,749.88c-5.68-8.3-13.29-12.02-21.56-14.58-1.31-.41-3.76.56-4.71,1.7-3.06,3.69-2.32,8.24.82,11.88,2.21,2.56,4.24,5.45,5.64,8.51,2.22,4.82,4.06,5.91,8.3,2.8,4.03-2.96,7.51-6.68,11.5-10.31ZM1715.97,992.36c-.34-.52-.68-1.04-1.02-1.56-1.62.38-3.27.67-4.86,1.16-9.73,3.01-19.43,6.11-29.18,9.07-2.43.74-5.07.85-7.47,1.66-3.79,1.28-5.56,5.82-4.08,9.85,1.48,4.03,4.48,2.35,7.02,1.71,12.76-3.23,24.52-8.61,34.94-16.71,1.8-1.4,3.11-3.43,4.65-5.17ZM1523.13,240.96c-1.15-8.93-3.37-15.83-9.71-20.73-2.25-1.74-4.33-2.27-6.66.21-7.26,7.77-6.14,19.51,3.05,24.93,2.65,1.57,6.77,1.9,9.79,1.14,1.78-.45,2.72-4.18,3.53-5.56ZM1369.35,285.87c-1.67-12.33-6.14-23-12.17-33.08-.57-.95-1.61-2.09-2.57-2.24-1.9-.3-4.16-.48-5.76.32-.76.38-.85,3.32-.34,4.78,4.01,11.37,10.3,21.95,11.69,34.26.13,1.18,2.06,3.02,3.15,3.03,1.54,0,3.52-1.09,4.49-2.34,1.04-1.35,1.13-3.44,1.5-4.72ZM1469.38,354.61c.85,1.72,1.49,3.59,2.58,5.14,4.84,6.86,9.68,13.73,14.77,20.4,5.78,7.58,10.96,8.31,19.89,3.22-4.83-7.63-29.58-28.11-37.23-28.76ZM1625.51,965.48c-1.5-2.36-2.56-5.01-4.45-6.81-4.89-4.64-10.07-8.97-15.26-13.28-3.11-2.59-6.49-1.37-7.05,2.62-.24,1.73-.06,4.05.92,5.33,5.34,6.96,10.87,13.8,16.62,20.43,1.82,2.1,4.51,1.45,5.97-.83,1.33-2.07,2.02-4.56,3.24-7.47ZM552.77,659.59c-.02-.94-.05-1.88-.07-2.82-3.75-2.07-7.47-5.85-11.24-5.89-9.12-.1-16.8,4.79-25.34,9.81,4.39,2.92,7.3,5.25,10.56,6.89,2.16,1.09,5.28,2.3,7.16,1.52,6.5-2.71,12.65-6.27,18.93-9.51ZM1108.8,944.3c-.06,4.74,2.68,6.97,7.16,5.36,1.82-.66,3.44-2.22,4.83-3.68,3.19-3.35,6.23-6.86,9.23-10.38,1.33-1.56,2.87-3.17,3.54-5.03,2-5.53-.77-8.6-6.54-7.6-9.24,1.61-18.11,12-18.23,21.33ZM1602.63,860.56c3.29-1.13,9.24-2.92,14.92-5.33,1.37-.58,3.02-3.83,2.52-4.77-1.02-1.9-3.23-3.72-5.31-4.33-1.74-.51-4.09.51-6.02,1.25-11.82,4.53-23.62,8.62-36.5,4.04-.98-.35-2.6,1.1-3.92,1.72.81,1.27,1.37,2.86,2.49,3.73,1,.78,2.59.96,3.95,1.09,8.31.83,16.63,1.56,27.87,2.6ZM517.13,612.04c.43.39.86.78,1.29,1.18,12.93-10.56,25.86-21.13,38.75-31.66-4.51-5.97-6.47-6.73-10.18-3.7-7.03,5.74-14.03,11.55-20.6,17.79-4.68,4.44-8.2,9.87-9.27,16.39ZM1159.82,679.15c-.46.59-.91,1.18-1.37,1.77,32.84,26.56,65.68,53.13,98.52,79.69.4-.5.81-1.01,1.21-1.51-31.38-28.39-64.26-54.93-98.37-79.95ZM524.02,641.29c-.71-1.33-.98-2.25-1.56-2.88-8.43-9.09-22.59-7.72-29.21,3.08-.85,1.39-.38,5.05.78,5.93,2.44,1.84,5.98,3.88,8.66,3.42,7.72-1.33,14.81-4.71,21.33-9.55ZM408.28,627.11c-.46.32-.92.64-1.38.95.98,2.09,1.73,4.32,2.98,6.24,7.71,11.87,15.53,23.67,23.34,35.49,1.15,1.74,2.13,3.79,3.73,4.97,1.36,1.01,4.12,1.88,5.13,1.18,1.29-.89,2.21-3.58,1.88-5.22-.42-2.13-2.01-4.15-3.45-5.93-9.5-11.72-19.07-23.38-28.69-35-.92-1.11-2.34-1.79-3.53-2.68ZM1696.96,917.41c0-9.5-8.82-18.64-18.11-18.79-9.5-.16-18.61,9.3-18.46,19.16.14,9.62,8.23,17.42,18.14,17.51,10.2.09,18.44-7.9,18.43-17.87ZM1295.28,842.22c-6.21,21.71,2.54,56.98,16.72,72.32-8.73-23.36-13.12-47.7-16.72-72.32ZM1443.01,474.44c-3.29,9.91.5,28.43,5.51,35.58,1.93,2.76,4.04,4.44,7.55,2.6,3.56-1.86,4.32-4.27,2.5-7.98-4.19-8.53-8.04-17.23-12.17-25.79-.79-1.64-2.24-2.95-3.38-4.42ZM1111.86,793.27c-8.46-18.01-18.72-19.22-28.89-4.62-.26.38-.65.73-.77,1.15-.54,1.85-1,3.72-1.48,5.58,1.91.33,3.86,1.09,5.72.9,5.75-.59,11.45-1.58,17.18-2.33,2.43-.32,4.89-.41,8.24-.68ZM1311.14,705.2c-5.58-1.47-9.97-1.36-13.15,2.35-6.28,7.34-12.22,14.98-18.25,22.43,5.54,5.96,8.1,6.16,12.54.78,5.61-6.78,11.01-13.73,16.41-20.68.92-1.19,1.39-2.73,2.45-4.89ZM1480.06,797.55c5.4-7.13,10.33-13.44,14.95-19.97.68-.96.39-3.24-.29-4.43-1.95-3.42-11.87-6.01-15.29-4.01-1.26.73-2.78,2.35-2.82,3.61-.23,7.99-.89,16.11,3.44,24.8ZM1523.5,847.95c-.27-.82-.54-1.65-.81-2.47-2.02.63-4.27.9-6.04,1.96-9.47,5.64-15.23,14.21-18.22,24.63-.51,1.77.06,4.17.86,5.95,3.57,8.01,3.72,8.05-2.82,13.34-6.39,5.18-9.39,12.05-10.12,19.97-.32,3.53-.36,7.35,4.61,10.45.18-3.58.28-6.22.46-8.84.48-7.31,1.23-14.67,7.85-19.31,5.59-3.93,6.57-8.63,5.25-15.14-2.44-12.02,2.46-21.47,13.15-27.42,1.92-1.07,3.89-2.07,5.84-3.1ZM1479.55,922.36c-1.08,10.74,3.16,19.02,10.72,22.62,5.37,2.56,11.64.76,17.29-5.15-6.56-9.81-19.65-8.68-28.01-17.47ZM1745.15,796.28c-11.23-9.66-24.4-13.66-37.14-18.45-.9-.34-3.02.46-3.34,1.23-.38.93.2,2.76.99,3.59,2.38,2.48,5.47,4.36,7.53,7.05,2.5,3.27,4.92,4.73,8.82,2.65,4.21-2.24,7.11-.2,9.39,3.23.77,1.15,1.15,2.55,1.89,3.73,2.74,4.37,4.52,4.68,8.19,1.34,1.17-1.06,2.06-2.42,3.68-4.36ZM1654.82,1042.09c4.76.23,7.41-1.87,8.47-5.6,1.2-4.26-2.25-4.93-5.17-5.86-.66-.21-1.47-.36-1.9-.83-3.49-3.78-6.72-3.9-10.67-.3-2.7,2.46-5.68,1.55-7.55-1.73-.57-1-.7-2.34-1.44-3.14-1.1-1.18-2.56-2.02-3.87-3-.92,1.91-2.49,3.8-2.53,5.73-.03,1.51,1.69,3.2,2.89,4.58,5.92,6.78,14.23,8.39,21.78,10.15ZM84.64,517.75c-.26-.95-.52-1.91-.77-2.86-10.59-.08-21.18-.36-31.76-.13-3.11.07-4.57,3.9-2.33,6.34,1.89,2.07,4.78,3.82,7.5,4.41,7.54,1.63,14.84.13,21.58-3.6,2.06-1.14,3.86-2.76,5.78-4.16ZM1509.72,930.16c.32-1.02.8-1.71.67-2.25-3.09-12.84.98-22.87,11.76-30.31,3.27-2.25,3.35-5.12,2.14-8.6-2.47-7.09-2.11-14.17.72-21.15.46-1.14.57-2.43.99-4.34-7.99,6.29-11,16.29-7.49,22.99,3.48,6.63,2.76,8.2-3.76,12-2.85,1.66-6.25,4.09-7.21,6.91-1.91,5.66-2.54,11.79-3.26,17.79-.43,3.63,1.56,6.02,5.43,6.95ZM1061.67,642.07c-.27.47-.54.95-.82,1.42.36.77.53,1.76,1.12,2.29,12.59,11.33,25.23,22.62,37.87,33.89,1.73,1.54,3.81,3.65,5.78,1.03.63-.83-.56-3.97-1.79-5.1-10.74-9.9-21.55-19.74-32.65-29.23-2.54-2.17-6.31-2.9-9.51-4.29ZM1779.81,856.63c-.02-.33-.05-.66-.07-.99-1.32.32-2.85.31-3.91,1.02-3.64,2.43-2.71,14.8,1.16,17,6.16,3.49,6.4,4.29,3.33,10.92-.29.63-.97,1.24-.93,1.83.07,1.26.1,3.03.88,3.61.79.59,3.32.41,3.6-.16,2.09-4.29,3.94-8.71,5.5-13.22.23-.66-1.33-2.31-2.39-2.94-1.36-.8-3.46-.59-4.53-1.58-1.73-1.61-3.75-3.73-4.02-5.83-.21-1.66,1.71-4.67,3.3-5.19,2.04-.66,4.87.18,7.01,1.15,1.78.8,2.85,3.2,4.63,3.98,1.36.6,3.73.29,4.93-.59.85-.62,1.19-3.41.52-4.31-1.4-1.89-3.46-4.17-5.53-4.49-4.4-.68-8.98-.21-13.49-.21ZM1164.83,964.23c-10.18,13.34-21.79,20.3-37.53,17.32-15.74-2.99-24.85-13.26-29.9-28.06-2.73,13.51,12,29.04,29.61,32.31,16.37,3.05,35.21-6.8,37.81-21.57ZM1803.81,878.61c-.65-.07-1.3-.14-1.95-.22-1.5,4.31-2.64,8.8-4.63,12.87-1.64,3.37-1.12,5.31,1.59,7.78,5.89,5.38,6,6.69.81,12.54-3.08,3.46-2.2,5.79,1.01,7.98,1.84,1.25,3.95,2.09,7.12,3.71,2.18-16.08-.2-30.43-3.95-44.66ZM1256.94,747.58c.44-.51.89-1.02,1.33-1.53-28.83-25.24-58.66-49.23-89.46-72.01-.38.47-.77.95-1.15,1.42,29.76,24.04,59.52,48.08,89.28,72.12ZM1592.79,690.05c-.12-3.75-3.51-5.01-7.68-3.15-8.91,3.98-17.75,8.11-26.61,12.19-.84.39-1.98.69-2.37,1.38-.84,1.48-2.08,3.46-1.64,4.71.35,1.03,3.28,2.24,4.39,1.77,10.7-4.49,21.27-9.26,31.8-14.12,1.05-.49,1.59-2.08,2.1-2.79ZM532.31,347.74c-.63.93-1.26,1.43-1.3,1.98-1.1,13.26-5.64,25.33-12.59,36.57-1.37,2.21-2.03,4.84.75,5.86,1.5.55,4.98-.6,5.57-1.89,4.15-9.04,8.3-18.15,11.35-27.59,1.59-4.92.47-10.41-3.78-14.91ZM339.66,919.33c.03,6.45,2.21,8.86,7.92,8.76,7.44-.13,11.96-4.91,11.79-12.47-.1-4.54-2.52-6.29-8.77-6.36-7.72-.08-10.97,2.91-10.94,10.07ZM1730.67,1039.27c13-4.64,23-13.7,33.36-22.17.76-.62.56-2.43.81-3.68-1.45-.26-2.97-.91-4.34-.68-2.91.49-5.71,1.98-8.6,2.09-4.02.15-5.81,1.67-6.38,5.66-1,6.93-1.76,7.4-8.94,7.82-7.41.43-8.72,2.65-5.91,10.97ZM1748.37,913.24c-.58-2.22-.9-5.56-2.29-8.38-2.31-4.68-9.17-5.67-10.57-1.5-1.75,5.24-2.23,11.2-1.85,16.75.25,3.69,6.27,6.48,9.94,5.92,4.71-.72,3.44-4.78,4.18-7.67.34-1.33.33-2.75.59-5.13ZM1161.47,1028.29c.05,0,.1,0,.15,0,0-3.25.11-6.5-.03-9.74-.13-3.15-1.64-5.48-5.04-5.48-3.56,0-5.62,2.11-5.68,5.68-.11,6.49-.08,12.98-.01,19.47.04,3.25,1.79,5.39,5.05,5.53,3.24.14,5.3-1.8,5.52-5.05.23-3.46.05-6.95.05-10.42ZM1147.3,966.52c-4.62-2.11-8.19-4.36-12.08-5.36-5.53-1.42-11.29-2.58-16.95-2.62-4.54-.03-5.29,3.03-2.18,6.53,7.49,8.43,19.01,8.39,26.9,5.21,1.31-.53,2.27-1.94,4.31-3.76ZM1509.03,404.13v.17c-3.72,0-7.46-.25-11.14.1-1.85.18-3.59,1.45-5.38,2.23,1.1,1.61,1.88,4.2,3.34,4.67,6.79,2.16,13.69,4.11,20.69,5.38,3.83.69,6.47-2.12,7.75-5.75,1.52-4.32-.13-6.65-4.81-6.79-3.48-.1-6.97-.02-10.45-.02ZM1569.48,981.33c-1.86,5.48-2.02,5.53.57,13.72,1.4,4.41,1.09,8.15-2.12,11.6-.86.93-1.35,2.2-1.94,3.17,7.35,9.01,11.04,12.1,16.37,13.42-.27-1.73-.19-3.28-.76-4.55-1.71-3.81-4.03-7.37-5.4-11.28-.92-2.62-1.59-6-.73-8.47,2.98-8.59,2.43-11.09-5.99-17.61ZM1585.36,789.74c-3.01-2.98-6.87-6.83-10.78-10.63-.24-.23-1.13-.24-1.3-.02-2.8,3.48-6.43,6.65-8.02,10.63-1.34,3.35,4,10.14,7.13,10.92,4.37,1.08,13.31-5.25,12.97-10.9ZM1806.53,933.57c-.48-.23-.97-.45-1.45-.68-1.09.98-2.4,1.8-3.24,2.96-2.45,3.38-4.72,6.89-7.05,10.36-2.21,3.28-4.96,5.16-9.24,5.13-6.45-.04-10.44,6.27-8.78,14.26,3.79-2.49,8.16-4.16,10.71-7.31,4.16-5.15,8.38-6.84,15.06-2.86,1.33-7.89,4.16-14.61,4-21.86ZM1765.84,846.03c.74-.24,1.47-.48,2.21-.72-.26-1.82-.35-3.69-.8-5.47-1.84-7.26-3.8-14.47.28-21.66.41-.72.69-2.04.32-2.61-3.75-5.66-7.77-11.1-14.17-14.72-.57,2.45-.73,4.7.04,6.58,1.4,3.42,3.28,6.65,5.08,9.9,2.37,4.29,3.66,8.52.48,13.04-2.19,3.12-1.52,6.18.76,8.95,1.88,2.28,3.87,4.47,5.81,6.71ZM809.31,864.27c-.36.62-.71,1.23-1.07,1.85,1.46.96,2.9,1.95,4.38,2.89,6.58,4.16,9.22,10.31,7.69,17.92-1.43,7.07-4.58,9.59-11.69,8.97-2.76-.24-5.48-.99-8.21-1.56-4.69-.99-9.37-2.03-14.05-3.05,8.06,3.51,16.33,5.71,24.59,7.96,4.54,1.24,8.27-.1,11.33-3.49,4.89-5.41,7.12-11.55,4.11-18.61-3.26-7.67-9.46-11.39-17.08-12.88ZM1631.98,1047.93c-3.97-4.44-7.05-8.47-10.77-11.75-1.6-1.41-4.93-2.31-6.82-1.62-4.37,1.6-7.45.28-10.9-2.13-4.08-2.86-8.52-5.23-14.24-3.8,5.33,7.18,34.77,20.73,42.73,19.31ZM1428.74,306.85c6.1-4.65,11.83-7.39,18.82-5.17-.05-5.58-.24-10.43-4.92-11.79-4.52-1.32-9.62-1.37-14.38-.94-3.34.3-5.06,3.05-3.6,6.79,1.25,3.2,2.37,6.46,4.07,11.12ZM624.19,588.47c-13.86-9.14-27.78-18.01-42.55-25.43,5.63,13.32,29.25,27.54,42.55,25.43ZM1091.31,761.41c3.1-5.24,5.91-9.64,8.27-14.26.57-1.1.18-3.44-.68-4.4-4.02-4.5-8.36-8.73-12.58-13.05-3.65,5.48-1.34,24.22,4.99,31.71ZM1678.7,1034.74c4.87,2.15,9.08,4.42,13.56,5.85,3.73,1.19,6.25,2.77,6.67,6.94.12,1.19,1.08,2.3,1.78,3.68,6.62-2.69,13.78-2.9,19.12-8.27-3.33-1.41-6.61-2.64-9.89-2.61-7.32.05-13.52-1.51-18.8-7.22-3.57-3.86-6.4-3.16-12.45,1.62ZM1184.41,876.77c-2.66-4.41-5.35-9.29-8.45-13.88-2.28-3.37-5.86-2.94-7.49.82-.7,1.61-.88,3.67-.62,5.42.95,6.21,2.16,12.38,3.39,18.54.14.68,1.06,1.2,1.38,1.54,3.86-4.07,7.41-7.82,11.79-12.44ZM1654.07,940.44c-.1-3.77-9.33-13.16-13.21-13.42-5.29-.36-9.13,4.9-6.14,9.18,2.71,3.88,6.39,7.4,10.34,10.01,4.25,2.8,9.14-.68,9.01-5.77ZM1588.31,499.59c-.61-2.92-.83-5.99-1.91-8.72-1.54-3.88-5.8-5.47-9.89-4.27-4.2,1.24-4.14,4.28-3.4,7.77.42,2.02.28,4.16.6,6.21.78,5.01,3.73,7.3,8.62,6.86,4.32-.39,5.75-2.35,5.98-7.85ZM850.42,590.02c-3.88,1.11-8.92,8.07-8.84,12.17.07,3.94,4.23,8.03,8.24,8.11,3.53.07,12.91-9.1,11.22-11.71-2.35-3.63-6.97-5.78-10.62-8.57ZM1570.67,458.42c-5.64,5.36-10.51,9.59-14.86,14.31-2.08,2.26-.83,4.72,2.27,4.81,5.58.17,11.19.01,16.74-.5,1.04-.1,2.95-2.9,2.62-3.77-1.76-4.69-4.09-9.16-6.76-14.85ZM1578.66,753.17c-3.71-.07-7.51,4.79-6.07,8.45,2.25,5.69,5.63,11,9.13,16.07.74,1.07,4.37,1.08,6,.26,1.02-.51,1.59-3.79,1.01-5.31-2.14-5.64-4.75-11.1-7.38-16.54-.63-1.3-2.03-2.22-2.69-2.92ZM1266.63,559.55c6.33-1.49,11.33-2.48,16.2-3.89,2.89-.83,5.92-2.08,4.78-6.23-1.16-4.24-4.04-5.97-8.46-4.68-4.43,1.29-8.92,2.59-13.05,4.59-1.87.91-4.33,3.78-4.03,5.25.41,2.03,3.19,3.58,4.56,4.95ZM443.58,964.36c-15.31-9.82-29.94-5.55-37.44,9.04,12.62-3.05,24.4-5.89,37.44-9.04ZM345.08,901.01c3.19-1.22,6.68-1.96,9.48-3.77,3.26-2.11,3.63-5.89,2.53-9.42-1.14-3.65-4.21-2.76-7.01-2.4-2.06.26-4.19.06-6.24.38-4.16.65-6.62,4.19-6.11,8.6.48,4.17,2.89,6.13,7.36,6.62ZM1343.36,591.64c3.08-.93,6.57-1.26,9.1-3,1.91-1.31,3.59-4.47,3.49-6.71-.07-1.64-3.02-3.51-5.06-4.59-1.77-.93-4.04-.94-6.1-1.28-5.39-.89-8.83,1.91-9.34,7.57-.43,4.8,2.29,7.44,7.91,8.01ZM1334.67,669.43c-.55-.23-1.1-.47-1.65-.7-.68.75-1.73,1.4-1.98,2.28-6.4,22.84-12.72,45.7-19.05,68.56.52.24,1.03.47,1.55.71.77-.69,2.02-1.25,2.25-2.1,6.35-22.9,12.61-45.83,18.87-68.75ZM1356.07,231.96c.78.41,2.4,1.82,4.2,2.09,4.46.66,10.53-4.1,12.6-9.42,1.65-4.23.3-10.91-2.8-13.53-2.3-1.94-4.16-1.69-5.42,1.22-2.71,6.24-5.44,12.46-8.57,19.63ZM1074.79,973.5c6.41,4.92,13.54,2.64,20.2,2.93.75.03,2.55-2.64,2.26-3.53-1.13-3.41-2.57-6.85-4.63-9.75-.86-1.21-4.08-2.07-5.38-1.42-5.07,2.57-9.8,5.83-12.44,11.75ZM1121.46,913.34c10.23-2.77,19.91-2.26,29.05,3.17,9.1,5.41,14.15,14.16,18.24,24.68,3.36-7.01-2.75-18-12.2-25.93-8.79-7.38-27.42-10.49-35.1-1.91ZM574.37,578.34c-.1.56-.21,1.11-.31,1.67.72.83,1.3,1.91,2.19,2.44,10.64,6.28,21.28,12.55,32.06,18.59,1.18.66,3.17-.12,4.79-.24-.66-1.56-.87-3.88-2.05-4.56-10.45-6.13-21.03-12.05-31.69-17.8-1.3-.7-3.31-.1-4.99-.1ZM1672.19,991.22c.77.87,1.04,1.49,1.35,1.5,10.73.49,20.52-2.89,29.84-7.71,2.77-1.43,2.45-4.73-.52-5.93-1.9-.77-4.63-.81-6.53-.05-7.1,2.84-14.04,6.09-20.96,9.34-1.24.58-2.14,1.89-3.17,2.84ZM1561.17,858.53c2.37-6.25-.46-9.27-4.14-11.4-5.2-3-10.76-5.4-16.08-8.21-2.47-1.3-4.92-1.41-5.65,1.35-.45,1.69.52,4.93,1.87,5.71,7.57,4.35,15.45,8.16,24.01,12.55ZM922.17,562.74c1.76,3.98,4.16,4.56,7.16,3.31,7.32-3.04,14.61-6.14,21.91-9.22,2.75-1.16,4.29-3.05,2.88-6.03-1.45-3.07-3.83-1.76-5.98-.82-6.83,3-13.69,5.94-20.46,9.07-1.98.92-3.68,2.43-5.52,3.68ZM1680.95,883.17c-.02,5.69,5.97,13.31,11.55,14.09,1.8.25,4.42-.38,5.51-1.62,1.06-1.21,1.39-4.02.75-5.61-2.16-5.33-6.11-9.27-11.49-11.42-3.82-1.52-6.3.43-6.32,4.56ZM280.67,910.25c.14-.02.28-.04.42-.05-.57-3.87-.81-7.83-1.86-11.57-.52-1.87-2.52-3.32-3.85-4.96-1.21,1.8-3.34,3.54-3.47,5.42-.41,6.17-.34,12.4.12,18.57.11,1.51,2.71,4.22,3.6,4.01,1.88-.45,4.19-2.16,4.85-3.91.83-2.21.2-4.97.2-7.5ZM1617.76,734.39c-1.72,1.4-2.42,1.73-2.72,2.27-.43.78-.92,1.77-.79,2.58,1.51,9.51,5.1,18.22,10.92,25.87.71.93,3.15.54,4.8.76.22-1.65,1.09-3.58.54-4.91-2.76-6.61-5.85-13.08-8.91-19.56-1.03-2.19-2.31-4.26-3.83-7.02ZM1010.29,639.85c-13.08-.45-33.12,5.56-37.18,11.47,2.78-.55,4.98-1.2,7.22-1.37,3.9-.28,7.92-.89,11.7-.24,9.37,1.62,13.37-.19,18.26-9.87ZM1320.82,265.01c4.49,5.38,8.38,10.07,12.31,14.72,1.62,1.92,3.16,4.41,6.23,2.16,2.71-1.99,3.15-4.67,1.34-7.31-2.61-3.8-5.19-7.74-8.47-10.93-4.83-4.71-7.79-3.93-11.41,1.35ZM1377.06,582.79c1.1-1.31,3.13-2.87,4.01-4.92,1.82-4.25,2.87-8.83,4.53-13.16,1-2.62,2.02-4.92-1.59-6.16-3.01-1.03-6.24-1.78-7.58,2.18-1.86,5.5-3.44,11.11-4.84,16.74-.81,3.24,1.36,4.61,5.47,5.32ZM807.58,662.02c5.12,2.8,9.78,5.68,14.74,7.86,1.42.62,4.39-.18,5.44-1.39,1.12-1.29,1.76-4.98.98-5.62-3.85-3.13-7.96-6.39-12.54-8.04-3.65-1.31-6.1,2.31-8.63,7.18ZM256.48,313.71c21.32,12.02,42.64,24.04,63.96,36.06-7.01-9.29-42.26-29.43-63.96-36.06ZM1581.29,900.38c-.08-.02-.16-.03-.24-.05.05-.69.1-1.38.14-2.08.23-3.65-1.63-5.8-5.09-6.21-3.9-.46-5.42,2.16-5.55,5.53-.17,4.6-.34,9.26.2,13.81.18,1.55,2.43,3.88,3.85,3.97,1.41.09,3.79-1.91,4.32-3.48,1.24-3.68,1.64-7.65,2.37-11.51ZM1549.07,257.34c-5.28-14.68-30.83-44.68-40.44-48.12,14.02,16.69,27.23,32.4,40.44,48.12ZM1355.32,331.83c0-3.46.56-5.87-.09-7.87-3.31-10.16-9.75-18.48-16.38-26.65-.43-.54-.96-1.22-1.55-1.36-1.04-.24-2.46-.53-3.16-.02-.64.47-.88,2.03-.68,2.98.23,1.07,1.17,1.98,1.77,2.97,5.58,9.1,11.13,18.22,16.75,27.3.43.7,1.34,1.1,3.33,2.65ZM1274.82,168.67c5.35.14,11.87-5.37,11.64-9.96-.18-3.61-2.37-5.38-5.86-5.61-5.89-.4-11.88,4.05-12.28,9.07-.3,3.7,2.39,6.39,6.5,6.5ZM1747.17,858.48c-2.8-4.84-5.54-9.89-8.62-14.74-1.27-1.99-2.82-5.05-5.95-3-2.94,1.93-4.69,5.23-2.49,8.42,3.15,4.56,6.98,8.68,10.74,12.77.7.76,2.73,1.05,3.7.6.99-.46,1.43-2.1,2.62-4.05ZM772.2,907.64c6.06,4.54,49.78,17.73,55.36,16.66-17.52-9.42-35.56-13.72-55.36-16.66ZM141.83,1023.54c-8.88-19.23-17.76-38.46-26.96-58.4,5.04,21.9,12.24,41.94,26.96,58.4ZM79.18,507.24c.21-.58.43-1.16.64-1.75-3.76-1.58-7.39-3.93-11.3-4.54-5.21-.81-10.64-.5-15.94-.12-1.26.09-2.57,2.27-3.4,3.75-.19.34,1.51,2.52,2.37,2.54,9.2.19,18.41.12,27.62.12ZM1246.87,155.6c2.26-12.6,4.74-25.27.81-38.03-4.63,12.53-4.02,25.21-.81,38.03ZM751.69,714.44c3.7,4.44,19.87,5.75,39,4.05,1.8-.16,3.5-1.41,5.25-2.16-.19-.63-.38-1.26-.57-1.89h-43.67ZM1686.84,844.28c4.39-3.02,7.26-5.27,10.37-7.08,3.38-1.97,4.3-4.48,3.08-8.13-.86-2.58-2.21-3.92-5.08-3.39-3.42.63-7.25.75-7.67,5.42-.37,4.06-.45,8.15-.71,13.18ZM397.51,1098.66c-12.67,4.16-25.33,8.32-38.13,12.52,9.55.79,29.36-5.4,38.13-12.52ZM1744.08,723.07c-14.03-6.58-28.71-11.74-44.51-12.7,14.84,4.23,29.67,8.46,44.51,12.7ZM1462.68,948.52c.58-.09,1.15-.17,1.73-.26-.97-14.6-1.94-29.2-2.91-43.8-.53.03-1.06.07-1.59.1.92,14.65,1.85,29.3,2.77,43.95ZM307.61,1115.62c-7.56-.84-14.69-1.49-21.79-2.47-6.78-.93-13.52-2.21-20.28-3.33,13.57,4.74,27.42,6.88,42.06,5.8ZM1044.95,1008.52c-.02.1-.05.19-.07.29h39.87c0-.1,0-.19,0-.29h-39.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M898.61,814.98c-9.2-9.62-15.12-12.22-22.77-9.17-6.61,2.64-11.52,9.87-11.12,16.36.42,6.7,6.13,13.5,12.71,15.14,7.97,1.98,13.96-1.55,21.06-13.06.27,2.54.81,4.25.58,5.86-1.82,12.45-4.03,24.84-5.64,37.31-1.72,13.39-2.74,26.88-4.45,40.28-.45,3.5-1.43,7.65-3.7,10.06-5.47,5.79-13.76,3.89-17.04-3.8-4.85-11.35-9.12-22.95-13.62-34.46-1.61-4.13-3.53-8.18-4.65-12.44-1.29-4.87-1.66-9.97-2.78-14.9-.86-3.76-1.41-8.02-3.58-10.95-5.12-6.88-8.82-14.29-10.92-22.5-4.73-18.52-9.86-36.97-13.76-55.67-5.44-26.11-4.43-51.74,6.83-76.7,8.81-19.54,16.24-39.7,24.2-59.62,6.34-15.86,16.74-27.82,32.54-34.83,41.13-18.26,82.5-35.92,124.99-50.8,3.39-1.19,6.86-2.14,10.7-1.97-6.18,2.62-12.36,5.23-18.52,7.88-3.94,1.7-7.79,3.57-7.96,8.68-.17,4.85,2.74,8.03,6.63,9.9,16.8,8.05,33.67,15.98,50.66,23.64,6.78,3.06,12.83-.08,18.24-4.02,8.3-6.04,16.39-12.35,24.57-18.55,11.34-8.59,22.73-17.12,34-25.8,3.13-2.41,6.19-5.01,8.82-7.93,4.75-5.26,4.59-8.29.03-14.02-.54-.68-.94-1.48-2.18-3.48,8.6.83,16.08,1.67,23.58,2.24,15.78,1.21,31.66,3.83,47.34,3,18.31-.97,36.45-5.02,54.67-7.68,22.84-3.33,45.69-6.61,68.55-9.87,1.84-.26,3.73-.35,5.59-.26,4.59.2,7.09,2.69,7.8,7.34.69,4.5-1.36,6.8-5.51,8.32-33.92,12.43-67.89,24.7-101.62,37.63-22.66,8.69-44.69,18.74-63.64,34.52-18.71,15.59-28.07,34.94-26.08,59.51.39,4.85.28,9.81-.2,14.66-1.06,10.75-10.37,14.81-19.23,8.55-1.9-1.34-3.64-2.92-5.35-4.5-34.32-31.69-74.69-41.44-119.95-32.7-32.97,6.37-61.77,20.55-84.25,46.23-21.23,24.26-29.84,52.52-25.68,84.26,1.84,14.03,5.87,27.76,8.89,41.64.48,2.2.81,4.44,1.21,6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M291.36,668.56c3.72,1.5,6.84,2.47,9.7,3.95,43.28,22.37,86.57,44.72,129.78,67.24,41.13,21.44,82.17,43.07,123.24,64.64,6.48,3.41,7.01,4.6,3.07,9.89-22.94,30.83-40.74,64.67-58.23,98.71-4.16,8.09-8.32,16.17-12.49,24.25-3.81,7.39-5.06,7.85-12.35,3.68-50.18-28.73-100.33-57.51-150.51-86.26-31.76-18.2-63.55-36.35-95.33-54.53-1.82-1.04-3.68-2.05-5.37-3.27-3.37-2.42-4.97-5.52-3.17-9.68,14.66-33.79,28.18-68.18,50.78-97.83,4.23-5.56,8.84-10.86,13.62-15.95,1.94-2.07,4.82-3.26,7.26-4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M844.29,539.91c.1-1.61-.06-2.35.2-2.89,8.17-16.82,6.65-33.98,1.65-51.18-1.88-6.48-4.13-12.88-6.61-19.16-8.57-21.71-6.31-42.49,5.08-62.52,10.11-17.8,23.81-32.81,37.78-47.52,27.1-28.53,57.65-53.01,90-75.26,24.08-16.57,51.19-20.35,79.57-17.53,32.31,3.2,64.18,8.85,95.37,18,9.16,2.69,18.21,5.78,27.2,8.98,7.44,2.64,7.32,3.59,6.16,11.3-.54,3.6.35,7.98,2.05,11.24,3.43,6.58,7.85,12.66,11.9,18.92,1.27,1.96,3.1,3.67,3.87,5.79.88,2.43,2.07,6.08.96,7.57-1.44,1.92-4.98,2.54-7.73,3.08-1.71.33-3.64-.54-5.48-.86-17.45-3.02-34.83-6.62-52.39-8.75-7.12-.86-14.9.6-21.91,2.62-10.85,3.13-14.45,9.4-11.58,20.23,3.69,13.95,8.54,27.59,12.83,41.38,1.45,4.67,3.06,9.33,4.02,14.11,1.11,5.51-.71,7.55-6.35,6.83-8.31-1.07-16.55-2.74-24.82-4.2-15.92-2.81-32.11-5.6-47.85-.93-13.3,3.95-26.26,9.52-38.75,15.64-50.83,24.87-95.86,58.37-138.86,94.79-3.55,3.01-7.24,5.87-11.04,8.55-1.31.93-3.16,1.1-5.25,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M1105.9,362.72c-2.05-8.19.88-13.58,8.81-16.57,11.62-4.39,23.51-2.81,35.26-.84,13.11,2.19,26.11,4.99,39.16,7.53.46.09.91.2,1.37.29,5.25.96,10.62,1.19,14.12-3.51,3.57-4.8.5-9.45-2.05-13.58-3.67-5.95-7.82-11.6-11.71-17.42-1.29-1.94-2.59-3.91-3.57-6.01-4.01-8.59-.92-14.96,8.43-16.4,8.06-1.24,16.24-2.27,24.36-2.2,4.37.03,9.4,1.58,12.97,4.1,29.56,20.81,58.85,42,88.22,63.08.95.68,1.84,1.43,2.73,2.19,5.57,4.82,5.72,6.47,1.14,12.08-12.68,15.54-13.45,36.2-1.62,52.43,7.97,10.93,16.35,21.56,24.51,32.36,1.42,1.88,2.62,3.92,3.93,5.89-.47.49-.95.98-1.42,1.47-3.29-1.88-6.78-3.48-9.85-5.68-17.24-12.38-34.48-24.76-51.52-37.41-34.07-25.28-72.29-40.32-114.03-46.84-2.51-.39-5.13-.05-7.7-.05-.14.96-.28,1.92-.41,2.88,19.29,3.19,38.57,6.43,57.84,14.52-18.55,2.33-26.13,8.04-27.41,19.78-1.06,9.74,5.55,19.53,15.23,22.54,9.32,2.9,19.43-1.17,24.68-9.93,6.02-10.04,3.49-18.66-8.44-31.09,6.85,3.24,13.78,6.32,20.53,9.76,26.14,13.29,49.24,31.09,72.35,48.9,8.48,6.54,17.52,12.36,26.31,18.5.76.53,1.8.82,2.33,1.52,1.19,1.58,3.34,3.82,2.9,4.93-.69,1.76-3,3.56-4.94,4.03-10.65,2.56-21.41,4.67-32.12,7.01-30.29,6.64-60.57,13.27-90.83,20.04-5.29,1.19-9.15-.61-12.28-4.55-4.64-5.84-9.04-11.88-13.76-17.66-11.52-14.11-22.96-28.42-37.81-39.17-8.82-6.38-18.46-11.76-28.16-16.75-5.87-3.02-8.99-6.42-10.5-13.29M1242.01,480.88c.4-5.21-3.3-9.07-8.97-9.36-5.7-.29-9.55,3.02-9.84,8.43-.28,5.24,2.87,8.93,8.08,9.45,5.56.56,10.32-3.22,10.73-8.52ZM1156.9,418.27c.15-5.13-3.75-9.3-8.93-9.56-5.51-.27-9.1,3.26-9.12,8.96-.01,5.39,3.66,9.09,9.15,9.22,5.01.11,8.76-3.51,8.9-8.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M560.67,464.84c7.06.75,12.43,5.61,19.25,5.39.27-.48.54-.95.81-1.43-1.96-1.25-3.89-2.56-5.89-3.73-19.52-11.43-39.1-22.75-58.54-34.32-4.78-2.85-9.18-6.39-13.56-9.86-3.41-2.69-4-6.13-1.52-9.9.51-.78.96-1.6,1.47-2.38,8.59-13.15,10.09-13.57,25.13-9.53,53.41,14.37,107.13,27.61,162.36,32.6,34.82,3.15,69.83,4.19,104.77,6.04,6.75.36,13.53.13,20.3.1,5.75-.02,9.7,2.44,11.98,7.86,8.45,20.08,16.14,40.56,16.56,62.52.22,11.47-2.81,23.02-4.65,34.49-.81,5.02-4.8,4.37-8.28,3.47-8.8-2.28-17.54-4.82-26.32-7.16-56.31-15.04-112.59-30.15-168.94-45.01-14.42-3.8-29.13-6.47-43.58-10.16-10.02-2.56-19.26-7.06-26.94-14.24-1.57-1.47-2.93-3.17-4.39-4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M1469.61,784.72c3.44,12.63,5.02,25.44-1.22,37.75-17.54,34.59-22.3,71.27-19.36,109.48,6.87,88.99,72.33,168.37,158.29,191.76,116.1,31.59,209.25-30.3,250.72-105.67,23.53-42.78,29.87-88.99,23.71-136.96-10.07-78.4-70.45-148.06-138.96-172.64-21.19-7.6-42.86-12.83-65.55-12.98-9.63-.06-13.18-3.77-13.02-13.12.1-5.44,1.65-7.35,7.22-6.88,14.86,1.27,30,1.51,44.46,4.72,85.3,18.91,143.99,70.47,174.06,151.5,25.82,69.58,20.45,139.18-17.89,203.57-37.65,63.24-93.2,102.24-166.84,114.4-97.05,16.03-193.58-32.17-239.82-110.06-30.5-51.37-42.66-106.64-32.47-165.99,4.85-28.26,14.81-54.88,28.59-80.03,1.82-3.32,4.29-6.29,6.46-9.43.54.2,1.08.39,1.61.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M904.67,730.97c-.01-10.55,2.81-20.2,8.2-29.26,15.28-25.7,37.27-41.71,66.83-47.26,9.33-1.75,17.37-.18,24.73,6.16,4.18,3.6,9.15,6.34,13.94,9.17,4.04,2.39,6.57,5.34,5.11,10.23-1.07,3.6.38,5.79,3.33,7.49,4.24,2.44,8.41,5,12.67,7.41,2.99,1.69,5.54,1.27,8.16-1.26,4.63-4.47,6.3-4.47,10.98.06,11.42,11.07,18.16,24.69,20.92,40.26,3.36,18.91-.13,36.49-10.11,53-16.85,27.9-39.68,49.89-66.63,67.71-16.96,11.22-31.91,9.7-47.19-3.75-9.75-8.59-17.34-18.95-23.31-30.35-13.42-25.57-22.06-52.81-26.94-81.24-.47-2.74-.47-5.56-.69-8.35ZM966.42,709.51c-3.07,4.7-3.09,6.27-.75,12.89,2.88,8.16,8.76,11.63,16.79,9.93,7.77-1.65,11.56-7.52,10.51-16.32-.86-7.28-.92-7.42,5.87-10.19,9.45-3.87,14.6-10.79,14.59-20.95-.01-10.21-5.49-17.66-13.85-22.88-1.91-1.19-5-1.19-7.39-.79-10.3,1.72-18.48,10.87-19.11,21.32-.58,9.73,2,18.47,9.09,25.55,1.15,1.15,2.38,2.27,3.33,3.58,3.26,4.49,2.16,10.49-2.37,13.52-4.25,2.85-9.54,1.28-12.26-3.89-1.07-2.03-1.49-4.39-2.29-6.57-.58-1.58-1.29-3.12-2.17-5.2ZM1029.96,793.91c3.79-6.33,2.38-13.94-2.22-19.15-4.28-4.84-9.36-6.05-15.07-3.58-6.66,2.88-10.02,7.81-9.5,13.91.65,7.62,6.77,14.33,16.28,16.43-2.66-3.41-4.41-5.97-6.48-8.23-3.03-3.3-5.25-6.75-2.9-11.26,1.87-3.6,4.91-5.56,9.14-5.09,5.03.57,6.86,4.22,8.07,8.47.68,2.37,1.48,4.7,2.69,8.51ZM1048.82,744.97c-4.69-9.33-18.47-9.81-23.76-2.28-3.81,5.42-3.99,11.75-.48,17.05,3.8,5.74,9.62,7.52,18.03,5.17,2.69-.75,7.39-.92,6.39-4.77-1.01-3.9-4.6-.9-7.03-.29-5.29,1.33-9.16.12-11.71-3.76-2.04-3.11-1.97-6.16.32-9.06,3.09-3.91,7-5.09,11.81-3.49,2.07.69,4.28.97,6.43,1.43ZM948.3,758.15c4.21,6.92,10.68,9.03,16.5,6.85,6.38-2.39,10.25-8.16,9.75-14.53-.52-6.56-4.19-11.16-10.12-12.67-6.95-1.77-12.64.14-16.61,6.17,4.74,0,9.02-.24,13.27.06,5.11.36,7,2.95,6.32,7.87-.89,6.5-4.68,9.23-11.21,7.99-2.65-.5-5.26-1.16-7.89-1.75ZM1018.74,702.8c-10.01,1.46-15.38,7.83-15.63,16.23-.17,5.74,3.59,10.62,9.93,12.88,5.89,2.1,11.17.59,14.96-4.29,3.98-5.13,4.73-11.19,1.47-15.97-1.22,3.15-2.14,5.98-3.4,8.66-1.4,2.98-3.21,6.68-6.93,5.73-3.56-.91-7.25-3.08-9.8-5.74-2.82-2.94,0-6.11,1.95-8.67,2.33-3.06,4.95-5.9,7.45-8.83ZM966.71,793.27c1.06-2.93,1.59-4.37,2.11-5.82.63-1.75,1.05-3.6,1.92-5.22,2.91-5.36,8.52-7.07,12.82-4.06,4.52,3.16,5.33,8.75,1.76,13.41-1.26,1.64-3.01,2.9-4.34,4.49-.76.91-1.11,2.15-1.83,3.6,9.62-1.47,16.24-10.26,14.34-18.21-1.73-7.23-10.77-12.61-17.99-10.7-7.91,2.1-12.27,11.77-8.8,22.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M1102.8,470.59c-25.82-9.69-51.79-18.46-80.12-12.37-3.63.78-7.33,1.73-10.65,3.33-32.58,15.75-64.39,32.85-93.18,55.02-2.21,1.7-4.41,3.47-6.37,5.45-5.54,5.61-5.39,9.32,1.2,13.46,5.3,3.33,11.14,5.79,16.73,8.68,2.19,1.13,4.32,2.37,6.48,3.56.09.62.17,1.24.26,1.86-3.36,1.75-6.7,3.56-10.1,5.23-13.13,6.45-26.12,6.8-39.74.68-8.43-3.79-17.7-5.72-26.59-8.5-1.48-.46-2.92-1.04-5.79-2.08,3.68-3.48,6.48-6.43,9.58-9.01,40.66-33.74,83.73-63.96,130.24-89.17,15.22-8.25,30.45-16.54,47.81-19.07,49.99-7.28,94.75,2.52,129.95,41.51,8.74,9.68,16.74,20.04,24.91,30.22,2.24,2.79,3.85,6.08,5.75,9.14-.32.44-.63.87-.95,1.31-5.35-1.17-10.73-2.22-16.04-3.55-10.4-2.61-20.68-5.72-31.15-8.02-35.43-7.79-70.03-3.27-104.09,7.73-33.73,10.89-67.1,22.76-99.31,37.65-4.83,2.23-9.19,2.4-13.86-.6-5.68-3.64-11.79-6.62-17.54-10.17-4.57-2.82-4.94-5.25-.79-8.71,6.97-5.81,13.94-11.85,21.72-16.42,22.9-13.46,45.94-26.71,69.41-39.13,16.83-8.9,35.07-8.41,53.28-4.34,10.46,2.33,20.9,4.76,31.37,7.04,2.44.53,4.96.65,7.45.96.04-.56.09-1.12.13-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M218.91,689.86c-.98,1.71-2.17,3.33-2.89,5.14-6.23,15.59-18.41,25.15-31.7,34.77-48.4,35.06-76.48,83.2-87.09,141.73-20.29,111.9,48.76,204.88,126.99,239.29,133.81,58.85,273.81-25.18,303.59-143.71,1.08-4.29,2.31-8.55,3.38-12.85,1.87-7.51,6.98-11.89,13.9-14.53,4.73-1.8,6.72-.42,5.97,4.73-1.11,7.6-2.26,15.27-4.3,22.66-21.22,76.67-67.63,131.82-140.89,163.65-115.85,50.33-268.68-.6-318.07-140.29-13.71-38.79-18.04-79.21-12.34-120.06,5.95-42.61,24.28-80.01,51.45-113.24,23.27-28.45,51.34-50.72,84.45-66.63,2.05-.99,4.36-1.43,6.55-2.12.34.48.67.97,1.01,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M1786.15,1128.79c-4.81,7.88-9.22,16.03-14.53,23.55-4.69,6.64-11.49,10.48-19.7,11.45-2.86-4.74,3.43-11.17-4.93-14.38-3.16,7.85-5.72,16.44-13.99,20.62-2.67,1.35-5.62,2.23-8.53,2.97-2.14.55-4.42.53-8.1.92,2.02-4.33,3.46-7.38,4.88-10.44,1.08-2.33,2.74-5.05-.36-6.73-3.05-1.66-4.78.84-5.76,3.33-5.27,13.48-15.66,18.82-29.53,19.41-10.62.45-21.22,1.6-33.25,2.55,3.24-6.57,12.37-8.28,8.95-17.58-2.77,2.08-4.78,3.49-6.67,5.03-9.96,8.12-21.05,11.62-33.9,8.78-6.93-1.53-13.94-2.66-20.95-4.8,10.54-6.08,20.69-12.27,33.29-12.64,0-.75.02-1.5.03-2.24-2.09-.9-4.12-2.33-6.28-2.59-6.4-.78-12.41.75-18.28,3.49-5.89,2.76-11.88,5.55-18.13,7.23-9.18,2.48-18.25,1.65-27.92-4.43,3.34-1.52,5.77-2.21,7.68-3.6,2.93-2.13,5.7-4.57,8.1-7.26.65-.73-.23-2.84-.41-4.32-1.27.23-2.67.19-3.79.74-4.79,2.34-9.26,5.55-14.27,7.16-11.48,3.7-21.21-.39-29.87-9.28,2.13-.35,4.35-.43,6.37-1.11,4.82-1.61,9.64-3.29,14.24-5.43,1.16-.54,1.45-2.93,2.14-4.48-1.82-.59-3.68-1.75-5.44-1.62-1.7.12-3.31,1.58-4.97,2.43-8.51,4.37-17.23,5.17-26.4,2.07-10.52-3.55-31.68-18.36-38.56-27.97,2.87,0,4.96.13,7.02-.03,4.37-.33,8.79-.54,13.07-1.4,1.26-.25,2.12-2.5,3.16-3.83-1.38-.64-2.75-1.28-4.13-1.89-.19-.08-.46,0-.69.03-22.28,3.07-37.44-7.87-49.41-25.09-1.73-2.48-3.41-5-5.05-7.54-.2-.32-.03-.88-.03-2.26,14.13,4.72,29.55,3.98,42.3,13.8,1.6-4.42-.73-6.76-2.99-8.88-4.72-4.42-10.33-7.41-16.81-7.86-11.48-.8-21.43-6.13-31.84-10.12-1.45-.56-3.03-1.58-3.83-2.84-9.64-15.15-17.55-31.11-21.95-49.36,1.66.89,3.36,1.69,4.96,2.67,6.74,4.12,14,6.47,21.92,5.9,1.57-.11,3-2.07,4.49-3.18-1.3-1.12-2.55-3.15-3.9-3.22-24.81-1.34-33.7-18.94-39.62-39.09-2.59-8.83-3.66-18.12-5.42-27.2.59-.28,1.19-.56,1.78-.84,1.22,1.43,2.53,2.8,3.63,4.31,4.26,5.83,9.73,10.01,16.58,12.29,3.54,1.18,3.57,1.09,7.34-2.92-2.13-1.45-4.09-2.95-6.2-4.17-15.6-9.04-24.28-22.1-23.73-40.57.22-7.39.44-14.79.66-22.18.59-.24,1.18-.47,1.78-.71,3.27,4.23,6.4,8.57,9.84,12.64,3.61,4.27,7.91,8,11.2,12.48,3.18,4.33,5.47,9.32,8.28,14.26,3.36-1.93,3.65-5.04,2.62-7.89-1.73-4.75-3.38-9.81-6.37-13.75-6.33-8.35-13.3-16.23-20.39-23.96-4.21-4.59-5.58-9.34-3.99-15.34,2.98-11.27,5.65-22.62,8.48-33.92.8-3.2,1.67-7.2,5.56-6.96,2.41.15,4.89,2.79,6.92,4.75,3.99,3.86,7.52,8.21,11.64,11.92,1.07.96,3.61.28,5.48.35-.15-1.9.37-4.28-.58-5.61-2.56-3.59-5.81-6.66-8.65-10.06-2.6-3.11-2.87-6.58.13-9.44,13.63-13.01,27.59-25.64,42.75-36.83.41.29.83.57,1.24.86-.63,1.54-1.13,3.14-1.91,4.6-15.12,28.59-27.18,58.3-33.34,90.2-11.29,58.47-1.71,113.26,29.55,163.95,19.9,32.26,44.3,60.65,75.75,82.31,25.73,17.72,54.33,28.51,84.95,34.38,37.24,7.15,74.19,6.49,110.9-3.19,17.88-4.71,34.99-11.43,51.38-19.98,1.01-.53,2.07-.96,3.1-1.44.4.35.8.69,1.2,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M706.88,887.91c-19.44.48-38.42-5.05-57.14-11.81-16.66-6.01-33.27-12.14-49.94-18.12-4.45-1.6-6.76-4.57-7.37-9.22-.9-6.94-2.08-13.84-3.05-20.76-1.56-11.07-7.7-18.41-18.25-21.72-20-6.26-37.91-16.73-55.83-27.2-2.15-1.26-5.33-4.41-4.92-5.73,1.32-4.27,3.91-8.22,6.46-11.99.47-.7,3.05-.17,4.6.09,37.68,6.47,75.32,13.22,113.06,19.34,9.61,1.56,19.54,1.57,29.32,1.54,20.32-.07,37.29,6.7,50.68,22.36,5.29,6.19,11.07,12.11,17.4,17.19,4.4,3.52,9.94,5.91,15.32,7.81,3.8,1.35,6.88,2.85,8.3,6.66,2.2,5.89,4.54,11.76,6.22,17.81,1.82,6.56.06,8.92-6.78,10.03-2.98.48-6.05.34-9.05.73-10.53,1.35-18.58,6-21.73,16.86-1.2,4.13-3.5,6.31-8.14,5.8-2.75-.3-5.58.18-9.14.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M1061.52,1039.96c-27.98.6-55.96,1.09-83.93,1.9-6.02.18-12.01,1.54-18.02,2.35-15.88,2.13-31.09-1.21-46.19-5.59-16.12-4.68-32.2-9.47-48.42-13.77-9.82-2.61-19.89-2.56-29.79-.07-6.96,1.75-13.52.64-19.72-2.37-32.71-15.89-65.36-31.91-98.02-47.91-1.45-.71-2.82-1.66-4.11-2.64-2.37-1.79-2.41-3.85-.31-5.88,1.5-1.46,3.11-2.81,4.71-4.18,8.53-7.31,12.62-16.55,12.09-27.8-.07-1.4-.25-2.8-.22-4.19.15-5.44,1.84-6.74,7.02-4.78,10.69,4.03,21.37,8.09,31.89,12.53,23.4,9.87,46.85,19.67,69.95,30.21,6.61,3.02,12.78,7.83,17.86,13.07,3.67,3.79,5.69,9.48,7.55,14.65,1.41,3.94,2.96,6.69,7.47,6.94,15.45.85,29.52,6.39,43.27,12.95,3.16,1.51,6.25,3.17,9.47,4.51,5.42,2.25,8.01,1.66,10.11-3.57,2.12-5.28,5.71-5.95,10.56-5.64,20.48,1.32,40.96,3.16,61.47,3.53,26.34.47,52.72-.75,79.06-.37,16.76.24,33.51,1.89,50.23,3.27,8.46.7,9.35,2.08,9.48,10.46.21,13.47.21,13.41-13.46,13.38-23.33-.05-46.65-.01-69.98-.01,0-.32,0-.64-.01-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M350.7,379.21c3.5,1.7,7.06,3.29,10.49,5.11,23.49,12.41,46.91,24.97,70.46,37.27,7.12,3.72,11.48,8.88,12.96,16.99,2.89,15.84,6.58,31.52,13.48,46.2,1.93,4.12,4.33,8.02,6.52,12.01.68-.29,1.36-.59,2.04-.88-1.08-2.78-1.96-5.65-3.26-8.31-7.87-16.08-11.79-33.35-15.44-50.7-1.22-5.81.32-7.64,6.11-6.51,30.82,5.99,60.88,13.92,86.94,32.79,20.72,15,31.33,35.19,32.94,60.43.53,8.27-.44,9.35-8.9,9.07-43.23-1.45-84.52-10.06-122.63-31.75-19.84-11.29-40.43-21.26-60.62-31.95-7.69-4.07-7.63-4.23-4.41-12.01,3.03-7.31,2.94-14.83-.32-21.79-6.52-13.92-13.64-27.55-20.59-41.27-2.28-4.5-4.79-8.88-7.2-13.32.47-.46.93-.92,1.4-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M307.54,966.38c1.3-5.61,2.43-10.8,3.74-15.94.25-.99,1.2-1.81,2.53-3.7,1.98,3.38,3.89,5.93,4.97,8.8.5,1.32-.08,4.17-1.09,4.76-5.95,3.49-2.56,7.32-.71,12.96,2.35-3.41,4.04-5.65,5.5-8.03,3.49-5.69,4.46-5.93,9.59-1.92,1.29,1,2.49,2.13,3.85,3.03,7.79,5.23,17.78.41,18.54-8.99.13-1.6.01-3.3-.38-4.86-1.26-5.01-.49-8.87,6.12-10.1-1.48-1.84-2.49-3.11-3.51-4.38q5.79-3.69,13.38,4.41c.66-2.02,1.06-3.64,1.71-5.15.82-1.89,1.46-4.08,2.86-5.43,2.91-2.81,5.42-1.47,7.12,4.34,7-13.14,21.08-13.86,31.92-19.99,4.52-2.56,7.97.38,6.93,5.62-6.9,34.73-24.01,62.7-55.78,79.76-54.3,29.17-120.05,7.8-146.91-47.55-15.85-32.66-14.12-84.08,19.22-118.55,3.08-3.18,6.35-6.18,9.57-9.23,2.71-2.57,5.29-2.78,7.52.63,3.71,5.67,7.74,11.26,7.6,18.45-.11,5.81,2.51,9.85,7.53,12.37,3.64,1.83,5.85,4.57,6.38,8.58.61,4.61-1.4,6.53-5.99,5.77-1.14-.19-2.25-.63-3.38-.9-3.87-.91-6.89.3-8.97,3.7-2.03,3.31-1.08,6.24,1.26,8.95.3.35.65.67.95,1.03,5.22,6.09,4.88,7.9-2.6,10.77-4.76,1.83-9.03,3.83-9.95,9.59-.91,5.65.94,10.13,5.95,13.05,2.2,1.28,4.67,2.09,6.99,3.17,2.72,1.27,3.73,3.02,2.49,6.16-2.81,7.15-.15,12.84,6.76,15.22,6.86,2.36,6.94,2.37,5.56,9.74-1.03,5.54-.07,10.19,5.01,13.41,4.86,3.08,9.55,2.89,14.42-.15,7.34-4.58,7.4-4.49,13.29.58ZM315.83,980.81c-18.29-1.76-35.38-6.28-49.24-19.23-13.84-12.93-20.9-29.37-24.72-47.54-2.81,43.08,50.63,74.88,73.96,66.77ZM242.23,894.42c4.75-10.39,9.07-19.83,13.38-29.27-7.9,8.01-11.93,17.67-13.38,29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M1673.11,760.48c2.66,11.67,5.16,22.63,7.92,34.73-2.92,0-4.89-.12-6.84.02-5.39.41-8.87,4.04-8.75,8.99.13,5.55,3.78,8.92,9.58,8.8.69-.01,1.38-.2,2.08-.26,7.07-.64,7.98.21,7.17,6.99-1.13,9.48-2.31,18.96-3.54,28.44-.17,1.31-.71,2.58-1.56,5.56-1.72-2.76-2.88-4.25-3.66-5.92-16.18-34.63-32.26-69.3-48.5-103.91-7.23-15.4-14.76-30.66-22.15-45.98-.61-1.26-1.24-2.51-1.79-3.79-2.73-6.31-1.74-8.09,5.06-8.17,12.36-.16,24.72.01,37.08-.15,2.48-.03,4.95-.93,7.43-1.43-.05-.61-.09-1.21-.14-1.82-1.41-.26-2.82-.75-4.23-.76-12.59-.06-25.19-.22-37.78.05-8.5.18-15.32-2.99-19.47-10.12-7.14-12.27-13.66-24.91-20.27-37.48-2.24-4.27.88-6.12,4.25-6.96,8.13-2.03,16.29-4.08,24.54-5.5,37.85-6.54,75.72-6.7,113.25,1.9,15.62,3.58,30.8,9.07,46.15,13.8,1.34.41,2.43,1.64,5.02,3.46-6.73,1.33-11.85,2.45-17.01,3.35-21.35,3.74-42.75,7.21-64.06,11.17-17.11,3.18-25.32,17.14-22.01,34.32,3.71,19.21,6.31,38.63,9.35,57.97.09.6-.34,1.28-.64,2.28-5.46-2.06-10.92-3.87-14.66,2.64-2.21,3.85-1.55,7.29,1.97,10.66,5.99,5.75,10.57.61,16.22-2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M777.04,621.96c-33.73-19.75-67.46-39.51-101.19-59.26.27-.68.55-1.36.82-2.04,37.99,11.4,75.97,22.81,113.96,34.21.23-.56.46-1.12.7-1.68-3.65-1.64-7.18-3.69-10.98-4.87-32.5-10.07-65.19-19.56-97.53-30.11-20.8-6.79-41.11-15.07-61.64-22.7-5.64-2.1-10.08-5.4-13.02-10.97-2.6-4.93-6.96-5.67-11.9-2.9-4.71,2.64-5.47,5.49-3,11.12.44,1,.84,2.01,1.78,4.31-5.53-1.64-8.13-4.59-9.32-8.66-.91-3.1-1.4-6.4-1.57-9.63-.31-6.08,1.68-7.67,7.6-6.03,14.16,3.91,28.27,7.99,42.4,12,45.07,12.8,90.15,25.59,135.21,38.43,9.19,2.62,18.31,5.48,27.49,8.13,14.79,4.25,25.71,13.83,35.02,25.52,4.37,5.48,5.55,11.77,2.94,18.45-2.29,5.85-4.27,11.9-7.24,17.39-8.87,16.38-22.39,22.36-40.44,17.7-6.01-1.55-12.03-3.96-17.35-7.14-54.04-32.29-107.95-64.81-161.87-97.31-2.87-1.73-5.5-3.87-9.09-6.42,7.1-3.35,12.44-3.49,18.9-.86,40.14,16.35,76.69,39.37,114.16,60.69,12.56,7.15,25.07,14.39,37.66,21.5,2.09,1.18,4.44,1.92,6.67,2.86.28-.57.55-1.15.83-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M1047.11,952.92c-4.13,3.06-7,5.23-9.92,7.33-4.55,3.27-9.2,6.38-13.67,9.75-3.09,2.33-5.52,2.35-8.6-.36-6.38-5.63-6.97-5.09-13.56-.22-3.13,2.31-7.48,3.96-11.34,4.1-12.57.46-25.18.03-37.77.08-4.65.02-8.13-1.43-10.07-5.94-2.04-4.75-5.77-5.4-10.44-4.27-10.89,2.63-15.44.11-18.99-10.46-1.88-5.6-3.67-11.05-9.61-13.9-2.51-1.21-2.48-3.44-1.41-6,3.84-9.13,3.81-9.23-4.72-15.18-3.37-2.35-3.78-5.6-3.71-9.22.35-18.25,2.56-36.27,6.53-54.08,3.79-17,5.87-34.04,1.11-51.21-1.06-3.81-2.49-7.52-3.63-11.32-2-6.67-2.68-13.43,1.12-19.62,1.28-2.1,3.85-4.14,6.13-4.57,1.11-.21,3.48,3.12,4.35,5.23,6.66,16.14,12.33,32.74,19.88,48.44,4.67,9.72,11.49,18.63,18.46,26.97,7.34,8.79,17.56,13.58,28.79,16.17,7.71,1.78,8.11,2.56,6.29,10.01-3.55,14.49-7.26,28.94-10.9,43.4-.51,2.03-1.09,4.06-1.5,6.11-1.3,6.53.45,9.23,7.32,10.98,12.64,3.23,25.32,6.33,37.97,9.54,10.08,2.56,20.15,5.2,31.87,8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M424.18,925.03c8.25,3.89,15.54,7.42,22.91,10.76,3.6,1.63,7.26,3.26,11.06,4.32,10.9,3.05,20.91,7.46,29.45,15.26,2.93,2.67,7.29,4.13,11.25,5.25,6.98,1.97,7.56,2.51,5.12,9.61-6.13,17.81-15.17,34.09-26.66,48.94-45.43,58.74-106.07,82.94-178.92,75.53-73.62-7.49-140.3-66.73-158.61-138.42-16-62.67-3.6-119.69,35.02-171.16,5.85-7.8,13.08-14.56,19.73-21.75.73-.79,1.87-1.21,3.1-1.98,3.83,3.49,3.23,7.11.87,10.63-1.55,2.3-3.57,4.3-5.46,6.36-34.62,37.72-49.7,82.55-47.96,133.27.29,8.53,2.28,17.04,3.98,25.46.39,1.92,2.57,3.89,4.43,5.01,5.76,3.5,12.14,3.78,18.16,1.1,8.5-3.79,16.67-8.31,25.04-12.4,7.99-3.9,8.49-3.62,10.78,4.96.24.9.55,1.78.78,2.69,2.21,8.49,1.4,9.91-7.11,12.56-7.12,2.22-14.28,4.34-21.34,6.72-9.1,3.06-13.59,10.48-15.93,18.99-.81,2.93.77,6.87,2.11,9.97,9.23,21.36,23.17,39.28,40.69,54.46,23.48,20.34,50,34.91,80.42,41.99.23.05.45.12.68.18,19.67,4.64,30.06-4.15,28.03-24.17-1.1-10.89-3.03-21.7-4.46-32.56-.91-6.91-.24-7.63,6.63-8.29,2.32-.22,4.65-.5,6.97-.55,7.9-.16,9.72,2.33,9.06,10.16-.87,10.19-1.65,20.44-1.42,30.64.34,15.5,10.54,25.03,25.96,24.98,17.86-.06,34.56-4.95,50.22-13.28,30.98-16.48,57.87-37.53,75.73-68.55,3.66-6.37,6.36-12.94,6.38-20.44.02-9.51-4.03-15.66-13.35-17.97-9.03-2.24-18.26-3.73-27.47-5.14-8.52-1.3-17.15-1.94-25.7-3.08-7.2-.96-8.02-2.23-6.18-9.07,1.81-6.71,3.82-13.37,6.02-20.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1239.16,594.73c2.82.95,4.39,1.38,5.89,1.99,14.02,5.73,28.1,11.31,41.97,17.39,3.44,1.51,6.89,4.16,9.06,7.2,8.94,12.52,17.33,25.44,26.06,38.11,2.61,3.79,2.88,7-.33,10.64-4.31,4.88-7.36,11.53-12.58,14.81-7.91,4.96-12.51,11.03-15.86,19.64-2.43,6.24-8.14,11.24-12.57,16.64-2.59,3.16-6.03,3.15-9.57,1.66-14.37-6.1-28.83-12.02-43.04-18.46-3.2-1.45-6.06-4.39-8.19-7.29-8.68-11.85-17.06-23.92-25.46-35.97-4.04-5.79-4.05-7.77.17-13.12,12.71-16.11,25.48-32.18,38.37-48.15,1.75-2.17,4.34-3.65,6.09-5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M703.23,900.59c14.23,2.16,20.69,8.23,21.72,20.27.63,7.37,1.03,14.95.01,22.22-1.55,11.05-8.79,17.72-19.6,20.18-13.59,3.09-27.31,2.15-41.04.97-28.39-2.43-55.13-11.19-81.65-20.86-6.56-2.39-13.29-4.32-19.83-6.76-5.23-1.95-6.27-4.17-3.81-9.07,9.7-19.35,19.36-38.72,29.59-57.78,4.62-8.6,7.51-9.1,16.65-5.81,19.06,6.85,38.09,13.78,57.17,20.58,3.93,1.4,6.81,3.49,8.65,7.45,1.55,3.33,4.24,6.11,6.11,9.32,2.34,3.99,4.88,7.97,6.4,12.29,2.63,7.48,7.57,12.15,14.99,14.34,3.79,1.12,7.66,2.04,11.53,2.85,5.43,1.14,8.12-1.09,6.34-6.21-2.11-6.07-5.52-11.7-8.54-17.43-1.05-1.99-2.63-3.69-4.7-6.53ZM617.34,910.94c-8.48-.05-16.25,11.61-12.78,19.28,1.37,3.02,3.53,4.8,7.19,4,5.29-1.16,11.66-7.48,12.72-12.81,1.14-5.7-2.09-10.43-7.13-10.46ZM664.53,950.1c8.44.28,15.12-9.55,11.54-16.99-2.04-4.25-5.59-5.59-9.66-3.43-5.06,2.67-7.87,7.12-8.65,12.65-.64,4.51,2.32,7.63,6.77,7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M1092.71,947.16c-1.42-.32-1.69-.31-1.87-.44-10.46-7.25-11.03-7.17-17.19,4.37-1.66,3.1-4,2.73-6.54,2.16-10.92-2.46-21.85-4.85-32.72-7.51-17.43-4.26-34.82-8.71-52.22-13.09-1.58-.4-3.13-.9-4.69-1.37-3.49-1.06-4.87-3.29-3.95-6.92,4.65-18.3,9.08-36.66,14.12-54.85.71-2.57,3.96-5.32,6.65-6.32,10.48-3.87,19.73-9.63,27.79-17.17,10.73-10.03,21.08-20.46,31.6-30.72,1.14-1.11,2.31-2.18,3.71-3.51,3.94,1.85,4.33,4.55,2.91,8.04-1.4,3.45-2.94,6.87-3.99,10.43-2.71,9.21-2.35,18.46.47,27.59,1.3,4.23,1.06,8.06-.84,12.16-2.91,6.29.82,10.9,7.87,10.28,1.61-.14,3.6-.82,4.77-.14,6.99,4.07,14.05,8.14,20.52,12.96,2.03,1.51,3.16,5.33,3.24,8.14.21,7.36,4.14,11.47,10.3,14.41,6.15,2.94,6.26,3.49,3.06,9.38-3.12,5.74-6.29,11.44-9.53,17.11-1,1.75-2.29,3.33-3.46,5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M119.69,475.55c11.4-4.51,22.12-9.65,33.37-12.93,10.45-3.04,21.44-4.34,32.26-5.97,29.97-4.52,59.98-8.73,89.95-13.25,11.75-1.77,23.41-4.14,35.14-6.08,6.36-1.05,8.11-.45,13.8,4.13-2.85.93-5.01,1.98-7.28,2.33-27.43,4.22-54.9,8.18-82.3,12.54-16.81,2.68-33.58,5.66-50.26,9.02-14.58,2.93-27.89,9.25-40.08,17.64-6.5,4.48-13.45,6.17-21.1,5.98-7.42-.19-8.81-1.75-8.06-9.9-2.56,1.03-4.77,2.07-7.08,2.83-13.27,4.39-26.54,8.79-39.86,13.03-4.47,1.42-7.02-.07-9.39-4.87-2.06-4.18-4.06-8.39-6.14-12.55-2.98-5.96-1.79-8.28,4.88-9.65,11.41-2.35,22.82-4.7,34.2-7.2,3.27-.72,6.43-1.93,9.64-2.91-.12-.62-.25-1.25-.37-1.87-8.52,1.18-17.05,2.36-27.23,3.77,2.14-2.38,3.02-3.62,4.15-4.57,12.9-10.8,28.67-15.07,44.35-19.76,34.84-10.44,70.66-14.83,106.69-18.26,11.12-1.06,22.15-3.15,33.23-4.74,2.34-.34,4.71-.52,7.06-.77.12.65.23,1.29.35,1.94-15.69,4.42-31.37,8.83-47.06,13.25.1.58.2,1.15.3,1.73,2.22-.2,4.5-.14,6.65-.66,14.04-3.43,28.1-6.81,42.05-10.56,6.52-1.76,12.24-1.2,17.96,2.59,6.53,4.32,13.42,8.08,21.74,13.03-3.17,1.31-4.63,2.27-6.19,2.52-38.45,6.08-76.92,12.03-115.37,18.13-14.02,2.23-28.11,4.23-41.93,7.38-10.43,2.37-19.88,7.48-28.05,14.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M1464.58,695.69c-.59-4.84.94-9.12,4.72-11.85,15.68-11.28,31.44-22.46,47.45-33.26,5.06-3.41,7.72-2.15,10.46,3.56,4.14,8.61,8.05,17.33,12.07,26,1.54,3.33,2.18,6.7,0,9.99-3.71,5.63-2.34,11.1.36,16.57,8.68,17.54,17.37,35.08,26.04,52.62,1.24,2.51,2.53,5,3.58,7.58,1.85,4.54,1.26,8.72-2.44,12.15-3.92,3.64-7.77,7.39-11.96,10.71-5.33,4.22-11.56,4.6-17.96,2.99-1.3-.33-3.18-.9-3.56-1.85-2.42-5.99-8.25-7.18-13.09-9.7-8.88-4.63-17.82-9.16-26.86-13.47-2.65-1.26-5.66-2.03-8.58-2.4-6.72-.84-9.56-2.7-11.14-9.53-1.47-6.33-2.16-12.85-3.12-19.3-2.02-13.6-3.99-27.21-5.98-40.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M1674.13,722.89c2.2,0,4.41-.15,6.6.02,33.75,2.68,63.85,15.13,90.81,35.09,48.71,36.06,73.54,85.25,76.81,145.21,4.9,89.92-55.99,170.58-143.4,192.69-105.06,26.58-210.57-43.72-231.13-147.63-6.69-33.78-4.6-66.79,7.47-99.09.94-2.53,2.08-4.98,4.25-7.09-.17,1.08-.15,2.24-.53,3.24-6.68,17.33-9.93,35.41-11.62,53.81-1.08,11.72-.21,23.34,2.93,34.66,1.03,3.73,2.92,7.42,5.19,10.56,4.42,6.11,10.73,8.3,17.93,5.84,5.94-2.03,11.6-4.86,17.39-7.3,5.98-2.52,7.89-1.9,10.08,3.14,3.49,8.03,2.55,12.3-3.39,14.68-2.16.87-4.45,1.4-6.68,2.09-18.58,5.79-26.01,20.39-18.32,38.21,3.74,8.67,8.7,17.19,14.71,24.45,24.49,29.58,54.39,51.62,91.86,62.04,7.33,2.04,15.12,3.27,22.72,3.38,12.38.17,18.3-6.07,19.06-18.43.18-3.01-.13-6.06-.1-9.09.04-3.34,1.8-4.95,5.17-5.34,9.24-1.08,11.94.99,13.14,10.47,1.7,13.46,11.42,22.32,25.06,22.57,11.17.2,21.78-2.85,31.91-7.07,37.24-15.51,68.93-38.08,90.05-73.35,3.42-5.72,6.17-12.13,7.77-18.58,2.52-10.17-.6-15.71-9.65-20.8-3.05-1.71-7.42-2.26-6.33-7.7,1.46-7.24,3.2-9.23,10.12-10.24,16.49-2.43,25.2-10.89,26.6-27.5,4.23-50.3-10.27-94.91-41.87-134.06-4.75-5.89-10.77-10.34-18.03-12.82-7.99-2.72-13.9-1.07-19.45,5.3-1.22,1.4-2.27,2.96-3.37,4.47-4.43,6.11-9.91,6.26-14.86.56-2.65-3.06-.98-5.64.53-8.28,4.02-7.02,5.29-14.3,2.83-22.19-2.29-7.34-7.07-12.47-13.54-16.24-13.5-7.88-28.25-12.02-43.54-14.53-5.16-.85-10.33-1.7-15.49-2.55.11-.87.22-1.73.32-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M1314.17,498.1c9.17-2.31,18.36-4.57,27.51-6.97,4.95-1.3,9.94-2.57,14.71-4.37,8.14-3.07,9.62-7.12,4.79-14.51-4.83-7.4-10.36-14.35-15.69-21.42-6.17-8.19-12.66-16.14-18.59-24.5-2.79-3.93-5.16-8.36-6.73-12.9-3.25-9.41-.12-17.56,8.88-21.6,19.54-8.76,39.33-17,59.08-25.27,4.49-1.88,6.59-.68,9.13,4.71,4.76,10.11,9.35,20.31,14,30.48,5.23,11.44,10.25,22.98,15.71,34.31,4.81,10,5.62,20.54,5.46,31.35-.06,4.09-2.18,6.44-5.68,7.95-8.98,3.87-17.97,7.7-26.93,11.63-4.65,2.04-7.31-.32-9.97-3.78-5.08-6.6-10.24-7.93-17.01-4.94-5.49,2.43-8.11,6.77-8.5,12.58-.13,1.85.1,3.73.04,5.59-.21,6.27-2.24,7.51-7.61,4.23-5.06-3.08-10.48-3.72-16.14-3.35-8.74.58-17.47,1.32-26.2,2-.09-.41-.18-.83-.28-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M1302.92,773.28c.2,2.54.98,5.19.49,7.59-2.68,13.23-4.58,26.75-8.75,39.51-10.46,31.97-6.29,62.09,9.26,91.15,5.6,10.47,11.6,20.76,17.88,30.84,19.33,31.07,5.8,72.47-29.54,86.24-21.44,8.35-43.65,11.41-66.38,11.85-16.08.31-32.16.3-48.24.29-8.24,0-10.28-2.23-10.27-10.49,0-1.4.05-2.8.12-4.19.36-7.18,1.88-9.13,9.32-9.29,18.41-.41,36.83-.22,55.23-.66,14.47-.34,28.87-1.75,42.72-6.39,3.73-1.25,7.43-2.8,10.88-4.7,17.41-9.6,25.1-27.81,18.11-46.41-4.14-11-10.18-21.43-16.44-31.44-9.81-15.69-19.53-31.35-22.8-49.89-6.04-34.26.75-65.31,24.11-91.91,3.9-4.44,8.14-8.59,12.23-12.88.7.26,1.4.52,2.09.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M319.95,399.08c-20.64-12.11-41.29-24.22-61.93-36.34.25-.48.5-.96.76-1.45,22.75,10.17,45.51,20.35,68.26,30.52.37-.67.74-1.34,1.11-2.02-2.16-1.29-4.23-2.75-6.49-3.83-24.2-11.53-48.43-23.01-72.65-34.49-5.48-2.6-11.01-5.08-16.44-7.77-2.19-1.08-4.19-2.56-7.58-4.66,5.57-4.5,9.81-8.89,14.93-11.67,2.42-1.32,6.93-.43,9.78.93,19.57,9.32,38.99,18.97,58.39,28.65,8.55,4.27,17.02,8.71,25.36,13.36,2.77,1.55,5.91,3.5,7.4,6.11,10.07,17.59,19.95,35.3,29.42,53.22,2.46,4.64,3.46,10.12,4.72,15.31.53,2.17.42,4.71-.13,6.89-1.81,7.09-6.77,9.03-13.06,5.35-46.92-27.4-93.83-54.82-140.76-82.2-4.23-2.47-8.61-4.67-12.85-7.11-4.62-2.66-5.37-4.82-2.39-8.97,10.83-15.09,9.02-15.02,24.4-6.43,27.69,15.46,55.38,30.9,83.09,46.32,1.72.96,3.58,1.66,5.37,2.48.43-.74.85-1.48,1.28-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M196.5,744.93c2.94,6.75,2.43,9.76-2.12,14.4-4.9,4.99-9.96,9.83-14.76,14.92-25.06,26.61-39.55,58.71-46.57,94.05-20.05,100.82,39.81,180.64,105.19,212.17,74.05,35.72,165.14,23.91,227.28-42.04,3.93-4.17,7.85-8.37,12.04-12.28-4.63,16.09-47,51.72-78.79,66.03-32.56,14.66-66.89,19.54-102.42,17.15-69.24-4.66-161.91-60.24-179.58-166.26-7.62-45.72-1.58-89.28,20.87-130.05,14.72-26.73,33.13-50.45,58.86-68.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M542.01,1078.94c4.45-16.81-2.75-30.14-11.68-43.26-4.27,1.33-3.36,4.49-2.76,7.34,1.64,7.74,3.5,15.44,5.11,23.19,2.69,12.97-.28,24.95-8.93,34.61-7.56,8.45-16.61,15.56-25.07,23.2-.77.69-1.96.91-4.49,2.02.63-9.12.7-17.18,2.01-25.03.44-2.64,3.96-4.82,6.2-7.09,1.29-1.31,2.83-2.37,4.67-3.88-10.53-4.87-20.59.75-21.98,11.38-.75,5.76-.79,11.62-1.32,17.41-1.01,10.95-6.48,19.24-15.46,25.37-7.25,4.95-14.92,9.03-24.46,12.87,4.31-14.5,12.02-27.53,1.8-41.15,1.35-1.12,2.31-2.05,3.4-2.8,54.74-37.88,90.15-88.83,104.23-154.2,1.08-5,1.94-10.1,3.56-14.93,1.48-4.42,4.27-5.41,7.33-2.5,13.92,13.24,25.77,27.7,26.11,48.38.13,8.14-1.48,15.99-5.44,22.89-11.95,20.81-24.38,41.34-36.7,61.93-1.02,1.7-2.65,3.03-4,4.53-.71-.09-1.42-.18-2.14-.28ZM568.36,1031.42c5.05-2.78,6.29-6.7,6.15-10.88-.51-14.97-8.52-26.13-19-35.86-.79-.73-2.86-1.06-3.65-.54-.83.55-1.42,2.55-1.08,3.56.81,2.38,2.05,4.68,3.44,6.79,6.61,10.02,11.38,20.71,12.43,32.83.09,1.05.82,2.05,1.7,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M1500.58,491.9c-1.61,1.73-2.94,4.07-4.93,5.13-7.82,4.15-15.85,7.89-23.8,11.79-4.57,2.24-7.07-.3-8.84-4.02-3.22-6.73-6.29-13.53-9.41-20.31-20.66-44.9-41.31-89.8-61.96-134.7-.58-1.27-1.16-2.55-1.69-3.84-2.8-6.8-1.65-9.49,5.19-12.54,5.74-2.56,11.5-5.08,17.15-7.84,8-3.9,10.95-2.99,14.76,5.26,9.19,19.89,18.3,39.82,27.46,59.73,13.92,30.29,27.86,60.57,41.76,90.88,1.45,3.16,2.66,6.43,4.32,10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M259.4,287.81c7.99-2.44,16.35-3.47,24.58-2.49,15.01,1.79,30.01,3.98,44.83,6.96,44.08,8.85,88.05,18.23,132.1,27.26,11.84,2.43,12.4,3.56,5.92,13.53-8.12,12.5-16.05,25.12-23.99,37.74-3.41,5.42-5.35,6.36-11.49,2.7-27.49-16.38-56.98-28.68-85.74-42.44-26.67-12.76-53.45-25.31-80.17-37.96-2.22-1.05-4.4-2.21-6.59-3.32.18-.66.37-1.33.55-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M1177.19,812.99c-1.36-8.17-7.64-9.5-13.52-11.71-3.2-1.2-6.16-3.34-8.86-5.52-8.87-7.19-17.62-14.52-26.31-21.93-5.69-4.86-5.69-6.29-.77-11.94,1.07-1.23,2.27-2.36,3.27-3.64,3.66-4.72,3.37-8.21-.97-12.17-1.03-.94-2.21-1.71-3.27-2.63-2.68-2.33-3.37-4.97-1.01-7.94,4.5-5.66,8.88-11.42,13.63-16.86,1.17-1.34,3.62-2.34,5.41-2.24,5.84.32,10.55-1.6,14.23-5.99,3.08-3.67,6-3.48,9.56-.59,18.82,15.31,37.76,30.46,56.57,45.78,4.58,3.73,4.92,5.71,2.07,10.85-2.58,4.66-4.07,9.2-2.56,14.67.51,1.84-.5,4.62-1.72,6.31-3.82,5.29-7.94,10.37-12.19,15.32-3.64,4.24-5.61,4.22-10,.62-7.02-5.76-8.88-5.47-14.56,1.82-2.08,2.67-4.56,5.03-6.86,7.53-.71.09-1.43.17-2.14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M495.04,932.58c2.5,1.05,4.34,2.08,6.32,2.59,3.01.77,5.63-.14,7.11-3.02,1.48-2.88.65-5.29-1.73-7.48-6.04-5.56-6.12-5.67-2.82-11.99,15.77-30.19,31.91-60.16,51.39-88.19,1.33-1.91,2.69-3.81,4.12-5.65,2.73-3.53,5.67-5.15,10.19-2.4,1.86,1.13,4.97,1.38,7.08.71,4.79-1.54,6.65.89,7.51,4.69,1.07,4.77,1.7,9.64,2.48,14.47.93,5.75,2.32,11.49,2.56,17.28.15,3.74-.63,7.95-2.32,11.27-10.24,20.14-20.73,40.16-31.48,60.03-1.89,3.5-4.91,7.06-8.31,8.96-13.02,7.27-26.32,14.06-39.72,20.61-2.93,1.43-6.82,1.95-10.06,1.47-8.63-1.27-11.83-8.5-7.46-16.04,1.48-2.55,3.39-4.84,5.14-7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1552.61,688.95c-4.58.35-6.34-2.7-7.88-5.95-6.39-13.47-12.82-26.93-19.12-40.44-13.67-29.34-27.24-58.73-40.89-88.08-5.03-10.81-4.75-11.43,6.43-16.35,5.75-2.53,11.31-5.47,16.96-8.23,6.11-2.98,8.78-2.27,11.85,3.73,2.44,4.77,4.41,9.76,6.65,14.63,17.64,38.3,35.29,76.59,52.93,114.89,1.07,2.33,2.67,4.58,3.02,7.02.28,1.92-.37,5.26-1.65,5.91-8.9,4.54-18.06,8.54-27.16,12.69-.41.19-.92.15-1.16.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M236.47,291.84c1.91.59,3.92.97,5.73,1.78,56.15,25.16,112.38,50.16,168.33,75.75,11.13,5.09,20.83,13.26,31.86,18.6,10.42,5.04,21.63,8.53,32.68,12.14,6.57,2.14,13.49,3.2,20.99,4.91-4.66,12.78,3.78,19.19,12.67,25.5,14.64,10.4,29.23,20.87,43.75,31.44,4.43,3.23,8.74,6.74,10.79,13.42-1.71-.71-2.65-.83-3.17-1.36-22.78-23.38-51.46-35.67-82.35-43.76-6.76-1.77-13.72-2.87-20.39-4.92-7.53-2.32-15.2-4.64-22.16-8.23-27.55-14.22-54.81-29-82.26-43.43-6.18-3.25-10.9-7.44-14.3-13.75-6.25-11.58-15.93-20.16-27.34-26.41-21.87-11.98-44.03-23.44-66.05-35.16-3.17-1.69-6.23-3.59-9.35-5.4.19-.38.38-.75.57-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M659.92,743.15c-2.41,6.43,1.16,9.97,5.08,13.57,5.49,5.05,10.75,10.35,16.05,15.61,1.56,1.54,2.89,3.31,4.33,4.98-.22.52-.43,1.04-.65,1.56-1.91.08-3.82.3-5.71.23-29.19-1.13-58.06-5.16-86.85-9.79-21.64-3.48-43.27-7.07-64.93-10.41-5.18-.8-8.55-2.96-10.04-8.18-2.2-7.67-4.94-15.09-11.74-20.2-.76-.57-1.17-2.75-.68-3.54.56-.92,2.63-1.9,3.44-1.54,6.07,2.74,11.38-.42,16.95-1.74,18.06-4.29,36.24-3.64,54.14.3,26.61,5.85,53.03,12.54,80.61,19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M1514.01,1038.82c4,3.81,7.96,7.67,12.01,11.42,22.69,21.01,48.1,37.64,77.58,47.51,34.98,11.71,70.12,11.46,105.3.81,33.56-10.16,63.58-26.65,89.29-50.58,31.75-29.56,49.69-66.24,53.67-109.28,4.02-43.49-3.55-85.15-23.79-124.05-21.25-40.84-54.9-67.8-97.45-83.81-13.68-5.15-28.17-8.12-42.29-12.09-1.95-.55-3.91-1.05-5.87-1.57.03-.49.06-.98.08-1.47,2.55,0,5.12-.19,7.65.03,28.71,2.54,55.19,12.02,79.15,27.67,66.93,43.72,98.8,106.13,93.9,185.67-5.34,86.73-68.12,159.55-153.12,178.37-73.7,16.32-136.77-5.07-189.53-58.33-2.77-2.79-5.1-6.01-7.64-9.03.35-.42.69-.84,1.04-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M1110.96,885.53c-2.81.31-7.89,1.28-12.98,1.3-4.31.02-9.05-.13-12.87-1.83-19.99-8.89-31.54-34.86-23.94-55.27,5.92-15.92,17.57-28.1,34.33-30.88,16.87-2.8,33.04,2.53,44.31,16.72,16.47,20.75,12.35,49.66-8.83,65.63-5.43,4.09-8.54,4.87-20.01,4.32ZM1085.19,844.35c-.13,10.29,9.64,20.4,19.86,20.54,10.24.14,20.07-9.75,20.08-20.2,0-10.33-9.11-19.71-19.43-20.01-10.5-.31-20.37,9.16-20.5,19.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M1457.51,695.32c1.03,4.11,1.99,6.91,2.41,9.78,2.39,16.36,4.38,32.78,7.06,49.08,1.54,9.33-1.14,15.67-8.85,21.57-13.47,10.3-25.97,21.88-38.94,32.85-1.94,1.64-4.22,2.87-6.34,4.29-.52-.42-1.03-.84-1.55-1.27,1.81-3.98,3.61-7.95,5.42-11.93l-1.44-1.02c-1.93,2.53-4.28,4.84-5.73,7.61-4.78,9.16-12.89,13.03-22.42,14.83-6.16,1.16-7.56-.26-5.46-6.05,2.62-7.21,5.75-14.24,8.5-21.41,13.84-36.02,35.39-66.95,62.22-94.4,1.09-1.11,2.48-1.93,5.12-3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1562.83,390.73c-3.49-2.22-7.2-4.15-10.42-6.71-15.5-12.37-30.89-24.88-46.28-37.39-5.34-4.34-5.28-4.41-1.46-10.52,2.23-3.57,1.62-6.82-1.93-9.78-3.02-2.51-6.02-3.16-9.4-.32-6.48,5.46-6.54,5.37-13.43-.06-1.1-.86-2.23-1.71-3.44-2.39-11.26-6.4-18.69-16.04-23.26-27.93-3.18-8.27-6.08-16.65-8.83-25.06-1.94-5.92-.21-7.78,6.1-6.83,8.99,1.36,18,2.69,26.92,4.43,14.74,2.87,26.79,10.81,37.48,21.31-4.79-1.81-9.58-3.63-14.37-5.44-.2.35-.4.69-.6,1.04.42.72.69,1.62,1.3,2.13,9.64,8.23,15.14,19.22,21.22,30.06,12.08,21.54,25.2,42.51,37.85,63.73,1.58,2.64,2.93,5.42,4.39,8.13-.61.54-1.22,1.07-1.83,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M274.64,653.64c4.95-4.42,9.63-9.19,14.91-13.15,5.38-4.04,11.35-7.29,17.51-11.18-1.24-1.32-2.38-2.54-4.13-4.4,19.49-1.41,38.32-.66,57.51,1.94-16.82,4.42-30.15,13.55-40.47,27.08-.61.8-.65,2.03-1.44,4.69,3.19-1.09,5.33-1.41,7.01-2.47,5.32-3.37,10.36-7.17,15.69-10.51,16.08-10.08,33.57-14.79,52.6-13.63,7.79.47,12.9,4.69,16.74,11.04,1.81,3,1.78,5.13-1.98,6.45-2.85,1-5.55,2.43-8.38,3.53-5.24,2.04-10.32,2.43-15.37-.93-1.18-.78-3.31-.14-5-.15.04,1.53-.32,3.21.19,4.57,2.54,6.79,9.14,10.08,16.46,8.05,4.94-1.37,9.71-3.32,14.59-4.88,9.43-3.01,16.98,4.01,15.32,13.69-.51,2.98.62,6.32,1.34,9.41.54,2.31,1.63,4.49,2.47,6.73-.42.38-.84.76-1.27,1.14-4.16-1.84-8.36-3.57-12.46-5.52-33.96-16.12-69.93-22.61-107.29-22.46-2.56.01-5.12.64-7.66.54-2.25-.08-5.15-.01-6.59-1.31-5.55-5.01-11.84-7.16-19.39-6.15-.31-.71-.62-1.42-.92-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M569.38,478.57c8.09,3.11,14.18,6.07,20.6,7.79,20.46,5.48,41.06,10.42,61.56,15.72,28.62,7.4,57.26,14.76,85.8,22.48,29.23,7.91,58.31,16.34,87.53,24.26,4.4,1.19,6.18,2.71,4.35,7.14-.35.84-.32,1.83-.55,2.74-1.66,6.69-3.8,7.97-10.55,6.12-11.68-3.2-23.33-6.51-35-9.72-64.23-17.63-128.47-35.27-192.72-52.83-8.86-2.42-16.94-5.63-19.82-15.51-.6-2.08-.66-4.31-1.21-8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M319.58,1182.36c5.45-10.1,13.93-13.67,25.02-12.08-3.21-8.95-14.55-11.8-21.7-6.4-1.66,1.25-3.03,2.89-4.49,4.4-9.6,9.85-21.35,14.02-34.89,12.48-7.29-.83-14.47-2.67-22.06-5,9.38-5.6,18.52-10.88,20.08-22.76,3.17.19,5.46.26,7.74.48,51.23,4.89,99.1-5.9,144.06-30.58,1.82-1,5.15-1.92,6.21-1.02,1.53,1.3,2.27,4.3,2.23,6.55-.21,12.99-7.07,23.41-13.71,33.85-.82,1.28-2.24,2.56-3.65,3.02-11.88,3.9-23.83,7.62-37.37,11.9,1.12-2.94,1.3-4.27,2.01-5.15,5.38-6.64,6.95-14.64,8.14-22.74.2-1.35-.77-2.86-1.19-4.3-1.49.77-3.57,1.17-4.36,2.39-2.26,3.51-3.95,7.39-5.96,11.06-8.07,14.72-19.53,24.15-37.26,23.91-9.43-.12-18.86-.02-28.87-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M546.64,537.21c8.89-.76,17.95-.98,26.6,1.43,7.54,2.1,15.17,4.9,21.86,8.89,46.23,27.56,92.21,55.53,138.31,83.32,15.76,9.5,31.57,18.92,47.48,28.16,3.82,2.22,5.39,4.28,2.18,8.08-.59.7-.9,1.63-1.37,2.43-3.78,6.55-5.41,6.97-12.2,3.01-15.5-9.04-31.15-17.84-46.43-27.22-45.27-27.78-90.33-55.92-135.65-83.63-10.3-6.3-21.36-11.37-32.01-17.1-3.18-1.71-6.17-3.76-9.25-5.65.16-.58.32-1.15.48-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M163.08,679c-4.61,12.1-6.98,23.07-7.19,34.35.64.25,1.29.49,1.93.74,1.09-.96,2.5-1.73,3.2-2.92.92-1.57,1.42-3.44,1.88-5.23,8.56-32.98,30.48-52.43,62.42-61.76.6-.18,1.3-.02,3.01-.02-3.99,5.9-6.97,11.75-11.31,16.31-4.14,4.35-9.7,7.36-14.64,10.96,3.86,4.7,9.79,5.94,15.15,2.02,3.84-2.8,7.18-6.65,9.83-10.64,7.07-10.65,15.19-20.03,26.62-26.2,12.57-6.79,26.22-9.45,40.22-10.86.84-.08,1.72.28,3.92.68-2.83,1.48-4.53,2.47-6.31,3.3-9.74,4.56-17.87,11.02-23.42,20.32-2.76,4.62-6.57,7.27-11.44,9.62-6.42,3.09-12.03,7.84-18.06,11.77-3.88,2.53-7.63,5.54-11.88,7.17-37.72,14.52-69.93,36.89-96.82,67.03-1.89,2.12-5.06,5.41-6.73,4.94-4.15-1.16-2.1-5.58-1.88-8.49,2.16-27.81,14.62-49.12,41.5-63.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M1666.68,997.97c-3.69,2.47-6.9,4.61-10.43,6.97-4.67-2.75-9.46-5.77-15.5-3.51-.75.28-2.74-1.43-3.45-2.63-1.27-2.14-2-4.61-3.24-7.62,1.83-.73,3.65-1.48,5.49-2.18,6.15-2.34,8.87-6.18,8.6-12.81-.1-2.52-.54-5.14-1.41-7.5-4.86-13.29-13.78-23.13-26.36-29.5-12.86-6.52-21.91-2.61-26.35,11.03-.13.4-.6.68-.91,1.02-11.09-1.36-16.74-19.79-9.15-30.33,1.93,2.16,3.46,5.02,5.84,6.27,4.99,2.61,10.38,2.8,15.13-.96,6.54-5.18,11.89-11.14,12.82-20.02.18-1.76,1.34-3.41,2.06-5.11.54.07,1.08.13,1.62.2.54,1.39,1.29,2.73,1.56,4.17.4,2.05.28,4.19.67,6.24,1.56,8.21,4.01,9.75,12.1,7.91,2.37-.54,4.78-.92,7.17-1.37.28.65.56,1.29.84,1.94-1.9,1.09-3.7,2.46-5.73,3.21-10.24,3.78-11.68,8.33-5.22,17.28,1.22,1.7,2.5,3.4,4.01,4.83,8.22,7.81,13.71,8.37,20.35-.27.39-.51,1.11-.78,2.41-1.65.5,2.01,1.05,3.62,1.27,5.27.67,4.99,3.63,7.14,8.47,7.61,7.42.72,13.71-1.72,19.48-6.15,5.66-4.34,5.81-4.35,10.17.98,2.53,3.09,5.53,3.63,8.62,1.71,3.25-2.01,3.88-5.24,1.69-8.49-2.72-4.04-2.86-8.08-1.35-12.62,1.09-3.29,1.52-6.82,2.02-10.28,1.66-11.39.32-13.74-10.53-18.31.73-1.36,1.3-2.76,2.15-3.96,3.48-4.92,3.59-7.55.37-12.75-4.65-7.49-11.54-11.97-19.96-14.41,1.56-4.07,2.99-7.82,4.71-12.3,1.18,1.72,2.3,3.25,3.33,4.84,6.2,9.52,13.49,17.84,24.24,22.45,15.38,6.59,24.37,2.62,29.13-13.33,4.48.45,7.74,2.95,9.7,6.74,2.1,4.06,4.64,8.41,4.89,12.75.2,3.6-2.66,7.37-4.07,10.83-1.69-.35-2.28-.29-2.53-.56-8.95-9.41-23.8-8.18-30.67,3.06-6.49,10.61-8.95,22.56-8.34,34.87.44,8.91,6.06,15.01,13.77,18.86,2.29,1.15,5.37.75,8.09,1,1.89.18,5.03-.33,5.44.52,1.03,2.12,1.41,4.96.98,7.3-.62,3.33-14.56,12.87-18.07,12.87-1.09,0-2.17-.44-3.63-.75.28-2.15.54-3.93.74-5.71.53-4.77-1.04-8.9-4.68-11.86-6.78-5.51-14.45-8.71-23.33-6.32-7.86,2.12-15.67,4.45-23.35,7.14-5.61,1.97-9.12,6.34-10.78,12.05-2.84,9.75-.84,14.6,9.13,21.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M1527.16,305.75c5.65,3.13,11.44,6.05,16.94,9.44,11.3,6.98,22.55,14.07,33.63,21.39,10.61,7,18.13,16.54,22.78,28.49,8.97,23.06,18,46.11,20.99,70.89,1.7,14.1,3.91,28.4-.96,42.27-2.37,6.76-5.91,13.17-9.37,19.49-2.48,4.52-10.9,6.86-15.49,4.92-3.06-1.29-4.97-8.09-3.96-13.21.95-4.83,4.29-3.97,7.58-3.56,1.15.14,2.33.18,3.49.19,12.29.15,16.04-3.49,15.83-15.63-.3-17.62-4-34.71-8.32-51.68-1.57-6.16-5.53-9.77-11.55-12-3.96-1.47-7.27-4.6-11.02-6.74-1.67-.95-3.74-1.95-5.54-1.79-3.92.33-6.1-1.53-7.88-4.56-15.12-25.74-30.31-51.43-45.32-77.23-1.67-2.88-2.41-6.3-3.58-9.46.59-.4,1.18-.81,1.76-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M574.81,666.08c7.38-1.89,13.46-4.26,19.72-4.9,24.89-2.55,48.3,1.67,68.98,16.79,6.73,4.92,6.9,5.13,3.98,13.05-1.35,3.65-.97,6.9,1.82,9.66,2.61,2.57,5.67,4.44,9.41,2.76,5.45-2.45,8.71.05,11.76,4.26,5.07,6.97,10.48,13.7,15.55,20.67.91,1.26.86,3.22,1.25,4.86-1.7.19-3.61.99-5.08.49-21.61-7.33-43.41-14.22-64.63-22.58-9.82-3.87-18.83-10.18-27.56-16.3-10.67-7.48-20.69-15.91-30.94-23.99-1.18-.93-2.05-2.26-4.27-4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M1144.45,998.89c-4.81,1.2-9.57,2.94-14.45,3.47-7.86.86-15.8,1.22-23.71,1.27-46.37.29-92.74.39-139.11.66-6.98.04-13.96.79-20.95.95-6.28.14-7.64-1.65-5.94-7.57,1.35-4.7,2.7-9.44,4.58-13.93,3.03-7.22,10.17-9.09,15.78-3.61,4.85,4.74,10.18,5.83,16.49,5.79,25.87-.19,51.73-.09,77.6-.31,3.11-.03,6.52-.8,9.25-2.25,6.89-3.64,14.25-5.5,21.61-3.73,18.08,4.35,35.97,9.48,53.9,14.41,1.69.46,3.15,1.74,4.72,2.64.07.74.15,1.48.22,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M204.61,783.62c3.61-9.27-1.27-18.45-1.63-27.88-.99-26.36,6.83-49.75,25.09-69.07,9.62-10.17,19.6-20.32,33.57-24.38,5.71-1.66,11.92-1.85,17.93-2.04,1.87-.06,4.22,1.73,5.51,3.35.52.66-.79,3.55-1.97,4.68-26.06,24.73-40.82,56.45-54.88,88.59-1.96,4.49-3.51,8.69-10.02,6.55-1.55-.51-4.97,1.11-5.72,2.64-.92,1.85-.78,5.28.41,6.92,3.03,4.15,4.27,8.46,2.49,13.09-.77,1.99-3.32,4.72-4.95,4.65-3.41-.16-5.66-2.84-5.83-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M1356.75,30.34c-1.01,4.49-2.26,11.37-4.14,18.07-2.91,10.3-6.22,20.48-9.43,30.7-5.13,16.35-22.03,21.66-35.77,11.28-3.99-3.01-3.58-7.18-3.24-11.44,1.21-15.08,2.5-30.15,3.43-45.24.43-6.96-.03-13.97.18-20.95.23-7.7,2.26-9.4,9.99-8.45,7.16.88,14.36,1.67,21.39,3.18,11.26,2.42,17.4,9.91,17.59,22.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M1101.69,518.72c8.97,1.42,16.18,2.1,23.14,3.81,6.45,1.58,6.96,4.39,2.23,9.22-2.43,2.48-5.18,4.69-7.96,6.79-17.83,13.49-35.84,26.75-53.49,40.47-6.66,5.18-13,6.32-20.63,2.53-12.7-6.32-25.59-12.24-38.37-18.39-1.67-.8-3.3-1.81-4.68-3.03-2.91-2.58-2.67-5.18.59-7.42.94-.64,2.09-1.01,3.17-1.42,23.68-9.1,47.25-18.52,71.13-27.08,8.39-3.01,17.54-3.91,24.89-5.46ZM1035.91,551.46c-5.78.13-9.39,3.61-9.38,9.03,0,5.9,4.26,10.26,10.05,10.29,5.26.03,9.84-4.47,9.89-9.72.05-5.72-4.37-9.75-10.56-9.6ZM1108.25,532.72c.13-6.09-3.11-9.38-9.37-9.52-6.41-.15-10.02,2.98-10.15,8.77-.13,6.1,3.69,10.02,9.85,10.12,5.97.09,9.54-3.36,9.67-9.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M1176.5,590.38c15.06-10.4,30.29-20.56,49.46-21.83,26.64-1.76,52.65-6.47,78.01-15.02,19.27-6.5,38.68-4.5,57.82,1.06,9.32,2.71,11.28,12.99,4.03,19.51-2.93,2.64-6.06,1.63-9.22.65-11.44-3.55-23.15-6.24-35.09-4.45-8.2,1.23-16.21,4-24.17,6.52-19.9,6.29-40.4,9.22-61.05,11.35-16.45,1.7-32.93,3.18-49.41,4.64-3.31.29-6.68.04-10.02.04-.12-.82-.23-1.65-.35-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M1365.47,766.9c-5.43-1.95-12.82-4.12-19.77-7.25-4.37-1.97-4.93-5.8-3.12-12.31,2.99-10.77,6.07-21.52,9.11-32.28,12.88-45.5,25.76-91,38.68-136.48.7-2.45,1.55-4.89,2.68-7.17,1.98-3.97,5.45-6.03,9.76-5.11,5.67,1.2,11.37,2.65,16.75,4.78,6.29,2.48,8.27,7.07,6.35,14.29-4.19,15.76-8.69,31.43-13.1,47.12-11.29,40.14-22.6,80.27-33.93,120.4-.76,2.69-1.53,5.41-2.68,7.94-1.66,3.64-4.54,5.83-10.75,6.08ZM1410.88,617.52c.05-7.87-4.13-12.38-11.61-13.66-6.85-1.17-10.87,1.28-13.18,8.3-1.38,4.2-2.5,8.48-3.7,12.73-4.87,17.23-9.92,34.42-14.43,51.74-.85,3.26-.69,7.79,1,10.48,2.92,4.65,8.08,6.98,13.87,6.41,5.45-.54,7.57-4.86,9.46-9.2.55-1.27.78-2.67,1.16-4.02,5.08-17.9,10.18-35.79,15.22-53.7.94-3.35,1.64-6.77,2.2-9.08ZM1406.35,574.88c-5.93.13-11.09,5.42-11.03,11.3.08,6.92,5.35,12.19,11.91,11.9,5.6-.25,10.78-5.86,10.81-11.72.04-6.13-5.55-11.62-11.69-11.49ZM1371.68,698.91c-5.97-.06-11.21,5-11.41,11.01-.2,6.36,5.12,12.2,11.04,12.1,6-.1,11.65-5.88,11.59-11.85-.05-5.94-5.3-11.2-11.23-11.26ZM1376.31,740.07c.4-7.7-5.03-13.18-13.58-13.69-7.15-.42-12.72,5.64-13.1,14.24-.29,6.78,6.31,12.57,14.65,12.87,6.96.25,11.58-4.91,12.03-13.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M116.65,722.76c-.46,2.21-.94,4.41-1.37,6.62-1.64,8.36-2.03,16.71,1.24,24.77,1.73,4.26.44,7.59-2.03,11.03-16.63,23.14-28.76,48.51-36.85,75.78-5.2,17.5-8.26,35.42-9.01,53.69-.13,3.26-.05,6.57-.59,9.77-.31,1.85-1.66,3.53-2.55,5.28-1.67-1.06-3.8-1.77-4.92-3.25-7.72-10.12-12.18-21.44-11.71-34.38.38-10.72,2.21-21.19,5.42-32.66,5.69,7.29,7.44,15.84,13.59,21.66,3.39-2.89,2.32-5.92,1.07-8.59-10.74-22.9-7.57-44.89,3.98-66.44,2.24-4.18,4.28-8.48,7.28-12.45,1.81,7.64,2.93,14.95-1.83,21.9-.99,1.45-.9,3.65-1.3,5.51,2.09-.32,4.51-.08,6.22-1.07,6-3.44,8.36-8.98,8.43-15.83.08-7.68.22-15.39.94-23.03,1.54-16.37,11.38-28.02,22.45-38.86.52.18,1.03.36,1.55.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M205.67,1156.26c6.77-4.83,14.85-6.6,21.26-14.39-3.7-.29-5.99-.96-8.05-.52-5.23,1.12-10.33,2.82-15.52,4.14-7.25,1.85-14.85,1.86-21.19-1.76-12.25-6.99-23.87-15.09-36.85-23.44,6.4-3.34,10.85-2.46,15.09.22,2.35,1.49,4.38,3.49,6.72,5,.81.52,2.41.71,3.12.25.68-.45,1.07-2.01.9-2.96-1.22-7.1-9.48-15.24-16.8-14.6-18.4,1.61-30.4-7.98-40.78-21.22-1.87-2.38-3.8-4.71-5.64-7.11-.21-.28-.03-.87-.03-1.9,1.78.15,3.5.34,5.24.44,4.41.26,9.15,1.6,13.16.45,6.53-1.87,10.16.87,14.42,5.02,34.07,33.17,74.25,55.13,120.9,65,2.96.63,5.97,1.23,8.78,2.32,3.92,1.52,4.56,4.28,1.35,6.76-11.27,8.7-23.49,14.77-38.2,10.05-8.19-2.63-16.11-6.07-24.12-9.24-1.19-.47-2.18-1.43-3.76-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M1547.06,395.02c7.71,2.37,13.61,4.15,19.48,6,9.31,2.94,18.54,6.16,27.93,8.85,6.94,1.99,11.41,5.74,12.59,13.17,2.45,15.37,5.44,30.66,7.56,46.07,1.27,9.2-.84,11.09-10.05,11.79-11.63.89-19.19-2.67-23.36-12.51-7.17-16.95-17.78-31.55-29.33-45.61-1.62-1.98-3.6-3.83-4.6-6.1-.83-1.89-1.46-5.3-.45-6.31,4.45-4.44,4.94-8.92.23-15.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1915.13,834.4c-7.27-1.65-12.13-4.68-15.42-10.04-1.63-2.66-3.27-4.5-6.68-5.42-2.27-.61-4.39-3.72-5.54-6.2-11.28-24.31-25.86-46.37-44.29-65.85-14.33-15.15-30.41-28.18-47.93-39.46-1.89-1.22-3.78-2.43-5.33-4.9,4.22-.34,8.49-.38,12.65-1.09,4.34-.74,8.54-2.88,12.85-3.07,10.06-.44,16.54,5.96,23.14,13.39-2.84,1.73-5.65,2.7-7.28,4.65-1.54,1.84-1.84,4.72-2.69,7.14,2.09-.02,4.33.45,6.23-.15,12.06-3.79,22.56.98,26.67,13.07-2.88,1.1-6.05,1.84-8.66,3.47-1.6,1-2.36,3.34-3.5,5.09,1.95.7,3.87,1.78,5.88,1.98,1.49.15,3.08-.91,4.66-1.33,4.93-1.31,9.35-.29,12.75,3.55,9.47,10.7,16.44,23.01,23.76,36.39-2.87.49-4.99.45-6.72,1.25-1.48.68-2.53,2.32-3.76,3.54,1.08,1.04,2.06,2.84,3.26,3,11.2,1.48,16.16,8.98,19.11,18.82,1.6,5.35,3.78,10.52,5.58,15.82.55,1.63.7,3.41,1.27,6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M73.25,1026.62c11.12,3.36,16.33,4.55,21.83,3.8,1.33-3.9-2.03-4.72-4.22-6.07-4.36-2.67-9.07-4.81-13.29-7.67-8.35-5.67-14.24-13.3-17.09-23.13-2.59-8.95-5.34-17.86-7.92-26.81-.54-1.87-.67-3.85-1.12-6.62,10.1,4.06,9.16,13.42,11.85,20.62.86.51,1.73,1.02,2.59,1.53.54-1.5,1.21-2.97,1.61-4.51,1.8-7.05,1.97-13.83-3.3-19.76-2.47-2.78-4.57-5.9-7.06-8.68-11.75-13.11-11.36-28.75-9.84-46.48,2.32,2.32,3.59,3.71,4.98,4.94,4.31,3.8,8.4,7.92,13.1,11.17,2.91,2.01,2.9,4.4,3.13,7.17,3.59,43.1,16.57,83.01,40.66,119.09,4.39,6.57,9.59,12.6,14.11,19.1,1.12,1.61,1.04,4.06,1.51,6.13-2.12.41-4.36,1.5-6.33,1.13-15.33-2.92-26.87-10.98-33.96-25.25-3.35-6.76-7.47-13.13-11.24-19.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M502.28,327.75c12.95.97,27.36,15.25,23,28.43-3.34,10.1-6.57,20.38-11.25,29.88-5.71,11.56-18.37,14.81-30.1,9.44-4.19-1.92-8.75-3.11-13.22-4.35-8.35-2.33-9.68-4.38-5.48-11.56,9.27-15.86,19-31.45,28.51-47.17,2.18-3.6,5.28-5.08,8.55-4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1205.61,961.35c-.72-.56-3.21-1.53-3.89-3.22-1.13-2.8,0-5.87,3.21-6.73,14.63-3.92,17.01-15.09,16.6-27.81-.38-11.86-.89-23.73-1.74-35.57-.77-10.7.69-20.96,5.07-30.71,15.91-35.39,36.46-67.68,64.25-95.02,4.8-4.72,10.33-8.69,15.56-12.96,2.74-2.24,5.37-2.71,7.69.68,2.08,3.02,2.82,5.91-.44,8.63-.36.3-.69.63-1.06.91-27.19,20.27-45.53,47.69-61.85,76.72-3.08,5.49-5.93,11.1-9.03,16.58-7.27,12.85-9.65,26.61-7.88,41.16,1.58,13.01,3.32,26.17-1.74,38.7-3.2,7.91-7.61,15.37-11.92,22.78-2.37,4.07-6.58,5.76-12.84,5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M1644.03,818.8c-1.34,1.32-2.53,3.08-4.19,4.01-3.44,1.92-7.05,3.61-10.73,5.02-7.8,2.98-8.81,2.53-12.31-4.92-5.35-11.37-10.59-22.79-15.92-34.18-6.12-13.07-12.29-26.11-18.42-39.18-3.51-7.48-2.76-9.43,4.84-12.83,2.55-1.14,5.1-2.27,7.66-3.39,7.49-3.25,8.25-3,11.69,4.23,5.01,10.5,10.05,20.99,14.93,31.55,6.83,14.79,13.53,29.64,20.27,44.47.67,1.47,1.25,2.98,2.17,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M1893.32,1003.8c8.66,13.52,7.29,31.92-2.93,42.62-1.83-1.56-3.53-3.44-5.62-4.61-1.09-.61-3.13-.38-4.27.29-.66.38-.94,2.73-.41,3.59,2.41,3.91,4.68,8.12,2.64,12.48-2.89,6.17-6.71,11.91-10.14,17.83-.58-.14-1.16-.28-1.74-.43-1.25-2.89-2.34-5.88-3.85-8.63-.55-1.01-2.71-2.29-3.1-2.01-1.13.81-2,2.27-2.44,3.64-.32,1.01.06,2.32.36,3.43,2.53,9.5-.37,17.28-7.07,24.19-7.75,8-15.02,16.49-25.25,22.79-.74-1.81-1.19-3.25-1.9-4.54-.88-1.61-1.99-3.1-3-4.64-.99,1.65-2.22,3.2-2.9,4.96-1.09,2.8-1.49,5.9-2.76,8.6-2.83,6.06-7.17,10.78-13.18,14.01-6.69,3.6-13.2,7.51-20.36,10.76,1.57-7.49,4.2-14.13,9.77-19.45,1.67-1.6,3.49-4.05,3.52-6.13.05-3.92,1.93-6,4.85-7.8,23.16-14.31,41.69-33.57,58.04-55.02,11.49-15.08,20.76-31.52,28.11-49.03.93-2.22,2.25-4.29,3.63-6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M770.71,803.31c-4.49,1.17-10.57,4.77-5.64,15.03-12.05,1.93-23.07,2.19-31.8-5.6-13.01-11.61-25.11-24.24-37.58-36.45-.3-.29-.33-.85-.74-1.99,5.19-2.5,8-6.69,7.94-12.94,0-1.09,3.82-3.14,5.89-3.15,11.21-.09,22.56,1.91,30.59,9.75,11.44,11.16,21.32,23.9,31.33,35.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1653.06,904.16c-4.01-5.73-9.19-11.53-12.53-18.24-7.03-14.14-13.1-28.76-19.55-43.19-1.46-3.27-.91-5.94,2.53-7.54,8-3.71,15.98-7.49,24.11-10.91,1.13-.47,4.01.52,4.46,1.54,8.54,19.55,20.59,37.64,24.71,59.04,1.25,6.5.86,6.38-5.2,8.92-5.87,2.46-11.2,6.2-18.53,10.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M1669.08,667.13c1.72-1.39,3.24-3.34,5.21-4.05,5.44-1.97,11.02-3.59,16.63-5.01,3.51-.89,5.88.22,5.91,4.53.01,1.35,1,3.44,2.06,3.84,1.08.4,3.5-.43,4.11-1.45,10.11-16.93,25.82-13.1,40.61-10.42,7.09,1.28,13.68,5.33,21.59,8.58-3.51,3-6.35,4.72-8.13,7.19-1.23,1.71-1.01,4.46-1.43,6.74,1.87-.38,4.19-.18,5.54-1.23,8.94-6.91,18.07-6.69,27.34-1.09,7.28,4.4,14.37,9.11,22.7,14.42-10.57,5.33-19.71,7.44-29.77,3.8v5.14c-12.3-4.95-24.06-10.43-36.31-14.42-12.14-3.95-24.66-6.97-37.21-9.34-12.64-2.39-25.53-3.47-38.31-5.13-.18-.7-.36-1.41-.54-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1926.15,904.57c-2.92-1.32-4.93-2.59-7.11-3.08-1.51-.34-3.26.39-4.9.64.53,1.77,1.05,3.54,1.61,5.3.06.17.35.3.57.39,10.31,4.31,11.98,12.57,10.61,22.49-1.15,8.31-1.77,16.69-2.84,25.01-.34,2.64-1.36,5.19-1.99,7.53-1.32,0-1.8.09-2.22-.02-2.28-.59-5.55-2.49-6.64-1.62-3.06,2.44.47,4.75,1.33,7.19,1.37,3.89,3.03,7.88,3.32,11.91.43,6-7.2,26.47-11.35,32.36-3.53-4.81-4.69-9.87-4.26-15.58.22-2.86-.6-5.79-.61-8.68,0-5.26-.77-10.79.54-15.75,9.41-35.42,9.59-71,2.46-106.7-2-10.02-5.37-19.77-8.09-29.64-.29-1.05-.41-2.16-.88-4.72,7.99,6,15.78,10.34,21.41,16.61,3.68,4.1,4.63,10.9,6.07,16.68.81,3.23-1.68,4.77-5.01,5.29-1.98.3-3.77,1.82-5.65,2.79,1.48,1.54,2.75,3.4,4.49,4.56,7.46,5,10.66,12.13,10.72,20.81.01,1.9-.93,3.81-1.58,6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M1456.88,553.01c.87-1.81,1.31-3.75,2.49-4.98,5.32-5.54,17.38-3.52,20.78,3.59,5.53,11.54,10.76,23.23,16.13,34.85,7.51,16.27,15.04,32.54,22.55,48.81,3.41,7.38,3.13,8.28-3.7,12.09q-12.32,6.87-18.13-5.79c-11.9-25.79-23.85-51.56-35.71-77.36-1.64-3.56-2.88-7.31-4.4-11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M1421.99,492.93c8.65,14.65,15.27,28.45,17.34,43.9,3.16,23.53,5.97,47.11,8.8,70.69,3,24.97,5.83,49.96,8.79,74.94.75,6.37-1.49,11.79-6.23,14.42-3.62,2-5.82.92-6.29-3.14-3.74-32.38-7.63-64.74-11.07-97.15-.93-8.74-.44-17.62-.74-26.43-.08-2.31-.36-4.71-1.09-6.88-7.24-21.7-6.16-44.66-10.23-66.84-.11-.62.25-1.32.72-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M304.38,668.2c1.03-.29,2.05-.83,3.09-.84,41.3-.42,80.55,7.9,117.38,27.05,7.65,3.98,12.03,9.18,11.6,18.06-.13,2.68.56,5.41.97,8.89-1.98-.69-3.3-.91-4.36-1.56-26.77-16.55-55.78-26.76-86.88-31.36-5-.74-10.05-2.36-14.62-4.52-9.36-4.42-18.41-9.48-27.58-14.27.14-.48.28-.97.41-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M1190.58,515.07c-6.69,0-13.41.39-20.07-.08-17.43-1.23-34.81-3.4-52.25-4.14-26.41-1.12-51.78,3.88-76.5,13.59-24.7,9.7-49.97,17.98-74.99,26.87-1.1.39-2.32,1.08-3.33.87-1.42-.29-3.35-.98-3.86-2.07-.53-1.13-.1-3.31.75-4.34,1.12-1.35,2.96-2.25,4.66-2.95,35.33-14.62,71.03-28.14,108.14-37.7,30.37-7.83,60.5-6.44,90.63.94,7.69,1.88,15.37,3.82,23.04,5.82,1.43.37,2.75,1.16,4.13,1.75-.12.48-.23.95-.35,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M1432.41,310.97c.78,1.08,1.52,1.63,1.51,2.16-.17,9.91,5.1,17.64,9.85,25.69,9.36,15.86,18.33,31.95,27.65,47.83,3.03,5.16,3.73,10.2,2.24,16.04-2.53,9.97.28,16.14,9.63,20.6,7.69,3.66,12.84,9.35,15.47,17.15,4.88,14.49,13.19,26.65,23.91,37.34.94.93,1.63,2.11,2.51,3.27-14.58,4.94-25.34.03-31.85-14.27-14.77-32.46-29.51-64.94-44.31-97.39-6.29-13.78-12.77-27.48-19.06-41.26-1.15-2.52-2.27-5.19-2.61-7.9-.47-3.8.3-7.44,5.06-9.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M536.15,715.85c3.4-1.06,6.73-2.66,10.2-3.05,6.68-.76,13.47-1.47,20.15-1.05,11.79.74,23.28.38,34.34-4.24,6.65-2.78,13.09-1.88,19.7.6,25.06,9.37,50.21,18.52,75.33,27.75.22.08.45.14.65.25,3.01,1.45,7.92,1.97,6.56,6.57-1.31,4.44-5.48,1.9-8.45,1.35-19.46-3.64-38.97-7.07-58.34-11.15-17.09-3.59-34.08-7.7-51.01-12.01-14.64-3.72-29.39-4.75-44.38-3.42-1.47.13-2.96.02-4.44.02-.11-.54-.21-1.08-.32-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M1493.75,1023.73c81.11,117.39,225.79,117.02,308.72,40.85,31.12-28.58,52.07-63.27,61.24-104.58,9.1-41.02,7.68-81.52-8.38-120.89-15.87-38.92-41.05-70.62-74.7-95.74,54.44,31.48,99.74,107.77,89.92,194.71-10.15,89.86-78.42,162.05-165.37,178.24-95.48,17.79-177.7-32.49-211.44-92.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M78.78,540.49c-1.2,2.46-1.86,4.23-2.85,5.78-14.91,23.38-29.85,46.75-44.85,70.09-1.77,2.76-3.76,5.84-7.8,3.79-3.8-1.94-4.26-5.19-2.77-8.94.69-1.73,1.22-3.52,1.91-5.26,5.42-13.64,10.88-27.27,16.29-40.92,3.52-8.88,6.99-17.78,10.45-26.68,3.19-8.21,5.63-9.31,13.73-6.26,3.7,1.4,7.56,2.45,11.12,4.14,1.86.88,3.21,2.83,4.76,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M1223.46,594.82c-3.24,6.63-6.83,11.88-12.38,15.4-1.48.94-4.06.66-5.99.26-9.23-1.92-16.33.96-22.07,8.43-7.81,10.17-15.91,20.13-24.09,30.01-1.62,1.96-4.17,3.14-6.29,4.68-1.81-2.78-4.83-5.4-5.23-8.37-1.52-11.27,2.17-21.66,7.21-31.55,1.68-3.3,3.59-6.73,6.22-9.24,2.74-2.62,6.31-5.56,9.81-6,16.19-2.03,32.48-3.25,48.74-4.7.85-.08,1.75.44,4.06,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1449.67,541.22c-6.11-9.39-4.01-15.46,6.27-20.04,13.59-6.06,27.09-12.3,40.71-18.31,3.87-1.71,8.49-6.64,11.89-3.21,3.94,3.97,5.78,10.24,7.78,15.78.51,1.41-1.36,4.37-2.93,5.67-2.46,2.04-5.52,3.42-8.44,4.83-9.01,4.34-18.07,8.58-27.12,12.84-4.72,2.22-9.19,2.43-13.89-.55-8-5.06-8.22-4.87-14.27,2.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M873.98,979.18c.75,1.27,1.3,2.6,2.19,3.66,10.92,12.96,27.91,11.77,36.89-2.56,1.48-2.37,2.78-4.85,4.27-7.22,1.75-2.78,3.89-3.61,7.04-1.77,4.19,2.45,8.78,4.25,12.81,6.91,1.54,1.02,3.21,4,2.78,5.49-2.78,9.61-5.87,19.14-9.4,28.5-1.62,4.3-5.16,2.58-8.3,1.24-9.2-3.92-18.33-8.06-27.73-11.45-5.87-2.12-12.14-3.18-18.29-4.42-3.54-.71-7.41-1.04-7.84-5.45-.44-4.53-.55-9.35,5.58-12.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M286,899.32c-.16-3.99,1.94-7.01,7.68-7.88,9.9-1.48,19.85-2.58,29.78-3.87,4.22-.55,6.87,1.25,7.41,5.44,1.41,10.85,2.65,21.72,3.93,32.59.49,4.15-2.18,6.21-5.58,6.75-11.27,1.77-22.59,3.24-33.9,4.7-4.37.56-5.63-2.44-6.02-6-1.07-9.95-2.08-19.92-3.3-31.73ZM311.66,924.14c7.61.14,12.82-4.91,12.77-12.37-.05-7.49-6.81-14.92-13.7-15.06-7.04-.14-14.54,7.36-14.87,14.85-.34,7.73,5.52,12.39,15.8,12.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M798.06,727.89c1.46-2.94,4.59-4.65,8.99-2.44.82.41,2.16.97,2.2,1.54.46,6.08.91,12.17.73,18.25-.02.69-4.06,1.97-6.05,1.68-1.93-.28-4.26-1.86-5.25-3.55-1.07-1.84-.81-4.46-1.18-7.17-.8,3.22-1.65,6.1-2.21,9.04-.87,4.59-3.47,6.89-8.17,6.87-7.91-.03-15.81.11-23.72-.07-5.43-.12-7.12-1.75-7.38-7.1-.25-5.1-.12-10.22-.05-15.33.06-4.51,2.38-6.84,6.98-6.78,7.9.11,15.84-.21,23.69.5,3.52.31,6.86,2.66,11.42,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M859.79,552.06c18.4,5.82,36.77,11.64,55.13,17.45.05.65.09,1.3.14,1.95-2.14,1.05-4.27,2.12-6.42,3.15-8.78,4.21-17.72,8.12-26.3,12.7-12.42,6.61-26.89,4.56-35.52-5.12,4.34-3.91,10.36-7.05,12.49-11.9,2.16-4.92.48-11.53.48-18.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M1610.34,840.73c-7.28,2.57-13.66,5.22-20.28,6.93-2.36.61-5.61-.55-7.94-1.83-14.89-8.17-29.64-16.59-44.41-24.97-.53-.3-.84-.99-1.93-2.34,7.54-2.88,10.17-8.51,8.51-16.07,7.16.95,61.12,31.71,66.04,38.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M573.34,706.24c-2.74.97-3.81,1.73-4.82,1.66-18.4-1.24-35.46,4.32-52.48,10.17-1.98.68-4.04,1.2-5.96,2.01-3.34,1.42-5.81.32-8.02-2.26-5.44-6.36-5.03-9.21,2.26-13.54,10.01-5.95,20.09-11.8,30.12-17.72,5.45-3.22,10.25-2.96,15.29,1.38,5.46,4.71,11.58,8.64,17.37,12.97,1.78,1.33,3.4,2.89,6.24,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M72.41,597.99c-3.26-2.98-5.63-5.65-8.49-7.61-2.51-1.72-3.81-3.23-2.25-6.22,6.37-12.17,12.35-24.55,19.15-36.48,4.36-7.64,20.01-13.26,28.42-11.16,2.86.72,5.05,2.2,2.8,5.4-13.24,18.85-26.58,37.64-39.62,56.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M1643.05,898.64c-2.32.24-3.68.71-4.89.46-14.6-3.05-29.16-6.33-43.78-9.29-7.29-1.48-10.91-5.17-9.76-15.64.43-3.88,2.49-6.27,6.46-5.61,9.71,1.6,18.42-.7,26.75-5.63,4.13-2.45,7.19-.48,9.02,3.48,2.84,6.13,5.34,12.43,8.32,18.49,2.21,4.49,4.96,8.72,7.87,13.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M412.36,912.26c-.86.4-1.69.85-2.57,1.2-12.53,4.9-24.96,10.08-37.64,14.55-6.64,2.34-8.95.19-9.21-6.81-.39-10.43-.83-20.86-1.2-31.3-.21-6.03,1.86-7.65,6.89-4.87,13.41,7.42,26.67,15.12,40,22.68,1.4.8,2.93,1.38,4.4,2.06-.23.83-.45,1.66-.68,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M1374.29,284.47c-.48-2.27-.96-4.55-1.44-6.82-.7-3.31.63-5.93,3.85-6.09,1.38-.07,3.67,2.45,4.22,4.21,3.26,10.4,6.09,20.94,9.15,31.41,1.08,3.7.65,7.05-2.32,9.56-4.78,4.05-9.59,8.12-14.75,11.67-4.53,3.12-5.73,2.35-8.54-2.63-6.16-10.9-12.38-21.77-18.82-32.51-2.04-3.4-2.13-6.05,1.13-8.44,3.68-2.7,6.02-1.52,7.58,3.75,2.38,8.05,9.48,11.25,15.26,6.25,2.68-2.31,3.81-6.42,5.64-9.72-.32-.21-.64-.43-.96-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M412.96,599.44c26.82,3.22,51.92,11.32,76.11,22.73-5.93,13.06-13.28,16.14-24.95,11.5-5.61-2.23-11.32-4.26-17.07-6.1-15.11-4.85-25.19-15.68-34.09-28.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M440.75,697.92c7.43,2.31,12.37-1.29,17.37-5.38,7.08-5.79,10.37-4.91,13.98,3.68,1.32,3.14,1.91,6.66,2.35,10.07.73,5.69.91,11.45,1.62,17.14.8,6.35-6.82,15.51-13.21,15.42-1.06-.01-2.42-.52-3.11-1.28-5.88-6.51-12.27-12.69-17.2-19.87-3.67-5.35-4.13-12.15-1.8-19.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M1293.89,129.67c-.13,1.99-.18,2.92-.25,3.85-.74,9.79-1.35,10.21-9.86,5.79-7.04-3.66-13.07-1.2-18.89,2.8-6.42,4.41-8.78,10.64-7.86,18.2.22,1.83,1.25,3.59,1.32,5.4.05,1.35-.84,2.73-1.32,4.1-1.35-.98-3.07-1.72-3.94-3.02-.66-.98-.33-2.69-.29-4.07.38-16.29.86-32.58,1.15-48.88.12-6.84,1.05-8.12,7.78-6.48,7.65,1.87,15.28,4.14,22.56,7.11,6.9,2.82,10.24,8.56,9.63,15.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M776.56,788.67c1.98,0,3.98-.13,5.95.02,10.45.81,20.9,1.79,31.35,2.51,4.34.3,6.88,2.42,8.02,6.47,1.63,5.83,3.18,11.69,4.89,17.5,1.22,4.13-.35,6.5-4.1,8.32-6.24,3.04-12.26,6.54-18.46,9.68-1.04.53-3.21.74-3.63.18-.82-1.09-1.56-3.43-.96-4.22,6.8-9,.88-14.56-5.13-20.18-4.76-4.46-9.55-8.89-14.27-13.39-1.61-1.53-3.05-3.23-4.57-4.86.31-.68.61-1.36.92-2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M1107.08,665.94c3.16,2.58,6.07,4.8,8.79,7.22,4.98,4.43,10.21,8.08,17.36,7.69,3.59-.2,5.36,2.09,4.6,5.37-2.31,10.01-5.8,19.53-13.18,28.01-2.51-1.79-4.68-3.4-6.9-4.92-4.56-3.13-6.48-2.92-10.23,1.08-.95,1.02-1.67,2.34-2.78,3.1-.83.57-2.6.97-3.12.51-.82-.72-1.62-2.56-1.24-3.36,2.88-6.09-.4-9.66-4.79-13-2.03-1.55-4.18-3.14-5.64-5.17-.89-1.24-1.34-3.93-.6-4.92.99-1.32,3.31-2.08,5.12-2.23,1.46-.12,3.01,1.08,4.55,1.62,4.62,1.6,7.93.37,10.82-3.59,2.75-3.77.69-6.41-1.6-9.28-1.59-1.99-4.56-3.83-1.16-8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M1357.05,543.04c.03,3.46-1.65,5.19-5.17,4.88-1.39-.12-2.76-.46-4.12-.77-14.9-3.36-29.59-2.26-44.12,2.12-1.34.4-2.65.93-4.02,1.19-3.84.73-6.27-1.08-7.55-4.58-1.36-3.72.74-5.78,3.81-7.05,3.87-1.61,7.87-2.88,11.73-4.49,12.46-5.19,24.89-10.43,37.31-15.72,5.24-2.23,7.07-1.95,8.05,2.42,1.63,7.26,2.74,14.64,4.08,22.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M1370.19,493.04q9.35,6.73,19.83-2.4c1.26,6.5,2.44,12.52,3.6,18.54,1.84,9.58,3.76,19.14,5.46,28.74,1.15,6.55-2.66,13.98-8.4,17.02-3.63,1.92-7.88-.26-9.38-5.36-1.44-4.89-2.32-9.95-3.37-14.95-2.67-12.73-5.3-25.46-7.9-38.2-.17-.84.07-1.76.17-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M201.14,354.46c-.67-1.43-1.62-2.75-1.92-4.21-1.61-7.74-3.37-15.47-4.47-23.28-1.36-9.63,6.71-20.11,15.97-21.42,9.25-1.31,19.47,6.89,20.36,16.93.23,2.61-.85,6.48-2.74,7.94-9.06,6.97-17.94,14.01-24.81,23.29-.32.43-1.25.42-2.37.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M1567.09,732.32c-1.59-1.21-4.52-2.55-6.03-4.82-2.14-3.23-3.68-7.04-4.55-10.82-.35-1.51,1.33-4.52,2.86-5.25,11.08-5.32,22.35-10.24,33.58-15.23.82-.36,1.89-.67,2.7-.45,6.45,1.75,7.12,7.94,9.54,12.75,1.77,3.52.62,6.83-2.58,8.37-10.84,5.23-21.88,10.01-32.86,14.95-.41.18-.9.18-2.66.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M283.53,886.03c1.25-1.49,2.34-3.15,3.77-4.43,7.96-7.14,15.96-14.25,24.05-21.25,5.31-4.6,6.19-4.61,12.28-1.12,8.27,4.75,16.52,9.52,24.75,14.33,1.69.99,3.24,2.21,4.85,3.32-.11.62-.21,1.24-.32,1.86-22.75,3.09-45.5,6.19-68.25,9.28-.38-.66-.76-1.32-1.14-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1295.25,977.75c-.49.47-1.17.86-1.43,1.44-9.6,20.97-28.7,23.76-48.43,25.31-.12,0-.26-.3-.65-.77,6.74-1.9,13.41-3.52,19.91-5.65,23.99-7.83,34.49-29.36,24.96-52.76-3.65-8.97-8.99-17.38-14.46-25.44-10.94-16.14-20.22-32.95-25.16-51.97-3.02-11.61-2.72-22.61,4.37-32.8.77-1.11,1.21-2.46,1.8-3.69.72.41,1.44.82,2.16,1.23.12,1.93.5,3.89.32,5.8-3.09,32.86,6.52,62.18,24.8,89.07,5.79,8.51,12.1,16.95,12.71,27.6.44,7.59-.66,15.26-1.07,22.9l.16-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M1522.86,421.24c.67,5.69.44,10.75,1.96,15.23,2.91,8.57,6.67,16.86,10.36,25.14,1.75,3.93,5.81,4.07,9.51,4.85,2.47.53,6.74,2.05,6.72,3.09-.05,4.21-4.06,4.3-7.25,4.68-2.54.3-5.13.18-7.69.36-8.93.62-15.43-3.32-19.46-11.01-4.97-9.5-9.5-19.23-14.24-28.86-1.76-3.57-1.54-6.06,2.93-7.4,5.51-1.65,10.86-3.82,17.15-6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M767.51,780.44c3.44-5.38,6.57-10.11,9.54-14.94,2.89-4.7,7.36-6.29,12.46-6.29,3.94,0,7.89.44,11.81.94,11.92,1.52,18.01,9.39,16.81,21.35-.31,3.08-1.68,4.74-4.84,4.62-4.65-.18-9.29-.39-13.93-.65-7.89-.45-15.78-.94-23.67-1.42-3.51-.21-7.06-.37-8.18-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M546.69,680.17c7.03-4.94,13.55-8.65,21.03-10.34,1.55-.35,3.79.51,5.17,1.54,9.33,6.98,18.53,14.13,27.72,21.3.85.67,1.34,1.81,2.06,2.84-2.33,4.22-6.69,4.12-10.26,5.37-15.13,5.3-11.62,6.04-24.93-3.97-5.03-3.78-10.04-7.59-15-11.47-1.76-1.37-3.32-3-5.8-5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M492.92,322.57c-1.07,2.04-1.85,3.67-2.75,5.23-10.79,18.52-21.67,36.99-32.38,55.56-3.56,6.17-6.87,6.98-12.1,2.66-2.88-2.38-3.04-5.24-1.62-8.16,2.56-5.22,5.12-10.5,8.27-15.37,7.85-12.14,15.95-24.12,24.11-36.05,4.28-6.26,8.29-7.22,16.47-3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M1420.75,542.8c.24,5.8-.95,6.92-6.42,6.13-5.31-.77-9.12-3.32-10.28-8.9-2.69-12.97-5.59-25.91-7.97-38.93-1.27-6.92,8.54-15.57,14.94-13.21,1.7.63,3.14,3.82,3.46,6.02,1.51,10.11,2.56,20.3,3.83,30.45.78,6.23,1.64,12.45,2.44,18.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M1548.1,388.88c-2.24-.72-4.48-1.44-6.72-2.16-13.77-4.43-25.41-11.97-35.95-22.02-16.68-15.9-34.24-30.87-51.35-46.33-2.06-1.86-6.56-3.8-4.08-6.91,3.18-3.99,5.63.99,7.77,2.69,28.84,22.85,57.56,45.86,86.29,68.84,1.7,1.36,3.27,2.89,4.91,4.35-.29.51-.58,1.02-.87,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M1323.3,649.61c-10.14-6.98-13.04-16.49-9.79-27.04,2.87-9.32,4.93-18.91,7.06-28.45,1.29-5.76,3.8-7.38,9.26-5.17,6.02,2.43,9.07,8.29,7.09,16.4-3.24,13.34-7.22,26.51-11.01,39.71-.46,1.61-1.71,3-2.61,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M1357.46,605.87c-2.28,17.24-6.64,34.84-14.42,51.45-2.43,5.2-5.5,6.44-9.33,4.78-4.36-1.89-5.54-5.08-4.01-10.36,4.74-16.32,9.31-32.7,14.27-48.96.8-2.6,2.78-5.7,5.07-6.82,5.03-2.46,8.66,1.67,8.41,9.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M1549.42,462.47c-8.59-.39-11.6-2.51-14.54-10.42-2.19-5.87-4.45-11.72-6.47-17.65-2.13-6.24-.6-10.16,4.69-12.9,5.11-2.65,8.6-1.81,12.54,3.51,5.12,6.9,10.1,13.91,14.97,20.98,2.04,2.95,5,5.86,2.48,10.03-2.48,4.1-6.13,6.2-10.88,6.45-.93.05-1.86,0-2.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M513.67,754.82c-.1,9.27-6.86,14.07-15.42,10.75-4.09-1.59-8.05-3.59-11.91-5.7-4.66-2.54-5.46-4.7-2.24-8.89,3.21-4.19,2.91-7.95.93-12.27-1.35-2.94-2.6-5.97-3.5-9.08-1.11-3.84.87-6.18,4.44-5.69,11.21,1.53,26.91,18.24,27.7,29.49.03.46,0,.93,0,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M836.73,934.28c-3.52,4.79-7.84,5.77-12.61,4.47-24.05-6.54-48.07-13.16-72.05-19.94-2.34-.66-4.53-2.31-6.46-3.9-2.75-2.26-4.31-4.89-1.18-8.27,3.45-3.72,5.55-3.78,9.53-1.08,3.96,2.67,8.14,5.42,12.63,6.84,21.75,6.89,43.65,13.33,65.48,19.96,1.46.44,2.83,1.16,4.65,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M1019.1,978.67c9.18-6.63,18.29-13.37,27.57-19.86,6.1-4.27,13.03-2.7,19.6-1.61,3.69.61,7.14,2.65,10.7,4.04-2.02,3.2-3.66,6.72-6.12,9.53-7.45,8.5-16.81,11.74-28.16,9.9-5.22-.85-10.64-.44-15.97-.56-2.44-.05-4.89,0-7.33,0-.09-.48-.19-.95-.28-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M1202.34,613.94c1.6.3,3.26.42,4.77.96,2.81,1,3.53,2.93,1.7,5.41-1.65,2.25-3.52,4.33-5.2,6.56-8.83,11.69-17.65,23.39-26.42,35.12-4.7,6.29-8.29,6.66-12.84,1.31-2.28-2.68-2.67-5.42-.54-8.23,9.11-12.07,18.04-24.28,27.58-35.99,2.37-2.9,6.8-4.12,10.29-6.12.22.33.44.66.66.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M1161.26,945.26c9.28.63,18.56,1.23,27.83,1.91,6.02.44,8.12,2.75,7.67,8.26-.42,5.12-2.33,6.58-8.68,6.16-14.84-.97-29.68-2.05-44.52-3.08-.46-.03-.93-.04-1.39-.1-6.03-.73-9.51-3.45-9.47-7.39.05-4.19,3.94-6.82,10.45-6.68,6.04.13,12.07.56,18.11.85,0,.02,0,.04,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M1082.33,722.95c-1.62-2.68-2.61-3.93-3.2-5.36-4.37-10.48-11.17-19.24-18.44-27.87-3.58-4.25-5.57-10.01-7.52-15.36-.89-2.45,1.58-3.74,4.01-2.89,1.47.52,2.73,1.75,3.96,2.8,10.06,8.7,20.11,17.4,30.1,26.18,4.9,4.3,5.14,5.25,1.34,10.45-2.93,4.01-6.43,7.6-10.25,12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M42.08,608.91c7.14,7.77,11.68-.85,18.62-2.56-1.88,7.08-4.49,12.41-9.59,16.84-4.13,3.59-8.07,7.68-11.06,12.24-6.64,10.13-12.57,20.72-18.91,31.04-1.36,2.21-3.26,4.08-5.75,5.58,6.38-22.01,11.62-44.35,26.69-63.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M520.76,677.17c-2.88,1.72-5.59,3.34-8.3,4.97-5.38,3.24-10.76,6.49-16.14,9.73-1.4.84-2.75,1.8-4.24,2.41-3.68,1.52-9.21-2.93-13.14-10.21-2.03-3.75-1.54-7.11,2.2-8.9,7.11-3.41,14.38-6.53,21.79-9.22,4.05-1.47,7.76.48,10.71,3.49,2.1,2.15,4.09,4.42,7.13,7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M906.39,954.85c-13.78-6.12-24-3.29-31.68,9.61-.72-1.51-1.25-2.11-1.25-2.71-.04-9.99,0-19.98,0-29.97,0-5.04,3.17-6.67,7.51-7.5,4.29-.82,7.89-1.53,10.49,3.62,3.76,7.45,8.38,14.47,12.6,21.7.64,1.09,1.04,2.31,2.34,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M758.4,830.85c2.95-.35,4.94-.77,6.94-.79,7.44-.07,14.9-.21,22.33.14,2.31.11,4.97,1.15,6.74,2.64,3.45,2.9,6.38,6.42,10.16,10.35-3.04,1.41-6.18,3.11-9.49,4.34-4.57,1.7-9.41,2.72-13.87,4.65-4.57,1.98-7.04.35-8.82-3.66-1.53-3.45-3.07-6.89-5.21-10.11-1.99,6.85,5.25,12.46,1.75,19.44-5.3-8.1-7.46-17.24-10.53-26.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M1462.46,261.03c-8.74.02-10.49-2.73-7.14-8.47,7.14-12.23,14.41-24.38,21.62-36.57,1.95-3.29,4.23-5.63,8.43-3.29,4.22,2.35,5.76,5.62,3.42,9.76-6.5,11.52-13.2,22.93-20.26,34.11-1.51,2.39-4.88,3.61-6.07,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M1163.43,914.45c-4.42-2.81-8.34-5.26-12.21-7.78-2.72-1.77-3.1-4.05-2.25-7.24,1.49-5.58-.54-8.99-5.32-10.14-3.87-.94-6.81,1.27-8.39,6.33-.34,1.11-.46,2.29-.89,3.36-1.33,3.29-3.72,4.86-7.18,3.45-3.43-1.39-2.24-4.05-1.29-6.48,2.98-7.67,8.81-13.02,14.95-18.05.94-.77,2.8-1.25,3.88-.86,4.88,1.77,9.05.33,13.29-1.99,2.69-1.47,5.72-2.86,7.35,1.55,1.67,4.51.56,7.13-3.94,8.2-3.92.93-7.16,2.28-7.29,7-.11,4.11,2.19,6.31,5.85,7.67,2.2.82,5.42,1.68,6.07,3.35,1.45,3.69.66,7.69-2.62,11.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M827.19,911.08c-18.96-4.16-36.47-8.01-53.98-11.85-1.82-.4-3.63-.85-5.46-1.22-10.73-2.14-14.58-8.14-12.27-19.01.9-4.24,4.06-5.99,7.65-7.4,13.02-5.11,26.03-10.23,39.04-15.37,1.95-.77,3.79-1.95,5.8-2.39,1.29-.28,2.81.43,4.22.7-.57,1.57-.76,3.5-1.81,4.62-1.01,1.08-2.88,1.39-4.41,1.95-11.83,4.3-23.68,8.54-35.49,12.89-2.16.8-4.36,1.76-6.17,3.15-3.53,2.7-4.16,6.58-3.31,10.73.77,3.76,3.56,5.11,7.01,5.85,15.96,3.43,31.9,6.98,47.86,10.39,1.54.33,3.28.33,4.8-.03,5.17-1.21,5.72,1.91,6.54,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M1377.88,253.97c8.47-2.6,14.37-.36,18.22,6.09,3.46,5.79,6.84,11.64,10.42,17.36,1.75,2.8,2.84,5.51.27,8.25-3,3.19-2.01,6.23-.31,9.59,1.36,2.69,2.57,5.55,3.17,8.48.56,2.76-1.36,4.19-3.79,2.72-4.36-2.64-8.69-5.48-12.53-8.82-4.43-3.84-5.63-8.58-3.16-14.48,4.01-9.58,1.08-18.38-7.29-24.54-1.65-1.21-3.02-2.8-4.98-4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M117.74,500.17c5.22,1.01,10.5,1.79,15.64,3.13,3.27.85,4.55,3.36,2.42,6.41-4.64,6.65-9.27,13.32-14.28,19.69-2.58,3.28-9.57,3.98-12.75,1.27-1.38-1.18-1.97-3.92-1.97-5.96,0-5.04.66-10.07.84-15.12.23-6.59,3.58-9.81,10.1-9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M1167.78,694.97c24.62,20.05,48.28,39.32,72.32,58.9-4.78,4.43-8.36,2.7-11.75-.02-8.16-6.56-16.25-13.21-24.36-19.84-10.63-8.69-21.24-17.4-31.85-26.11-3.5-2.87-6.52-5.97-4.36-12.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M1027.42,668.68c-5.6-2.57-11.5-4.67-16.72-7.87-4.41-2.7-4.34-5.22-1.11-9.24,1.74-2.17,3.88-4.01,5.66-6.15,5.25-6.36,5.49-6.56,11.99-1.18,3.74,3.09,6.89,6.89,10.51,10.15,6.36,5.74,1.59,11.35-4.25,12.63-1.8.39-3.67.45-5.51.66-.19.33-.38.67-.56,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M1499.99,219.04c-.19,1.76.09,3.76-.65,5.24-2.59,5.15-2.47,10.13-.79,15.56,2.18,7.06-6.14,23.07-13.13,24.97-2.9.79-6.49.1-9.49-.82-2.78-.85-3.73-3.38-2.04-6.23,7.35-12.43,14.69-24.87,22.11-37.26.51-.84,1.67-1.29,2.53-1.93.49.16.97.32,1.46.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M1551.86,867c7.6.43,13.01,6.38,12.57,13.84-.45,7.62-6.95,13.44-14.45,12.93-7.25-.49-12.94-6.8-12.67-14.04.29-7.55,6.71-13.17,14.55-12.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M1537.48,907.41c6.62-.06,13.4,6.76,13.45,13.54.05,6.71-6.55,13.65-13.23,13.89-6.69.24-14.16-7.16-14.03-13.92.12-6.29,7.43-13.46,13.81-13.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1300.81,277.73c.26,7.6-1.84,9.98-10.7,12.75-6.66,2.08-10.51,1.09-13.54-3.5-3.89-5.91-2.57-12.64,3.61-16.19,3.6-2.07,7.55-3.6,11.49-4.98,5.22-1.84,7.34-.52,8.35,4.89.47,2.5.58,5.08.79,7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1440.14,320.27c7.76,7.33,15.77,14.91,23.79,22.47,2.57,2.42,4.29,5.03,2.14,8.57-2.24,3.68-.59,6.66,1.56,9.6,4.95,6.77,9.9,13.53,14.83,20.31.96,1.32,2.39,2.58,2.65,4.04.27,1.52-.18,3.61-1.14,4.75-.52.61-2.97.11-4.19-.55-1.12-.61-1.91-2.01-2.6-3.21-11.95-20.79-23.87-41.59-35.75-62.42-.74-1.29-1.03-2.83-1.29-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1375.06,548.04c-1.21,1.12-2.51,3.26-4.28,3.77-3.38.98-6.78-.07-7.96-3.78-1.63-5.08-2.9-10.31-3.92-15.55-.98-5.02-1.48-10.13-2.14-15.21-.45-3.46.28-6.46,3.48-8.48,3.46-2.18,6.3-1.7,7.12,1.94,2.7,12.03,5.02,24.15,7.7,37.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1195.76,895.12c4.02,6.37,7.94,12.06,11.17,18.12.65,1.22-.86,4.28-2.21,5.71-1.95,2.07-4.26,1.15-5.95-.98-.43-.54-.73-1.2-1.18-1.73-3.72-4.41-7.65-5.59-11.54-3.49-4.09,2.2-4.94,5.53-3.48,11.46.42,1.72.39,4.6-.63,5.4-1.57,1.22-4.5,2.01-6.3,1.38-5.64-1.97-7.03-11.94-2.42-15.83,3.19-2.69,6.77-4.93,9.86-7.73,2.75-2.49,4.99-5.52,7.59-8.2,1.24-1.28,2.77-2.27,5.08-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M313.79,354.14c-1.44-.49-2.95-.83-4.32-1.48-20-9.41-39.95-18.93-59.99-28.27-6.66-3.1-11.2-7.95-14.21-14.75,5.96.3,68.84,35.1,78.51,44.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M790.96,695.53c16.59.85,22.4-8.17,21.4-22.56,9.23-.03,11.66,2.45,9.42,9.68-3.01,9.72-6.62,19.25-10.53,30.47-7.42-5.83-13.67-10.74-19.91-15.64-.12-.65-.25-1.3-.37-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M44.93,478.19c1.44,1.16,3.69,2.84,5.76,4.71.62.56.74,1.67,1.06,2.54,3.66,9.92,2.93,10.91-7.44,12.1-3.38.39-6.78,1.5-9.91,2.87-3.01,1.32-4.86.69-6.27-2.03-.64-1.23-1.22-2.5-1.72-3.79-3.2-8.27-2.9-9.07,5.14-12.53,2.76-1.18,5.62-2.13,8.47-3.07,1.08-.36,2.28-.39,4.9-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M834.53,957.76c3.57,0,7.14-.12,10.7.03,5.35.23,10.7.54,16.04,1.01,6.33.57,8.55,2.52,8.36,8.77-.16,5.62-.27,11.69-6.31,16.07-4.67-4.85-8.77-9.87-13.65-13.97-4.68-3.93-10.17-6.9-15.3-10.29.05-.54.1-1.08.15-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M1420.88,315.23c-1.15,1-2.29,2.47-3.78,3.21-5.2,2.58-10.64,4.7-15.79,7.38-11.55,5.99-22.98,12.21-34.45,18.34-1.23.66-2.34,1.85-3.61,2.04-2.08.3-5.24.83-6.2-.27-2.2-2.53.7-4.1,2.57-5.26,17.42-10.8,35.52-20.26,54.62-27.77,2.51-.98,4.94-1.8,6.65,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1128.46,752.7c-2.7,3.78-4.43,6.77-6.7,9.26-7.53,8.25-12.78,7.82-19.63-1.14-1.82-2.38-2.09-4.61-.31-6.94,2.25-2.93,4.47-5.92,7.02-8.57,2.18-2.27,4.84-5.5,8.26-3.08,4,2.83,7.3,6.65,11.35,10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M894.73,766.88c-6.51-16.22.72-58.54,16.42-70.82-2.12,4.5-4.18,8.57-5.99,12.75-4.96,11.48-5.64,23.37-3.16,35.53.51,2.5,1.07,5,1.52,7.51,1.61,9.11.53,10.92-8.79,15.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M783.91,884.1c6.16-4.02,12.17-8.32,18.54-11.97,4.91-2.81,9.51-.85,12.74,4.51,3.02,5.03,2.34,11.7-1.74,14.5-1.21.83-3.13,1.41-4.5,1.1-8.27-1.87-16.47-4.03-24.69-6.09-.12-.69-.24-1.38-.35-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1195.54,805.38c3.59,3.41,7.6,6.48,10.66,10.31,2.67,3.34-.92,5.9-2.64,8.45-1.03,1.52-2.37,2.84-3.67,4.15-5.75,5.81-7.54,6.13-12.18,2.33-6.49-5.32-7.25-9.03-3.16-15.39,3.47-5.4,7.44-8.89,11-9.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1295.91,749.88c-3.99,3.63-7.47,7.35-11.5,10.31-4.24,3.11-6.09,2.02-8.3-2.8-1.41-3.06-3.43-5.95-5.64-8.51-3.14-3.63-3.88-8.19-.82-11.88.95-1.14,3.4-2.11,4.71-1.7,8.26,2.56,15.88,6.28,21.56,14.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1369.35,285.87c-.37,1.28-.46,3.37-1.5,4.72-.97,1.26-2.96,2.35-4.49,2.34-1.1,0-3.02-1.84-3.15-3.03-1.39-12.31-7.68-22.88-11.69-34.26-.51-1.46-.42-4.4.34-4.78,1.59-.8,3.85-.62,5.76-.32.96.15,2,1.29,2.57,2.24,6.02,10.08,10.5,20.75,12.17,33.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1469.38,354.61c7.66.65,32.41,21.13,37.23,28.76-8.93,5.09-14.11,4.36-19.89-3.22-5.09-6.68-9.93-13.54-14.77-20.4-1.09-1.55-1.73-3.42-2.58-5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M552.77,659.59c-6.28,3.24-12.43,6.8-18.93,9.51-1.88.78-5-.43-7.16-1.52-3.25-1.64-6.16-3.96-10.56-6.89,8.54-5.02,16.21-9.9,25.34-9.81,3.77.04,7.5,3.81,11.24,5.89.02.94.05,1.88.07,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1108.8,944.3c.12-9.34,8.99-19.72,18.23-21.33,5.76-1,8.53,2.07,6.54,7.6-.67,1.86-2.21,3.47-3.54,5.03-3,3.53-6.04,7.03-9.23,10.38-1.39,1.46-3,3.03-4.83,3.68-4.47,1.61-7.22-.62-7.16-5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M1602.63,860.56c-11.24-1.04-19.56-1.77-27.87-2.6-1.36-.14-2.95-.31-3.95-1.09-1.12-.87-1.68-2.46-2.49-3.73,1.32-.62,2.94-2.07,3.92-1.72,12.87,4.58,24.68.49,36.5-4.04,1.93-.74,4.28-1.76,6.02-1.25,2.08.61,4.29,2.43,5.31,4.33.5.94-1.15,4.19-2.52,4.77-5.68,2.41-11.63,4.19-14.92,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1159.82,679.15c34.1,25.02,66.98,51.56,98.37,79.95-.4.5-.81,1.01-1.21,1.51-32.84-26.56-65.68-53.13-98.52-79.69.46-.59.91-1.18,1.37-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M524.02,641.29c-6.52,4.84-13.61,8.22-21.33,9.55-2.67.46-6.22-1.58-8.66-3.42-1.16-.88-1.63-4.54-.78-5.93,6.62-10.8,20.77-12.17,29.21-3.08.58.63.85,1.55,1.56,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M408.28,627.11c1.19.88,2.61,1.57,3.53,2.68,9.62,11.62,19.2,23.28,28.69,35,1.44,1.78,3.03,3.8,3.45,5.93.32,1.64-.6,4.32-1.88,5.22-1.01.7-3.77-.17-5.13-1.18-1.6-1.18-2.58-3.23-3.73-4.97-7.81-11.81-15.62-23.61-23.34-35.49-1.25-1.92-2-4.15-2.98-6.24.46-.32.92-.64,1.38-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1696.96,917.41c0,9.97-8.24,17.96-18.43,17.87-9.91-.09-17.99-7.89-18.14-17.51-.14-9.86,8.96-19.31,18.46-19.16,9.29.15,18.1,9.3,18.11,18.79ZM1679.28,902.79c-8.14-.07-14.93,6.35-15.17,14.34-.24,7.85,6.68,14.75,14.7,14.66,7.73-.09,14.43-6.7,14.45-14.26.01-7.66-6.64-14.67-13.97-14.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M1295.28,842.22c3.6,24.62,8,48.96,16.72,72.32-14.18-15.34-22.94-50.61-16.72-72.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1443.01,474.44c1.14,1.46,2.59,2.78,3.38,4.42,4.13,8.56,7.99,17.26,12.17,25.79,1.82,3.71,1.05,6.12-2.5,7.98-3.51,1.83-5.61.15-7.55-2.6-5.01-7.15-8.79-25.67-5.51-35.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1111.86,793.27c-3.35.27-5.81.36-8.24.68-5.73.75-11.43,1.74-17.18,2.33-1.86.19-3.81-.57-5.72-.9.49-1.86.95-3.73,1.48-5.58.12-.42.51-.77.77-1.15,10.17-14.6,20.43-13.39,28.89,4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1311.14,705.2c-1.06,2.16-1.53,3.7-2.45,4.89-5.4,6.95-10.8,13.9-16.41,20.68-4.44,5.37-7,5.18-12.54-.78,6.03-7.45,11.96-15.09,18.25-22.43,3.18-3.71,7.58-3.82,13.15-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1480.06,797.55c-4.33-8.69-3.68-16.81-3.44-24.8.04-1.25,1.56-2.87,2.82-3.61,3.42-2,13.33.58,15.29,4.01.68,1.19.97,3.46.29,4.43-4.62,6.53-9.56,12.84-14.95,19.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M84.64,517.75c-1.92,1.4-3.72,3.02-5.78,4.16-6.74,3.73-14.04,5.23-21.58,3.6-2.73-.59-5.61-2.35-7.5-4.41-2.24-2.44-.78-6.27,2.33-6.34,10.58-.23,21.17.04,31.76.13.26.95.52,1.91.77,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1061.67,642.07c3.2,1.39,6.97,2.12,9.51,4.29,11.11,9.49,21.91,19.33,32.65,29.23,1.23,1.13,2.41,4.27,1.79,5.1-1.97,2.62-4.05.5-5.78-1.03-12.64-11.27-25.28-22.56-37.87-33.89-.59-.53-.75-1.51-1.12-2.29.27-.47.54-.95.82-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1164.83,964.23c-2.6,14.78-21.44,24.62-37.81,21.57-17.61-3.28-32.34-18.81-29.61-32.31,5.05,14.79,14.16,25.07,29.9,28.06,15.74,2.99,27.35-3.98,37.53-17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1256.94,747.58c-29.76-24.04-59.52-48.08-89.28-72.12.38-.47.77-.95,1.15-1.42,30.8,22.78,60.64,46.77,89.46,72.01-.44.51-.89,1.02-1.33,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1592.79,690.05c-.51.71-1.05,2.3-2.1,2.79-10.53,4.86-21.11,9.64-31.8,14.12-1.12.47-4.04-.74-4.39-1.77-.43-1.25.8-3.23,1.64-4.71.39-.69,1.53-.99,2.37-1.38,8.86-4.08,17.7-8.21,26.61-12.19,4.17-1.86,7.56-.61,7.68,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M532.31,347.74c4.24,4.5,5.37,10,3.78,14.91-3.06,9.44-7.21,18.55-11.35,27.59-.59,1.3-4.07,2.44-5.57,1.89-2.78-1.01-2.11-3.64-.75-5.86,6.95-11.24,11.49-23.31,12.59-36.57.05-.55.67-1.05,1.3-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M339.66,919.33c-.03-7.15,3.22-10.14,10.94-10.07,6.25.06,8.67,1.82,8.77,6.36.17,7.55-4.35,12.33-11.79,12.47-5.7.1-7.89-2.31-7.92-8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1161.47,1028.29c0,3.48.18,6.96-.05,10.42-.22,3.24-2.28,5.18-5.52,5.05-3.26-.14-5.01-2.29-5.05-5.53-.07-6.49-.1-12.98.01-19.47.06-3.58,2.12-5.68,5.68-5.68,3.4,0,4.91,2.33,5.04,5.48.14,3.24.03,6.49.03,9.74-.05,0-.1,0-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1147.3,966.52c-2.04,1.83-2.99,3.23-4.31,3.76-7.89,3.18-19.42,3.23-26.9-5.21-3.11-3.51-2.37-6.57,2.18-6.53,5.67.04,11.43,1.2,16.95,2.62,3.89,1,7.45,3.25,12.08,5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M1509.03,404.13c3.48,0,6.97-.08,10.45.02,4.68.14,6.32,2.47,4.81,6.79-1.27,3.63-3.92,6.44-7.75,5.75-7-1.27-13.91-3.21-20.69-5.38-1.46-.47-2.24-3.06-3.34-4.67,1.79-.78,3.53-2.05,5.38-2.23,3.68-.35,7.43-.1,11.14-.1v-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M1585.36,789.74c.33,5.65-8.6,11.98-12.97,10.9-3.13-.78-8.47-7.57-7.13-10.92,1.59-3.98,5.22-7.15,8.02-10.63.18-.22,1.06-.21,1.3.02,3.91,3.8,7.77,7.64,10.78,10.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M809.31,864.27c7.62,1.49,13.82,5.2,17.08,12.88,3.01,7.07.78,13.2-4.11,18.61-3.07,3.39-6.79,4.73-11.33,3.49-8.26-2.25-16.53-4.45-24.59-7.96,4.68,1.02,9.36,2.06,14.05,3.05,2.73.58,5.45,1.32,8.21,1.56,7.11.62,10.26-1.9,11.69-8.97,1.53-7.61-1.11-13.75-7.69-17.92-1.48-.94-2.92-1.92-4.38-2.89.36-.62.71-1.23,1.07-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1428.74,306.85c-1.7-4.66-2.82-7.92-4.07-11.12-1.46-3.74.26-6.48,3.6-6.79,4.75-.43,9.86-.38,14.38.94,4.68,1.37,4.87,6.21,4.92,11.79-6.99-2.21-12.73.52-18.82,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1091.31,761.41c-6.32-7.49-8.64-26.23-4.99-31.71,4.22,4.32,8.56,8.55,12.58,13.05.86.96,1.24,3.29.68,4.4-2.36,4.62-5.17,9.01-8.27,14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1184.41,876.77c-4.38,4.62-7.93,8.37-11.79,12.44-.32-.34-1.25-.86-1.38-1.54-1.23-6.16-2.44-12.33-3.39-18.54-.27-1.75-.08-3.81.62-5.42,1.63-3.76,5.22-4.19,7.49-.82,3.1,4.59,5.79,9.47,8.45,13.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1295.1,978c1.67-4.65,3.35-9.3,5.3-14.72,8.94,21.59-11.19,43.41-39.5,43.65,4.75-1.54,9.59-2.82,14.22-4.67,11.14-4.44,18.68-12.02,20.14-24.5l-.16.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1588.31,499.59c-.24,5.5-1.66,7.47-5.98,7.85-4.89.44-7.83-1.86-8.62-6.86-.32-2.05-.18-4.18-.6-6.21-.73-3.49-.8-6.53,3.4-7.77,4.08-1.21,8.35.39,9.89,4.27,1.08,2.73,1.31,5.8,1.91,8.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M850.42,590.02c3.65,2.79,8.27,4.94,10.62,8.57,1.69,2.61-7.69,11.77-11.22,11.71-4.01-.08-8.17-4.17-8.24-8.11-.07-4.1,4.96-11.06,8.84-12.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1570.67,458.42c2.67,5.69,5.01,10.16,6.76,14.85.33.87-1.58,3.67-2.62,3.77-5.55.51-11.16.67-16.74.5-3.09-.09-4.35-2.55-2.27-4.81,4.35-4.72,9.22-8.95,14.86-14.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M1578.66,753.17c.66.69,2.06,1.62,2.69,2.92,2.63,5.44,5.24,10.9,7.38,16.54.58,1.53.02,4.8-1.01,5.31-1.64.82-5.26.81-6-.26-3.49-5.07-6.88-10.38-9.13-16.07-1.44-3.66,2.36-8.51,6.07-8.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1266.63,559.55c-1.37-1.37-4.14-2.92-4.56-4.95-.3-1.47,2.15-4.35,4.03-5.25,4.13-2,8.62-3.3,13.05-4.59,4.42-1.28,7.3.44,8.46,4.68,1.14,4.15-1.89,5.39-4.78,6.23-4.87,1.4-9.87,2.39-16.2,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M757.99,925.44c11.26,2.83,22.53,5.61,33.78,8.5,6,1.54,11.96,3.26,17.94,4.89,0,.48-.01.97-.02,1.45-1.61.34-3.22.96-4.84.96-13.01.06-25.52-2.08-36.76-9.12-3.41-2.13-6.64-4.54-9.96-6.83l-.15.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345.08,901.01c-4.46-.48-6.88-2.45-7.36-6.62-.51-4.41,1.96-7.94,6.11-8.6,2.05-.32,4.18-.12,6.24-.38,2.79-.35,5.86-1.24,7.01,2.4,1.11,3.53.73,7.31-2.53,9.42-2.8,1.81-6.29,2.56-9.48,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1343.36,591.64c-5.62-.57-8.35-3.2-7.91-8.01.51-5.66,3.95-8.46,9.34-7.57,2.06.34,4.34.34,6.1,1.28,2.03,1.08,4.98,2.95,5.06,4.59.1,2.25-1.58,5.4-3.49,6.71-2.53,1.73-6.02,2.06-9.1,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1334.67,669.43c-6.27,22.92-12.52,45.85-18.87,68.75-.23.84-1.48,1.4-2.25,2.1-.52-.24-1.03-.47-1.55-.71,6.33-22.86,12.65-45.72,19.05-68.56.24-.87,1.3-1.52,1.98-2.28.55.23,1.1.47,1.65.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1356.07,231.96c3.13-7.17,5.87-13.4,8.57-19.63,1.26-2.91,3.12-3.16,5.42-1.22,3.1,2.62,4.46,9.29,2.8,13.53-2.08,5.32-8.14,10.08-12.6,9.42-1.79-.27-3.42-1.68-4.2-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1074.79,973.5c2.65-5.93,7.37-9.18,12.44-11.75,1.3-.66,4.52.2,5.38,1.42,2.07,2.9,3.5,6.34,4.63,9.75.29.88-1.51,3.56-2.26,3.53-6.65-.29-13.79,1.99-20.2-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1121.46,913.34c7.68-8.57,26.31-5.47,35.1,1.91,9.45,7.93,15.56,18.92,12.2,25.93-4.09-10.52-9.15-19.27-18.24-24.68-9.14-5.43-18.81-5.94-29.05-3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M1561.17,858.53c-8.55-4.39-16.43-8.2-24.01-12.55-1.35-.77-2.31-4.02-1.87-5.71.73-2.76,3.18-2.65,5.65-1.35,5.32,2.81,10.87,5.21,16.08,8.21,3.68,2.12,6.51,5.15,4.14,11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M922.17,562.74c1.84-1.25,3.54-2.76,5.52-3.68,6.77-3.14,13.63-6.08,20.46-9.07,2.15-.94,4.52-2.25,5.98.82,1.41,2.98-.14,4.87-2.88,6.03-7.3,3.08-14.6,6.18-21.91,9.22-3,1.24-5.4.67-7.16-3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M280.67,912.29c0,2.53.63,5.29-.2,7.5-.66,1.75-2.96,3.46-4.85,3.91-.89.21-3.49-2.5-3.6-4.01-.45-6.17-.53-12.4-.12-18.57.12-1.87,2.26-3.61,3.47-5.42,1.33,1.64,3.33,3.09,3.85,4.96,1.05,3.74,1.29,7.7,1.86,11.57-.14.02-.28.04-.42.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M1617.76,734.39c1.52,2.76,2.8,4.83,3.83,7.02,3.06,6.48,6.16,12.95,8.91,19.56.55,1.33-.32,3.25-.54,4.91-1.64-.22-4.09.17-4.8-.76-5.82-7.66-9.41-16.36-10.92-25.87-.13-.81.36-1.8.79-2.58.3-.54,1-.87,2.72-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1010.29,639.85c-4.89,9.68-8.88,11.49-18.26,9.87-3.78-.65-7.81-.05-11.7.24-2.24.16-4.44.82-7.22,1.37,4.05-5.91,24.09-11.92,37.18-11.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1320.82,265.01c3.62-5.28,6.58-6.06,11.41-1.35,3.27,3.19,5.86,7.13,8.47,10.93,1.81,2.64,1.37,5.32-1.34,7.31-3.06,2.25-4.6-.24-6.23-2.16-3.94-4.65-7.82-9.34-12.31-14.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1377.06,582.79c-4.11-.7-6.28-2.07-5.47-5.32,1.4-5.63,2.98-11.24,4.84-16.74,1.34-3.97,4.57-3.21,7.58-2.18,3.6,1.23,2.59,3.54,1.59,6.16-1.66,4.33-2.72,8.9-4.53,13.16-.88,2.05-2.9,3.62-4.01,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M807.58,662.02c2.53-4.87,4.98-8.49,8.63-7.18,4.58,1.65,8.68,4.91,12.54,8.04.78.64.14,4.33-.98,5.62-1.05,1.21-4.02,2.01-5.44,1.39-4.96-2.18-9.62-5.06-14.74-7.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M256.48,313.71c21.71,6.64,56.95,26.77,63.96,36.06-21.32-12.02-42.64-24.04-63.96-36.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M1581.29,900.38c-.74,3.85-1.13,7.82-2.37,11.51-.53,1.57-2.91,3.57-4.32,3.48-1.42-.09-3.67-2.42-3.85-3.97-.54-4.55-.37-9.21-.2-13.81.13-3.37,1.65-5.99,5.55-5.53,3.46.41,5.32,2.56,5.09,6.21-.04.69-.09,1.38-.14,2.08.08.02.16.03.24.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1552.81,294.82c.14,8.18-1.88,9.51-7.05,6.31-16.06-9.95-31.97-20.14-48.02-30.09-4.07-2.53-4.65-5.32-2.15-9.27,2.36-3.72,3.6-9.15,6.91-11,3.15-1.76,8.34.36,12.64.4,8.53.07,14.42,4,18.8,11.23,4.7,7.77,10.25,15.02,14.97,22.78,2.13,3.49,3.14,7.66,3.91,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1533.52,245.21c1.1.97,2.13,1.59,2.75,2.49,11.4,16.76,22.78,33.52,34.04,50.37,1.39,2.08,2.42,4.6,2.89,7.06.58,3.05-2.93,8.54-5.27,9.11-3.13.76-8.55-2.7-9.85-6.47-.44-1.29-.6-2.76-.52-4.12.7-11.32-3.56-21.02-9.86-29.97-5.24-7.43-10.84-14.61-16.11-22.02-.79-1.11-.97-2.95-.76-4.35.12-.77,1.63-1.33,2.68-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1523.13,240.96c-.8,1.37-1.75,5.11-3.53,5.56-3.02.77-7.13.43-9.79-1.14-9.2-5.43-10.31-17.16-3.05-24.93,2.32-2.49,4.4-1.95,6.66-.21,6.34,4.89,8.56,11.8,9.71,20.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1549.07,257.34c-13.21-15.72-26.41-31.43-40.44-48.12,9.61,3.44,35.15,33.44,40.44,48.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1355.32,331.83c-1.99-1.55-2.89-1.95-3.33-2.65-5.62-9.08-11.18-18.19-16.75-27.3-.61-.99-1.55-1.9-1.77-2.97-.2-.95.03-2.51.68-2.98.69-.51,2.12-.22,3.16.02.59.14,1.11.82,1.55,1.36,6.63,8.16,13.07,16.48,16.38,26.65.65,2.01.09,4.41.09,7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1274.82,168.67c-4.11-.11-6.8-2.8-6.5-6.5.4-5.02,6.39-9.47,12.28-9.07,3.49.23,5.68,2,5.86,5.61.23,4.6-6.29,10.1-11.64,9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M772.2,907.64c19.8,2.94,37.84,7.24,55.36,16.66-5.58,1.07-49.3-12.12-55.36-16.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M141.83,1023.54c-14.72-16.46-21.93-36.5-26.96-58.4,9.21,19.94,18.08,39.17,26.96,58.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M79.18,507.24c-9.21,0-18.42.07-27.62-.12-.86-.02-2.56-2.2-2.37-2.54.82-1.48,2.13-3.66,3.4-3.75,5.3-.38,10.73-.69,15.94.12,3.91.61,7.54,2.96,11.3,4.54-.21.58-.43,1.16-.64,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1246.87,155.6c-3.21-12.82-3.83-25.5.81-38.03,3.94,12.76,1.46,25.44-.81,38.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M751.69,714.44h43.67c.19.63.38,1.26.57,1.89-1.75.75-3.45,2-5.25,2.16-19.12,1.7-35.29.39-39-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M758.14,925.3c-8.7-2.21-17.43-4.28-26.05-6.76-1.52-.44-2.67-2.47-3.78-3.93-2.01-2.63-1.06-4.85,1.44-6.46,2.81-1.8,5.73-1.44,7.16,1.55,4.31,9.04,12.35,12.79,21.08,15.74l.15-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M397.51,1098.66c-8.78,7.12-28.58,13.31-38.13,12.52,12.8-4.2,25.47-8.36,38.13-12.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1744.08,723.07c-14.84-4.23-29.67-8.46-44.51-12.7,15.8.96,30.48,6.12,44.51,12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M1462.68,948.52c-.92-14.65-1.85-29.3-2.77-43.95.53-.03,1.06-.07,1.59-.1.97,14.6,1.94,29.2,2.91,43.8-.58.09-1.15.17-1.73.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M307.61,1115.62c-14.65,1.08-28.49-1.06-42.06-5.8,6.76,1.12,13.49,2.4,20.28,3.33,7.09.98,14.23,1.63,21.79,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1044.95,1008.52h39.79c0,.1,0,.19,0,.29h-39.87c.02-.1.05-.19.07-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1242.01,480.88c-.41,5.3-5.17,9.08-10.73,8.52-5.21-.52-8.35-4.21-8.08-9.45.29-5.41,4.14-8.72,9.84-8.43,5.67.28,9.37,4.15,8.97,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1156.9,418.27c-.15,5.1-3.9,8.72-8.9,8.61-5.49-.12-9.16-3.83-9.15-9.22.02-5.7,3.61-9.23,9.12-8.96,5.18.26,9.08,4.43,8.93,9.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M966.42,709.51c.87,2.08,1.59,3.62,2.17,5.2.8,2.18,1.22,4.54,2.29,6.57,2.72,5.17,8.01,6.74,12.26,3.89,4.53-3.03,5.62-9.03,2.37-13.52-.95-1.31-2.18-2.43-3.33-3.58-7.08-7.08-9.67-15.82-9.09-25.55.62-10.46,8.81-19.6,19.11-21.32,2.39-.4,5.48-.4,7.39.79,8.35,5.22,13.83,12.66,13.85,22.88.01,10.15-5.14,17.08-14.59,20.95-6.79,2.78-6.73,2.92-5.87,10.19,1.04,8.8-2.74,14.67-10.51,16.32-8.03,1.7-13.91-1.77-16.79-9.93-2.34-6.62-2.31-8.19.75-12.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1029.96,793.91c-1.21-3.81-2.02-6.14-2.69-8.51-1.21-4.25-3.04-7.9-8.07-8.47-4.23-.48-7.26,1.49-9.14,5.09-2.35,4.51-.13,7.96,2.9,11.26,2.08,2.26,3.82,4.82,6.48,8.23-9.51-2.1-15.62-8.81-16.28-16.43-.52-6.1,2.84-11.03,9.5-13.91,5.7-2.47,10.79-1.26,15.07,3.58,4.6,5.21,6.01,12.82,2.22,19.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1048.82,744.97c-2.15-.47-4.36-.75-6.43-1.43-4.81-1.6-8.72-.42-11.81,3.49-2.29,2.9-2.36,5.95-.32,9.06,2.55,3.89,6.42,5.09,11.71,3.76,2.43-.61,6.02-3.62,7.03.29,1,3.85-3.7,4.01-6.39,4.77-8.41,2.36-14.22.57-18.03-5.17-3.51-5.3-3.33-11.62.48-17.05,5.29-7.53,19.07-7.06,23.76,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M948.3,758.15c2.63.59,5.24,1.25,7.89,1.75,6.53,1.23,10.31-1.5,11.21-7.99.68-4.93-1.21-7.51-6.32-7.87-4.25-.3-8.53-.06-13.27-.06,3.98-6.03,9.67-7.94,16.61-6.17,5.93,1.51,9.61,6.11,10.12,12.67.5,6.36-3.37,12.14-9.75,14.53-5.81,2.18-12.28.06-16.5-6.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1018.74,702.8c-2.5,2.93-5.11,5.77-7.45,8.83-1.95,2.56-4.77,5.73-1.95,8.67,2.55,2.66,6.24,4.83,9.8,5.74,3.72.95,5.54-2.76,6.93-5.73,1.26-2.68,2.18-5.51,3.4-8.66,3.26,4.78,2.51,10.84-1.47,15.97-3.79,4.88-9.07,6.4-14.96,4.29-6.34-2.26-10.1-7.14-9.93-12.88.24-8.41,5.62-14.77,15.63-16.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M966.71,793.27c-3.47-10.73.9-20.41,8.8-22.51,7.22-1.92,16.26,3.46,17.99,10.7,1.9,7.96-4.73,16.74-14.34,18.21.71-1.44,1.07-2.69,1.83-3.6,1.33-1.6,3.09-2.85,4.34-4.49,3.57-4.67,2.76-10.26-1.76-13.41-4.3-3-9.92-1.29-12.82,4.06-.88,1.61-1.29,3.47-1.92,5.22-.52,1.44-1.05,2.89-2.11,5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M315.83,980.81c-23.33,8.11-76.77-23.69-73.96-66.77,3.82,18.18,10.88,34.61,24.72,47.54,13.86,12.95,30.95,17.47,49.24,19.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M242.23,894.42c1.45-11.6,5.48-21.26,13.38-29.27-4.32,9.44-8.63,18.88-13.38,29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M617.34,910.94c5.04.03,8.27,4.77,7.13,10.46-1.07,5.32-7.44,11.65-12.72,12.81-3.65.8-5.82-.97-7.19-4-3.47-7.67,4.3-19.33,12.78-19.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M664.53,950.1c-4.45-.15-7.41-3.26-6.77-7.78.78-5.53,3.59-9.97,8.65-12.65,4.07-2.15,7.62-.81,9.66,3.43,3.58,7.44-3.1,17.27-11.54,16.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M568.36,1031.42c-.87-2.05-1.6-3.05-1.7-4.1-1.06-12.13-5.83-22.81-12.43-32.83-1.39-2.11-2.63-4.41-3.44-6.79-.34-1.01.25-3.01,1.08-3.56.78-.52,2.86-.19,3.65.54,10.48,9.73,18.49,20.9,19,35.86.14,4.18-1.1,8.1-6.15,10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1085.19,844.35c.13-10.51,10-19.97,20.5-19.67,10.33.3,19.44,9.68,19.43,20.01,0,10.45-9.83,20.34-20.08,20.2-10.21-.14-19.98-10.25-19.86-20.54ZM1104.97,830.22c-7.97.11-14.5,7.02-14.25,15.08.24,7.61,6.93,13.97,14.71,13.98,7.56,0,14.18-6.68,14.25-14.4.07-7.96-6.76-14.76-14.71-14.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1035.91,551.46c6.18-.14,10.61,3.88,10.56,9.6-.05,5.25-4.64,9.76-9.89,9.72-5.79-.04-10.04-4.4-10.05-10.29,0-5.42,3.61-8.9,9.38-9.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1108.25,532.72c-.13,6.01-3.7,9.46-9.67,9.37-6.16-.1-9.98-4.02-9.85-10.12.13-5.79,3.74-8.91,10.15-8.77,6.27.14,9.51,3.43,9.37,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1410.88,617.52c-.55,2.31-1.25,5.73-2.2,9.08-5.04,17.91-10.14,35.8-15.22,53.7-.38,1.34-.61,2.75-1.16,4.02-1.89,4.34-4.01,8.65-9.46,9.2-5.8.58-10.95-1.75-13.87-6.41-1.69-2.69-1.85-7.22-1-10.48,4.51-17.32,9.56-34.51,14.43-51.74,1.2-4.25,2.32-8.53,3.7-12.73,2.3-7.02,6.32-9.47,13.18-8.3,7.48,1.28,11.66,5.79,11.61,13.66ZM1371.44,681.79c1.13,1.37,2.51,4.16,4.76,5.53,5.2,3.17,9.85.69,11.93-6.24,3.34-11.17,6.4-22.42,9.55-33.64,2.52-8.98,5.19-17.93,7.42-26.98,1.45-5.88-.8-9.81-5.57-11.08-5.15-1.38-8.36.55-10.15,6.77-5.74,19.94-11.32,39.93-16.93,59.9-.38,1.34-.5,2.75-1.02,5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1406.35,574.88c6.14-.13,11.73,5.36,11.69,11.49-.04,5.86-5.21,11.46-10.81,11.72-6.56.29-11.83-4.98-11.91-11.9-.06-5.89,5.1-11.18,11.03-11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1371.68,698.91c5.93.06,11.17,5.32,11.23,11.26.06,5.97-5.6,11.75-11.59,11.85-5.92.1-11.24-5.73-11.04-12.1.19-6.01,5.44-11.08,11.41-11.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1376.31,740.07c-.45,8.51-5.06,13.67-12.03,13.42-8.34-.3-14.94-6.09-14.65-12.87.37-8.61,5.95-14.67,13.1-14.24,8.55.51,13.98,5.99,13.58,13.69ZM1371.62,738.37c-.11-4.44-3.9-7.26-9.44-7.03-4.5.19-7.59,4.08-7.39,9.32.18,4.75,4.43,8.29,9.65,8.04,4.42-.21,7.33-4.4,7.19-10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M311.66,924.14c-10.28-.19-16.13-4.85-15.8-12.58.32-7.49,7.83-14.99,14.87-14.85,6.89.14,13.65,7.56,13.7,15.06.05,7.46-5.16,12.51-12.77,12.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1679.28,902.79c7.33.06,13.99,7.08,13.97,14.73-.01,7.56-6.72,14.17-14.45,14.26-8.02.09-14.94-6.81-14.7-14.66.24-7.99,7.03-14.41,15.17-14.34ZM1686.33,917.43c-.03-4.82-3.63-8.39-8.44-8.37-4.74.02-8.56,3.8-8.49,8.39.07,4.83,4.16,8.43,9.38,8.26,4.52-.14,7.58-3.5,7.55-8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1104.97,830.22c7.96-.11,14.79,6.69,14.71,14.65-.07,7.72-6.69,14.41-14.25,14.4-7.78,0-14.47-6.37-14.71-13.98-.25-8.06,6.28-14.97,14.25-15.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1371.44,681.79c.52-2.98.64-4.39,1.02-5.73,5.61-19.98,11.19-39.96,16.93-59.9,1.79-6.22,5-8.15,10.15-6.77,4.77,1.28,7.02,5.2,5.57,11.08-2.23,9.05-4.9,18-7.42,26.98-3.15,11.22-6.21,22.48-9.55,33.64-2.08,6.94-6.73,9.42-11.93,6.24-2.25-1.37-3.63-4.16-4.76-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1371.62,738.37c.14,5.93-2.77,10.12-7.19,10.33-5.21.25-9.46-3.29-9.65-8.04-.2-5.24,2.89-9.13,7.39-9.32,5.55-.23,9.34,2.59,9.44,7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1686.33,917.43c.03,4.78-3.02,8.14-7.55,8.29-5.22.17-9.3-3.43-9.38-8.26-.07-4.59,3.75-8.37,8.49-8.39,4.8-.02,8.4,3.55,8.44,8.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycle);
export default __webpack_public_path__ + "static/media/Motorcycle.b0c7c913dfdc2ea7aafa6489a8b5da45.svg";
export { ForwardRef as ReactComponent };